var stores = [
  {
      "name": "SuperBioMarkt",
      "address": "Alexanderstraße 94-98, 26121 Oldenburg",
      "latitude": 53.15465,
      "longitude": 8.210709999999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Teutoburger Str. 65, 33607 Bielefeld",
      "latitude": 52.016686,
      "longitude": 8.5425451,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Babenhauser Str. 13, 33613 Bielefeld",
      "latitude": 52.05833,
      "longitude": 8.51623,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Friedrichstraße 73, 40217 Düsseldorf",
      "latitude": 51.2145765,
      "longitude": 6.776326399999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Aachener Straße 57, 40223 Düsseldorf",
      "latitude": 51.2044909,
      "longitude": 6.7729895,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Nordstraße 82-84, 40477 Düsseldorf",
      "latitude": 51.2392095,
      "longitude": 6.780214,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Theo-Champion-Str. 9a, 40549 Düsseldorf",
      "latitude": 51.2324805,
      "longitude": 6.7446218,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Hauptstraße 47, 40597 Düsseldorf",
      "latitude": 51.16525919999999,
      "longitude": 6.8739713,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Benderstraße 43, 40625 Düsseldorf",
      "latitude": 51.2373584,
      "longitude": 6.855565599999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Lüpertzender Straße 112, 41061 Mönchengladbach",
      "latitude": 51.1924273,
      "longitude": 6.4413896,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Löhstraße 21, 41747 Viersen",
      "latitude": 51.2572211,
      "longitude": 6.3850022,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Friedrich-Ebert-Str. 42, 42103 Wuppertal",
      "latitude": 51.2554932,
      "longitude": 7.1376928,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Kampstraße 102, 44137 Dortmund",
      "latitude": 51.5143104,
      "longitude": 7.457796999999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Westfalendamm 285, 44141 Dortmund",
      "latitude": 51.5035234,
      "longitude": 7.5124676,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Harkortstraße 18, 44225 Dortmund",
      "latitude": 51.47551869999999,
      "longitude": 7.4433685,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Brackeler Hellweg 123, 44309 Dortmund",
      "latitude": 51.5233907,
      "longitude": 7.5452888,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Rüttenscheider Straße 76, 45130 Essen",
      "latitude": 51.4364514,
      "longitude": 7.0049398,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Horster Straße 42, 45897 Gelsenkirchen",
      "latitude": 51.57614599999999,
      "longitude": 7.049203899999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Rüschhausweg 8, 46161 Münster",
      "latitude": 51.96781259999999,
      "longitude": 7.5783279,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Ludgeristraße 100, 48143 Münster",
      "latitude": 51.9603127,
      "longitude": 7.6269589,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Ludgeristraße 100, 48143 Münster",
      "latitude": 51.9603127,
      "longitude": 7.6269589,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Warendorfer Straße 97-101, 48145 Münster",
      "latitude": 51.9642273,
      "longitude": 7.6476478,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Grevener Straße 61a, 48149 Münster",
      "latitude": 51.9716906,
      "longitude": 7.611960799999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Hammer Straße 126, 48153 Münster",
      "latitude": 51.94509009999999,
      "longitude": 7.6225927,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Marktallee 48, 48165 Münster",
      "latitude": 51.9039471,
      "longitude": 7.645086,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Otto-Bergmeyer-Str. 5, 48431 Rheine",
      "latitude": 52.2753124,
      "longitude": 7.4368205,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Lengericher Landstr. 34a, 49078 Osnarbrück",
      "latitude": 52.2555066,
      "longitude": 7.9914307,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Lotter Straße 75, 49078 Osnarbrück",
      "latitude": 52.2737819,
      "longitude": 8.0212908,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Mönkedieckstr. 14, 49088 Osnarbrück",
      "latitude": 52.29888,
      "longitude": 8.06026,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Venloer Straße 47-53, 50672 Köln",
      "latitude": 50.9425833,
      "longitude": 6.934497299999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Hohenstaufenring 28, 50674 Köln",
      "latitude": 50.9313874,
      "longitude": 6.9418406,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Hauptstraße 129-131, 51465 Bergisch Gladbach",
      "latitude": 50.99043289999999,
      "longitude": 7.125015899999999,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Theaterplatz 9-11, 52062 Aachen",
      "latitude": 50.7726497,
      "longitude": 6.0878491,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "SuperBioMarkt",
      "address": "Gangolfstraße 2-4, 53111 Bonn",
      "latitude": 50.7325291,
      "longitude": 7.0985106,
      "website": "www.superbiomarkt.de"
  },
  {
      "name": "Bio Company",
      "address": "Postplatz 2 B, 01067 Dresden",
      "latitude": 51.050809,
      "longitude": 13.7330549,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Königsbrückerstraße 34, 01099 Dresden",
      "latitude": 51.0681984,
      "longitude": 13.7481076,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Tolkewitzer Straße 8, 01277 Dresden",
      "latitude": 51.0510321,
      "longitude": 13.8077599,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Chausseestraße 19, 10115 Berlin",
      "latitude": 52.5302259,
      "longitude": 13.3840856,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Friedrichstraße 136, 10117 Berlin",
      "latitude": 52.52283869999999,
      "longitude": 13.3875644,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Brunnenstraße 6 - 7, 10119 Berlin",
      "latitude": 52.5307421,
      "longitude": 13.400712,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Dircksenstraße 145 - 147, 10178 Berlin",
      "latitude": 52.5230907,
      "longitude": 13.4041731,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Boxhagener Straße 73, 10245 Berlin",
      "latitude": 52.5070499,
      "longitude": 13.4690287,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Voigtstraße 38, 10247 Berlin",
      "latitude": 52.5161706,
      "longitude": 13.4680726,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Treskowallee 114, 10318 Berlin",
      "latitude": 52.4811663,
      "longitude": 13.5244616,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Greifswalder Straße 212, 10405 Berlin",
      "latitude": 52.5321581,
      "longitude": 13.4270269,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Prenzlauer Allee 180, 10405 Berlin",
      "latitude": 52.5440067,
      "longitude": 13.4266027,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Gleimstraße 30 - 35, 10437 Berlin",
      "latitude": 52.547634,
      "longitude": 13.4125389,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Turmstraße 42, 10551 Berlin",
      "latitude": 52.5270147,
      "longitude": 13.3351183,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Wilmersdorfer Straße 107, 10629 Berlin",
      "latitude": 52.5047264,
      "longitude": 13.3076739,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Fehrbelliner Platz 5, 10707 Berlin",
      "latitude": 52.4911519,
      "longitude": 13.3148962,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Heilbronner Straße 12, 10711 Berlin",
      "latitude": 52.5022609,
      "longitude": 13.2957445,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Babelsberger Straße 52, 10715 Berlin",
      "latitude": 52.4877723,
      "longitude": 13.3355407,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Uhlandstraße 103, 10715 Berlin",
      "latitude": 52.4858287,
      "longitude": 13.3228818,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Bundesallee 201 - 203 / Trautenaustraße 2, 10717 Berlin",
      "latitude": 52.4931688,
      "longitude": 13.33103,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Uhlandstraße 41, 10719 Berlin",
      "latitude": 52.4992197,
      "longitude": 13.3243845,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Martin-Luther-Straße 14, 10777 Berlin",
      "latitude": 52.4981438,
      "longitude": 13.3457031,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Hauptstraße 31 - 32 , 10827 Berlin",
      "latitude": 52.485093,
      "longitude": 13.3535328,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Friesenstraße 1, 10965 Berlin",
      "latitude": 52.4888663,
      "longitude": 13.3941911,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Yorckstraße 35 - 42, 10965 Berlin",
      "latitude": 52.49265519999999,
      "longitude": 13.371844,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Hasenheide32 - 38, 10967 Berlin",
      "latitude": 52.4885197,
      "longitude": 13.414823,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Kottbusser Damm 91/92, 10967 Berlin",
      "latitude": 52.4934587,
      "longitude": 13.4222072,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Rudi-Dutschke-Straße 17, 10969 Berlin",
      "latitude": 52.50657469999999,
      "longitude": 13.3934657,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Skalitzer Straße 72, 10997 Berlin",
      "latitude": 52.5003736,
      "longitude": 13.4408463,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Skalitzer Straße 127, 10997 Berlin",
      "latitude": 52.4992952,
      "longitude": 13.4210347,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Karl-Marx-Straße 142 A, 12043 Berlin",
      "latitude": 52.4767441,
      "longitude": 13.4385289,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Sonnenallee 60, 12045 Berlin",
      "latitude": 52.4844982,
      "longitude": 13.433813,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Hermannstraße 199, 12049 Berlin",
      "latitude": 52.4752377,
      "longitude": 13.4276646,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Tempelhofer Damm 227, 12099 Berlin",
      "latitude": 52.4556231,
      "longitude": 13.3848746,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Bundesallee 88, 12161 Berlin",
      "latitude": 52.4681196,
      "longitude": 13.3279639,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Schloßstraße 34, 12163 Berlin",
      "latitude": 52.457979,
      "longitude": 13.3210808,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Ferdinandstraße 31 - 35, 12209 Berlin",
      "latitude": 52.42756,
      "longitude": 13.32879,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Bölschestraße 2, 12587 Berlin",
      "latitude": 52.4471055,
      "longitude": 13.6246278,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Weißenhöher Straße 108, 12683 Berlin",
      "latitude": 52.5071789,
      "longitude": 13.5591651,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Berliner Allee 24 - 26, 13088 Berlin",
      "latitude": 52.5478196,
      "longitude": 13.45042,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Breite Straße 20, 13187 Berlin",
      "latitude": 52.570275,
      "longitude": 13.404053,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Breite Straße 33 - 34, 13187 Berlin",
      "latitude": 52.5697615,
      "longitude": 13.4066457,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Müllerstraße 141, 13353 Berlin",
      "latitude": 52.5488698,
      "longitude": 13.35383,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Heinsestraße 28, 13467 Berlin",
      "latitude": 52.6163739,
      "longitude": 13.3077798,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Klosterstraße 34, 13581 Berlin",
      "latitude": 52.5320681,
      "longitude": 13.1984977,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Reichstraße 10, 14052 Berlin",
      "latitude": 52.51267319999999,
      "longitude": 13.2674852,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Neufertstraße 21, 14059 Berlin",
      "latitude": 52.5177292,
      "longitude": 13.2929684,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Kladower Damm 362 - 364, 14089 Berlin",
      "latitude": 52.4555466,
      "longitude": 13.1451713,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Wiesenschlag 4, 14129 Berlin",
      "latitude": 52.4271204,
      "longitude": 13.217742,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Teltower Damm 13, 14169 Berlin",
      "latitude": 52.4336138,
      "longitude": 13.2604779,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Rüdesheimer Straße 3, 14197 Berlin",
      "latitude": 52.4737081,
      "longitude": 13.3147939,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Gutenbergstraße 20 - 22 , 14467 Potsdam",
      "latitude": 52.401184,
      "longitude": 13.0545042,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Schiffbauergasse 4 B, 14467 Potsdam",
      "latitude": 52.4025014,
      "longitude": 13.0720024,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Nedlitzer Straße 19, 14469 Potsdam",
      "latitude": 52.42386070000001,
      "longitude": 13.0544777,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Babelsberger Straße 16, 14473 Potsdam",
      "latitude": 52.3923298,
      "longitude": 13.0652341,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Förster-Funke-Allee 103, 14532 Kleinmachnow",
      "latitude": 52.4049001,
      "longitude": 13.2180019,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Oranienburger Chaussee 21, 16548 Glienicke",
      "latitude": 52.63352920000001,
      "longitude": 13.3096469,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Lange Reihe 29, 20099 Hamburg",
      "latitude": 53.5566549,
      "longitude": 10.0099473,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Hoheluftchaussee 67 - 69, 20253 Hamburg",
      "latitude": 53.5810456,
      "longitude": 9.972513800000002,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Neuer Kamp / Neuer Pferdemarkt 31, 20355 Hamburg",
      "latitude": 53.5576461,
      "longitude": 9.9646879,
      "website": "www.biocompany.de"
  },
  {
      "name": "Bio Company",
      "address": "Stresemannstraße 62, 22769 Hamburg",
      "latitude": 53.5600225,
      "longitude": 9.9590034,
      "website": "www.biocompany.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Webergasse 1, 01067 Dresden",
      "latitude": 51.0481586,
      "longitude": 13.7353981,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alaunstr. 8, 01099 Dresden",
      "latitude": 51.0639974,
      "longitude": 13.7490061,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Königsbrücker Str. 76, 01099 Dresden",
      "latitude": 51.0718446,
      "longitude": 13.7514147,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Brühl 1, 04109 Leipzig",
      "latitude": 51.3433125,
      "longitude": 12.3732192,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Täubchenweg 22 / Breitkopfstr., 04317 Leipzig",
      "latitude": 51.3361816,
      "longitude": 12.3990017,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Handelsstr. 4 - 8, 04356 Leipzig",
      "latitude": 51.4018343,
      "longitude": 12.3978842,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Leipziger Str. 100, 06108 Halle",
      "latitude": 51.4816385,
      "longitude": 11.9721736,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Holzmarkt 1, 07743 Jena",
      "latitude": 50.926876,
      "longitude": 11.586238,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Oskar-Arnold-Str. 9, 08056 Zwickau",
      "latitude": 50.7077008,
      "longitude": 12.5001486,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedensstr. 89, 08523 Plauen",
      "latitude": 50.4962401,
      "longitude": 12.1246534,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Str. der Nationen 12, 09111 Chemnitz",
      "latitude": 50.8339051,
      "longitude": 12.9233325,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Templiner Str. 12, 10119 Berlin",
      "latitude": 52.5320111,
      "longitude": 13.407639,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alexanderplatz 2, 10178 Berlin",
      "latitude": 52.52082559999999,
      "longitude": 13.4144639,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Annenstr. 48, 10179 Berlin",
      "latitude": 52.507502,
      "longitude": 13.4147385,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Tamara-Danz-Str. 11, 10243 Berlin",
      "latitude": 52.5060818,
      "longitude": 13.4465683,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Warschauer Str. 63, 10243 Berlin",
      "latitude": 52.5102346,
      "longitude": 13.4520877,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Boxhagener Str. 103, 10245 Berlin",
      "latitude": 52.5125894,
      "longitude": 13.4598559,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Boxhagener Str. 82 - 82 A, 10245 Berlin",
      "latitude": 52.5086226,
      "longitude": 13.4665077,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mühsamstr. 54, 10249 Berlin",
      "latitude": 52.5201858,
      "longitude": 13.451355,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Dönhoffstr. 41, 10318 Berlin",
      "latitude": 52.48231,
      "longitude": 13.52459,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Danziger Str. 73 - 77, 10405 Berlin",
      "latitude": 52.5391233,
      "longitude": 13.4255315,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Greifswalder Str. 31, 10405 Berlin",
      "latitude": 52.5325818,
      "longitude": 13.4294418,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schliemannstr. 48, 10437 Berlin",
      "latitude": 52.54107,
      "longitude": 13.41637,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schönhauser Allee 80, 10439 Berlin",
      "latitude": 52.5496693,
      "longitude": 13.4159766,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Grolmanstr. 48, 10623 Berlin",
      "latitude": 52.505014,
      "longitude": 13.3234803,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hauptstr. 11, 10827 Berlin",
      "latitude": 52.48843309999999,
      "longitude": 13.3581056,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hauptstr. 29, 10827 Berlin",
      "latitude": 52.4852293,
      "longitude": 13.3539758,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hasenheide 108 A, 10967 Berlin",
      "latitude": 52.4859103,
      "longitude": 13.4215219,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kottbusser Damm 3, 10967 Berlin",
      "latitude": 52.4949725,
      "longitude": 13.4205121,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Oranienstr. 140 - 142, 10969 Berlin",
      "latitude": 52.50400399999999,
      "longitude": 13.4089768,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Karl-Marx-Str. 66, 12043 Berlin",
      "latitude": 52.4820247,
      "longitude": 13.4327194,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Karl-Marx-Str. 234, 12055 Berlin",
      "latitude": 52.4684502,
      "longitude": 13.4414437,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rheinstr. 60, 12159 Berlin",
      "latitude": 52.4701661,
      "longitude": 13.3343422,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Albrechtstr. 16 - 18, 12167 Berlin",
      "latitude": 52.4545481,
      "longitude": 13.3269031,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Marienfelder Chaussee 154, 12349 Berlin",
      "latitude": 52.4156816,
      "longitude": 13.4039126,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alt-Rudow 24, 12357 Berlin",
      "latitude": 52.4201363,
      "longitude": 13.4920803,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schnellerstr. 21, 12439 Berlin",
      "latitude": 52.4573777,
      "longitude": 13.5076039,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Dörpfeldstr. 1, 12489 Berlin",
      "latitude": 52.4354598,
      "longitude": 13.5418601,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 33 - 38, 12555 Berlin",
      "latitude": 52.4577739,
      "longitude": 13.5769098,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bizetstr. 17 - 19, 13088 Berlin",
      "latitude": 52.5473238,
      "longitude": 13.4509583,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rosenthaler Weg 78, 13127 Berlin",
      "latitude": 52.6073205,
      "longitude": 13.4290931,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hermann-Hesse-Str. 4, 13156 Berlin",
      "latitude": 52.5810218,
      "longitude": 13.4025868,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Wollankstr. 101, 13187 Berlin",
      "latitude": 52.5645628,
      "longitude": 13.3939067,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Prenzlauer Promenade 192, 13189 Berlin",
      "latitude": 52.5517356,
      "longitude": 13.4297746,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Müllerstr. 34, 13353 Berlin",
      "latitude": 52.54836779999999,
      "longitude": 13.3558537,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hanne-Sobek-Platz, 13357 Berlin",
      "latitude": 52.5487656,
      "longitude": 13.388132,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Oraniendamm 44, 13469 Berlin",
      "latitude": 52.6111152,
      "longitude": 13.3179834,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Ruppiner Chaussee 217 - 233, 13503 Berlin",
      "latitude": 52.61368,
      "longitude": 13.24571,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Borsigturm 2, 13507 Berlin",
      "latitude": 52.5860043,
      "longitude": 13.2866924,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Klosterstr. 3, 13581 Berlin",
      "latitude": 52.5343325,
      "longitude": 13.1936692,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kaiserdamm 112, 14057 Berlin",
      "latitude": 52.51045,
      "longitude": 13.2931999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Chausseestr. 21, 14109 Berlin",
      "latitude": 52.4179138,
      "longitude": 13.1472519,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Teltower Damm 299, 14167 Berlin",
      "latitude": 52.4062268,
      "longitude": 13.2696162,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Clayallee 177, 14195 Berlin",
      "latitude": 52.4513295,
      "longitude": 13.2700928,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Auf dem Strengfeld 6, 14542 Werder",
      "latitude": 52.3629328,
      "longitude": 12.9338412,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 79 - 81, 14612 Falkensee",
      "latitude": 52.56077759999999,
      "longitude": 13.0918293,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kröpeliner Str. 54, 18055 Rostock",
      "latitude": 54.0887982,
      "longitude": 12.1298793,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Ballindamm 40, 20095 Hamburg",
      "latitude": 53.5513987,
      "longitude": 9.996071400000002,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rentzelstr. 36, 20146 Hamburg",
      "latitude": 53.5659351,
      "longitude": 9.976557399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schanzenstr. 119, 20357 Hamburg",
      "latitude": 53.5649265,
      "longitude": 9.9654034,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Sachsentor 58, 21029 Hamburg-Bergedorf",
      "latitude": 53.4863478,
      "longitude": 10.2149915,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Willy-Brandt-Str. 10, 21335 Lüneburg",
      "latitude": 53.2429791,
      "longitude": 10.4139422,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Alten Eisenwerk 8, 21339 Lüneburg",
      "latitude": 53.2581378,
      "longitude": 10.4124042,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hansestr. 30, 21682 Stade",
      "latitude": 53.60851899999999,
      "longitude": 9.4757763,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Massaquoipassage 5, 22305 Hamburg",
      "latitude": 53.5881965,
      "longitude": 10.0443059,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Fuhlsbüttler Str. 397, 22309 Hamburg",
      "latitude": 53.60236399999999,
      "longitude": 10.0398285,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Stratenbarg 2, 22393 Hamburg",
      "latitude": 53.6543663,
      "longitude": 10.1127004,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Frohmestr. 11, 22457 Hamburg",
      "latitude": 53.63546419999999,
      "longitude": 9.9195037,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kieler Str. 577 D, 22525 Hamburg",
      "latitude": 53.5998105,
      "longitude": 9.9155488,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rugenbarg 11, 22549 Hamburg",
      "latitude": 53.5745425,
      "longitude": 9.8461675,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Osdorfer Landstr. 2, 22607 Hamburg",
      "latitude": 53.5691972,
      "longitude": 9.8796061,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Ottenser Hauptstr. 39, 22765 Hamburg",
      "latitude": 53.5518393,
      "longitude": 9.9288124,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Große Bergstr. 152 - 162, 22767 Hamburg",
      "latitude": 53.55145959999999,
      "longitude": 9.9442535,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rathausplatz 29, 22926 Ahrensburg",
      "latitude": 53.672773,
      "longitude": 10.2371588,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schlutuper Str. 3 - 5, 23566 Lübeck",
      "latitude": 53.8645796,
      "longitude": 10.719382,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Lübecker Str. 23 - 25, 23843 Bad Oldesloe",
      "latitude": 53.811443,
      "longitude": 10.3782756,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Holtenauer Str. 94, 24105 Kiel",
      "latitude": 54.3346034,
      "longitude": 10.133545,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Saarbrückenstr. 143, 24114 Kiel",
      "latitude": 54.3093059,
      "longitude": 10.1060132,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Gutenbergstr. 4, 24558 Henstedt-Ulzburg",
      "latitude": 53.8046727,
      "longitude": 9.980183799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Marienallee 64, 24937 Flensburg",
      "latitude": 54.77822399999999,
      "longitude": 9.4140518,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kurt-Wagener-Str. 4, 25337 Elmshorn",
      "latitude": 53.7462968,
      "longitude": 9.6977007,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Elmshorner Str. 68 - 72, 25421 Pinneberg",
      "latitude": 53.66976,
      "longitude": 9.79473,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Lindenstr. 61, 25524 Itzehoe",
      "latitude": 53.93060639999999,
      "longitude": 9.507149,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kiarwai 3, 25980 Sylt",
      "latitude": 54.9021444,
      "longitude": 8.3289922,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Nadorster Str. 54 - 56, 26123 Oldenburg",
      "latitude": 53.15101139999999,
      "longitude": 8.2172434,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Uhlhornsweg 99, 26129 Oldenburg",
      "latitude": 53.1481104,
      "longitude": 8.181667599999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bloherfelder Str. 2 - 6, 26129 Oldenburg",
      "latitude": 53.1420568,
      "longitude": 8.1911101,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Stedinger Str. 6 - 12, 26135 Oldenburg",
      "latitude": 53.1322858,
      "longitude": 8.2235067,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bismarckstr. 247, 26382 Wilhelmshaven",
      "latitude": 53.529085,
      "longitude": 8.0933903,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Telefunkenstr. 49, 29223 Celle",
      "latitude": 52.6391357,
      "longitude": 10.0761739,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Marktstr. 45, 30159 Hannover",
      "latitude": 52.3703626,
      "longitude": 9.7377605,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Ernst-August-Platz 1, 30159 Hannover",
      "latitude": 52.3761416,
      "longitude": 9.7415315,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Celler Str. 85, 30161 Hannover",
      "latitude": 52.38570379999999,
      "longitude": 9.7467518,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Engelbosteler Damm 20/22, 30167 Hannover",
      "latitude": 52.38359879999999,
      "longitude": 9.7254018,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Marienstr. 51/53, 30171 Hannover",
      "latitude": 52.3696413,
      "longitude": 9.751006799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Limmerstr. 3 - 5, 30451 Hannover",
      "latitude": 52.37154229999999,
      "longitude": 9.7124046,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Tiergartenstr. 128, 30559 Hannover",
      "latitude": 52.3606376,
      "longitude": 9.8305505,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Edgar-Scheibe-Str. 1, 30655 Hannover",
      "latitude": 52.40600999999999,
      "longitude": 9.79014,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Pettenkoferstr. 2 E, 30880 Laatzen",
      "latitude": 52.30532410000001,
      "longitude": 9.814796099999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hannoversche Str. 12 B, 30938 Burgwedel",
      "latitude": 52.4906318,
      "longitude": 9.8593008,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alfelder Str. 56 P, 31139 Hildesheim",
      "latitude": 52.1392301,
      "longitude": 9.9401687,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Burgdorfer Str. 10 B, 31275 Lehrte",
      "latitude": 52.37701,
      "longitude": 9.976856,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mindener Str. 82, 32049 Herford",
      "latitude": 52.1248161,
      "longitude": 8.684012599999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedrichstr. 22, 32427 Minden",
      "latitude": 52.2930246,
      "longitude": 8.9027326,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Flurweg 20, 32457 Porta Westfalica",
      "latitude": 52.2598825,
      "longitude": 8.900115999999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bruchweg 14, 32657 Lemgo",
      "latitude": 52.0288268,
      "longitude": 8.9083121,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Pohlweg 110, 33100 Paderborn",
      "latitude": 51.7039458,
      "longitude": 8.7689015,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Strengerstr. 4 - 6, 33330 Gütersloh",
      "latitude": 51.9079339,
      "longitude": 8.3810516,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bielefelder Str. 114, 33378 Rheda-Wiedenbrück",
      "latitude": 51.8460198,
      "longitude": 8.3215695,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Apfelstr. 8, 33613 Bielefeld",
      "latitude": 52.03766470000001,
      "longitude": 8.5247824,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Königsplatz 53, 34117 Kassel",
      "latitude": 51.3155037,
      "longitude": 9.4970202,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kirchweg 70, 34119 Kassel",
      "latitude": 51.3164636,
      "longitude": 9.463945599999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Gutenbergstr. 19, 35037 Marburg",
      "latitude": 50.8052793,
      "longitude": 8.768834499999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schiffenberger Weg 115 - 117, 35394 Gießen",
      "latitude": 50.5713328,
      "longitude": 8.6919044,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "An der Hessenhalle 1 - 3, 35398 Gießen",
      "latitude": 50.5865525,
      "longitude": 8.656271499999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kothenbachweg 4 - 6, 36041 Fulda",
      "latitude": 50.54579529999999,
      "longitude": 9.674408399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Heinrich-Büssing-Ring 41, 38102 Braunschweig",
      "latitude": 52.250467,
      "longitude": 10.5301874,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kurzekampstr. 1, 38104 Braunschweig",
      "latitude": 52.2781088,
      "longitude": 10.5535486,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Celler Str. 30, 38114 Braunschweig",
      "latitude": 52.2730085,
      "longitude": 10.5053872,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Wehrhahn 28 - 30, 40211 Düsseldorf",
      "latitude": 51.2282622,
      "longitude": 6.7898358,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedrichstr. 133, 40217 Düsseldorf",
      "latitude": 51.2083464,
      "longitude": 6.774539,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Düsseldorfer Str. 77, 40667 Meerbusch",
      "latitude": 51.2448184,
      "longitude": 6.696502100000001,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Kronengarten 12, 40721 Hilden",
      "latitude": 51.1681874,
      "longitude": 6.9384516,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Prinzenstr. 1, 41065 Mönchengladbach",
      "latitude": 51.19489859999999,
      "longitude": 6.4546037,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Odenkirchener Str. 34, 41236 Mönchengladbach",
      "latitude": 51.16374,
      "longitude": 6.442359199999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Maubisstr. 26, 41564 Kaarst",
      "latitude": 51.2290782,
      "longitude": 6.6199222,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hoeftstr. 4, 42103 Wuppertal",
      "latitude": 51.2509424,
      "longitude": 7.140145,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Heiligenhauser Str. 52 - 58, 42549 Velbert",
      "latitude": 51.33262569999999,
      "longitude": 7.0232851,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hastener Str. 22 - 26, 42855 Remscheid",
      "latitude": 51.18955330000001,
      "longitude": 7.172403499999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kaiserstr. 93, 44135 Dortmund",
      "latitude": 51.5128599,
      "longitude": 7.484381799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Lindemannstr. 6 - 8, 44137 Dortmund",
      "latitude": 51.50616309999999,
      "longitude": 7.4512519,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hattinger Str. 264, 44795 Bochum",
      "latitude": 51.45833649999999,
      "longitude": 7.196894899999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Wattenscheider Hellweg 83 - 85, 44869 Bochum",
      "latitude": 51.4639701,
      "longitude": 7.1524022,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Birkhuhnweg 5 A, 44892 Bochum",
      "latitude": 51.4620888,
      "longitude": 7.3056666,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rüttenscheider Str. 49, 45128 Essen",
      "latitude": 51.440862,
      "longitude": 7.006605,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Humboldtstr. 323, 45149 Essen",
      "latitude": 51.4209691,
      "longitude": 6.959509,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Düsseldorfer Str. 203, 45481 Mülheim a.d.R.",
      "latitude": 51.41045099999999,
      "longitude": 6.868075999999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Halterner Str. 20, 45657 Recklinghausen",
      "latitude": 51.6199005,
      "longitude": 7.1980966,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Springemarkt 2, 45894 Gelsenkirchen",
      "latitude": 51.5784253,
      "longitude": 7.0552534,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kapellener Str. 29/ Moerser Str. 64, 47239 Duisburg",
      "latitude": 51.4014346,
      "longitude": 6.6587489,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Uerdinger Str. 123, 47799 Krefeld",
      "latitude": 51.336447,
      "longitude": 6.579029,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hammer Str. 39, 48153 Münster",
      "latitude": 51.9523028,
      "longitude": 7.625791799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Grevener Str. 85, 48159 Münster",
      "latitude": 51.9766597,
      "longitude": 7.611847900000001,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "August-Wessing-Damm 86, 48231 Warendorf",
      "latitude": 51.9551934,
      "longitude": 7.9721096,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Weidenstr. 20, 49080 Osnabrück",
      "latitude": 52.270435,
      "longitude": 8.030839199999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Iburger Str. 223, 49082 Osnabrück",
      "latitude": 52.2480775,
      "longitude": 8.0629218,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Emsteker Str. 34, 49661 Cloppenburg",
      "latitude": 52.84283749999999,
      "longitude": 8.0515629,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Deutzer Freiheit 95, 50679 Köln",
      "latitude": 50.936933,
      "longitude": 6.9751892,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Venloer Str. 254 - 260, 50823 Köln",
      "latitude": 50.9477872,
      "longitude": 6.922309299999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Dürener Str. 160 - 162, 50931 Köln",
      "latitude": 50.9302878,
      "longitude": 6.915667,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bergisch Gladbacher Str. 599, 51067 Köln",
      "latitude": 50.9706168,
      "longitude": 7.0474907,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Richard-Zanders-Str. 6, 51465 Bergisch Gladbach",
      "latitude": 50.9842384,
      "longitude": 7.1207406,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Franzstr. 2, 52064 Aachen",
      "latitude": 50.77181179999999,
      "longitude": 6.0841976,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Neumühle 1, 52349 Düren",
      "latitude": 50.79249309999999,
      "longitude": 6.487972399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kölnstr. 9 - 11, 53111 Bonn",
      "latitude": 50.7383163,
      "longitude": 7.1008676,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Endenicher Str. 367 - 373, 53121 Bonn",
      "latitude": 50.7250013,
      "longitude": 7.0702522,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mozartstr. 3 - 5, 53773 Hennef",
      "latitude": 50.77545689999999,
      "longitude": 7.2822232,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schusterstr. 41 - 45, 55116 Mainz",
      "latitude": 50.0015023,
      "longitude": 8.2711665,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schwabenheimer Weg 127, 55543 Bad Kreuznach",
      "latitude": 49.8510781,
      "longitude": 7.8908486,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hohenzollernstr. 34, 56068 Koblenz",
      "latitude": 50.351473,
      "longitude": 7.5921648,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Koblenzer Str. 181, 56727 Mayen",
      "latitude": 50.3277157,
      "longitude": 7.2439747,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Weidenauer Str. 274, 57076 Siegen",
      "latitude": 50.8888737,
      "longitude": 8.0280118,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "An der Drehbank 2, 58285 Gevelsberg",
      "latitude": 51.32586389999999,
      "longitude": 7.353115600000001,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bräuckenstr. 9 - 11, 58511 Lüdenscheid",
      "latitude": 51.2115823,
      "longitude": 7.6447653,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hans-Böckler-Str. 76, 58638 Iserlohn",
      "latitude": 51.3748952,
      "longitude": 7.6865766,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Unnaer Str. 24, 58706 Menden",
      "latitude": 51.440473,
      "longitude": 7.7914385,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedberger Landstr. 73, 60318 Frankfurt",
      "latitude": 50.12401149999999,
      "longitude": 8.6913875,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mainzer Landstr. 351 - 353, 60326 Frankfurt",
      "latitude": 50.1018595,
      "longitude": 8.6341135,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Berger Str. 211, 60385 Frankfurt",
      "latitude": 50.12687039999999,
      "longitude": 8.7085174,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Victor-Slotosch-Str. 14, 60388 Frankfurt",
      "latitude": 50.1449817,
      "longitude": 8.748778399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Goldsteinstr. 126 A, 60528 Frankfurt",
      "latitude": 50.0849893,
      "longitude": 8.631762799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Odenwaldring 70, 63069 Offenbach",
      "latitude": 50.0880131,
      "longitude": 8.7610264,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Steinheimer Tor 3, 63450 Hanau",
      "latitude": 50.1319527,
      "longitude": 8.9118374,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Lange Str. 15 - 19, 63741 Aschaffenburg",
      "latitude": 49.9819229,
      "longitude": 9.141954,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Josef-Dinges-Str. 2, 63743 Aschaffenburg",
      "latitude": 49.9637025,
      "longitude": 9.171888,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Tiergartenstr. 5 A, 64646 Heppenheim",
      "latitude": 49.6401808,
      "longitude": 8.618043499999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Frankfurter Str. 56, 64807 Dieburg",
      "latitude": 49.90750999999999,
      "longitude": 8.8469499,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mauergasse 6 B, 65183 Wiesbaden",
      "latitude": 50.08105930000001,
      "longitude": 8.241234,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Otto-Wallach-Str. 5, 65203 Wiesbaden",
      "latitude": 50.04411349999999,
      "longitude": 8.2178683,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Elly-Beinhorn-Str. 1 B, 65760 Eschborn",
      "latitude": 50.1338252,
      "longitude": 8.5626295,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Fischbacher Str. 6, 65779 Kelkheim",
      "latitude": 50.1390153,
      "longitude": 8.446424,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 41, 67346 Speyer",
      "latitude": 49.32215919999999,
      "longitude": 8.4291774,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schönauer Str. 16-18, 67547 Worms",
      "latitude": 49.6262965,
      "longitude": 8.3626097,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rheingoldplatz 1, 68199 Mannheim",
      "latitude": 49.4546143,
      "longitude": 8.482484099999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Scheffelstr. 67, 68723 Schwetzingen",
      "latitude": 49.3800996,
      "longitude": 8.5847918,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 33, 69115 Heidelberg",
      "latitude": 49.40550510000001,
      "longitude": 8.688337599999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Fritz-Frey-Str. 15, 69121 Heidelberg",
      "latitude": 49.4359522,
      "longitude": 8.680769900000001,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Stralsunder Ring 27, 69181 Leimen",
      "latitude": 49.3545448,
      "longitude": 8.682138,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bergstr. 41, 69469 Weinheim",
      "latitude": 49.5504477,
      "longitude": 8.6646831,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Robert-Koch-Str. 2, 70563 Stuttgart-Vaihingen",
      "latitude": 48.7294133,
      "longitude": 9.1094791,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kimry-Platz 4, 70806 Kornwestheim",
      "latitude": 48.8610582,
      "longitude": 9.1982527,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Johannes-Daur-Str. 18, 70825 Korntal-Münchingen",
      "latitude": 48.8293073,
      "longitude": 9.122145800000002,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mercedesstr. 7 B, 71063 Sindelfingen",
      "latitude": 48.7062912,
      "longitude": 9.000909799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Seeländerplatz 1, 71083 Herrenberg",
      "latitude": 48.5979746,
      "longitude": 8.8687274,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alfred-Kärcher-Str. 6, 71364 Winnenden",
      "latitude": 48.87792280000001,
      "longitude": 9.396042099999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Danziger Str. 40, 71638 Ludwigsburg",
      "latitude": 48.888426,
      "longitude": 9.2089062,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schillerstr. 13, 72202 Nagold",
      "latitude": 48.5481986,
      "longitude": 8.7266193,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kirchheimer Str. 53, 72622 Nürtingen",
      "latitude": 48.6250831,
      "longitude": 9.348989399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Gminderstr. 7, 72762 Reutlingen",
      "latitude": 48.4948169,
      "longitude": 9.2051325,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Poststr. 10, 73033 Göppingen",
      "latitude": 48.701825,
      "longitude": 9.660245999999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Dettinger Str. 107, 73230 Kirchheim unter Teck",
      "latitude": 48.6384882,
      "longitude": 9.454098499999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Ledergasse 7, 73312 Geislingen an der Steige",
      "latitude": 48.6157848,
      "longitude": 9.8416654,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Fackelbrückenstr. 3, 73430 Aalen",
      "latitude": 48.831117,
      "longitude": 10.0821773,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Karlstr. 3, 73614 Schorndorf",
      "latitude": 48.8070906,
      "longitude": 9.5287921,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Gottlieb-Daimler-Str. 9, 74076 Heilbronn",
      "latitude": 49.15208000000001,
      "longitude": 9.21094,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hohenloher Str. 2, 74172 Neckarsulm",
      "latitude": 49.182833,
      "longitude": 9.2249559,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Flößerstr. 60, 74321 Bietigheim-Bissingen",
      "latitude": 48.94873339999999,
      "longitude": 9.0985829,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hermann-Bauer-Str. 5, 74336 Brackenheim",
      "latitude": 49.07489990000001,
      "longitude": 9.0649702,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Daimlerstr. 64, 74545 Michelfeld",
      "latitude": 49.10231,
      "longitude": 9.69575,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Zwingenburgstr. 2, 74821 Mosbach",
      "latitude": 49.3391841,
      "longitude": 9.1199838,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Sporgasse 10 - 12, 75015 Bretten",
      "latitude": 49.0367057,
      "longitude": 8.708899,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Mühlkanal 1, 75172 Pforzheim",
      "latitude": 48.8868497,
      "longitude": 8.6695608,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Stuttgarter Str. 1, 75179 Pforzheim",
      "latitude": 48.9001704,
      "longitude": 8.665281799999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Goethestr. 15, 75417 Mühlacker",
      "latitude": 48.947592,
      "longitude": 8.8384579,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kaiserallee 13 B, 76133 Karlsruhe",
      "latitude": 49.01026599999999,
      "longitude": 8.3831917,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Durmersheimer Str. 143, 76189 Karlsruhe",
      "latitude": 48.9975837,
      "longitude": 8.348628,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Karlsruher Str. 11, 76437 Rastatt",
      "latitude": 48.8639719,
      "longitude": 8.2171184,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Im Götzmann 9, 77933 Lahr/Schwarzwald",
      "latitude": 48.3329381,
      "longitude": 7.8454483,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Carl-Friedrich-Benz-Str. 3, 78073 Bad Dürrheim",
      "latitude": 48.0327789,
      "longitude": 8.5328774,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Erzbergerstr. 1, 78224 Singen",
      "latitude": 47.7589298,
      "longitude": 8.838866399999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hegaustr. 21, 78315 Radolfzell",
      "latitude": 47.7457793,
      "longitude": 8.959084700000002,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bodanstr. 19, 78462 Konstanz",
      "latitude": 47.6580617,
      "longitude": 9.173226999999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Fürstenbergstr. 91, 78467 Konstanz",
      "latitude": 47.6842664,
      "longitude": 9.1567013,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rudolf-Diesel-Str. 11, 78532 Tuttlingen",
      "latitude": 47.9932466,
      "longitude": 8.8286128,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Flözlinger Str. 46, 78658 Zimmern",
      "latitude": 48.16968050000001,
      "longitude": 8.575957899999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Breisacher Str. 151, 79110 Freiburg",
      "latitude": 48.00664279999999,
      "longitude": 7.8280128,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Seidlstr. 5/ Ecke Marsstr. 25, 80335 München",
      "latitude": 48.1430708,
      "longitude": 11.5558582,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hohenzollernstraße 3 - 5, 80801 München",
      "latitude": 48.1592979,
      "longitude": 11.5844194,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Feilitzschstr. 7 - 9, 80802 München",
      "latitude": 48.1616388,
      "longitude": 11.5878709,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bunzlauer Platz 7, 80992 München",
      "latitude": 48.1786246,
      "longitude": 11.5053166,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Verdistr. 130, 81247 München",
      "latitude": 48.1650003,
      "longitude": 11.4613705,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Giesinger Bahnhofplatz 2, 81539 München",
      "latitude": 48.1101446,
      "longitude": 11.5953433,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Grünwalder Str. 190, 81545 München",
      "latitude": 48.0953615,
      "longitude": 11.5630046,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kreillerstr. 211, 81825 München",
      "latitude": 48.1226037,
      "longitude": 11.661993,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Wasserburger Landstr. 214, 81825 München",
      "latitude": 48.1127109,
      "longitude": 11.7020587,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Emil-Geis-Str. 3, 82031 Grünwald",
      "latitude": 48.0398855,
      "longitude": 11.52092,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hartstr. 2, 82110 Germering",
      "latitude": 48.1269935,
      "longitude": 11.3665539,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hauptplatz 5, 82131 Gauting",
      "latitude": 48.0669477,
      "longitude": 11.3807803,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Augsburger Str. 15, 82194 Gröbenzell",
      "latitude": 48.1931722,
      "longitude": 11.3693319,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Olchinger Str. 56, 82194 Gröbenzell",
      "latitude": 48.1841114,
      "longitude": 11.38855,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Maisacher Str. 16, 82256 Fürstenfeldbruck",
      "latitude": 48.1815761,
      "longitude": 11.2551422,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Weilheimer Str. 14, 82319 Starnberg",
      "latitude": 47.9919316,
      "longitude": 11.3304936,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Von-Brug-Str. 13, 82467 Garmisch-Partenkirchen",
      "latitude": 47.4957169,
      "longitude": 11.0953879,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Königsdorfer Str. 33, 82515 Wolfratshausen",
      "latitude": 47.9099757,
      "longitude": 11.4236755,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Sudetenstr. 29 C, 82538 Geretsried",
      "latitude": 47.85735,
      "longitude": 11.48605,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Mangfallstr. 35 - 37, 83026 Rosenheim",
      "latitude": 47.84055,
      "longitude": 12.11323,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kufsteiner Str. 81, 83026 Rosenheim",
      "latitude": 47.8454932,
      "longitude": 12.1254211,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Westendstr. 4 A, 83043 Bad Aibling",
      "latitude": 47.8665478,
      "longitude": 11.9991926,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hochriesstr. 47 B, 83209 Prien",
      "latitude": 47.8472618,
      "longitude": 12.3499895,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Lindach 10, 84489 Burghausen",
      "latitude": 48.1629779,
      "longitude": 12.8045654,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alte Römerstr. 1, 85221 Dachau",
      "latitude": 48.2564184,
      "longitude": 11.4696477,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Landshuter Str. 30, 85356 Freising",
      "latitude": 48.4046787,
      "longitude": 11.7543969,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Anton-Huber-Str. 4, 85435 Erding",
      "latitude": 48.310432,
      "longitude": 11.8897717,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Putzbrunner Str. 26, 85521 Ottobrunn",
      "latitude": 48.0665911,
      "longitude": 11.665882,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Zusestr. 5, 85649 Brunnthal",
      "latitude": 48.0405576,
      "longitude": 11.6624802,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bezirksstr. 7, 85716 Unterschleißheim",
      "latitude": 48.2834583,
      "longitude": 11.579862,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Osterfeldstr. 43, 85737 Ismaning",
      "latitude": 48.2310679,
      "longitude": 11.6885118,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Oberbürgermeister-Hohner-Str. 1 A, 86153 Augsburg",
      "latitude": 48.3643163,
      "longitude": 10.9111217,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedberger Str. 165, 86163 Augsburg",
      "latitude": 48.35584470000001,
      "longitude": 10.9515785,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Germanenstr. 14, 86343 Königsbrunn",
      "latitude": 48.2873973,
      "longitude": 10.8914375,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Benzstr. 13, 86391 Stadtbergen",
      "latitude": 48.3786557,
      "longitude": 10.8465858,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bürgermeister-Götz-Str. 18 A, 86529 Schrobenhausen",
      "latitude": 48.5639589,
      "longitude": 11.2571809,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Längenmühlweg 30, 86633 Neuburg/ Donau",
      "latitude": 48.7256682,
      "longitude": 11.193437,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Alte Weberei 3, 87600 Kaufbeuren",
      "latitude": 47.8829983,
      "longitude": 10.6225134,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 23/ Ecke Luitpoldstr., 87700 Memmingen",
      "latitude": 47.9803589,
      "longitude": 10.1860713,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rheinstr. 3, 88046 Friedrichshafen",
      "latitude": 47.6710895,
      "longitude": 9.4923324,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Langenweg 32 - 34, 88131 Lindau",
      "latitude": 47.5547386,
      "longitude": 9.6903129,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Jahnstr. 5, 88214 Ravensburg",
      "latitude": 47.780418,
      "longitude": 9.605917999999999,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bahnhofstr. 1, 89231 Neu-Ulm",
      "latitude": 48.393081,
      "longitude": 10.003126,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Geschwister-Scholl-Str. 1 C, 89312 Günzburg",
      "latitude": 48.4462514,
      "longitude": 10.2824658,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Wilhelmstr. 160, 89518 Heidenheim a.d. Brenz",
      "latitude": 48.6801667,
      "longitude": 10.1254982,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Pfisterstr. 69, 89584 Ehingen",
      "latitude": 48.2826282,
      "longitude": 9.7170643,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Allersberger Str. 100, 90461 Nürnberg",
      "latitude": 49.43927420000001,
      "longitude": 11.0901588,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Äußere Cramer-Klett-Str. 21, 90489 Nürnberg",
      "latitude": 49.455088,
      "longitude": 11.092651,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Äußere Sulzbacher Str. 124 A, 90491 Nürnberg",
      "latitude": 49.464352,
      "longitude": 11.119234,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hans-Vogel-Str. 54, 90765 Fürth",
      "latitude": 49.4820085,
      "longitude": 11.0092383,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Paul-Gossen-Str. 69, 91052 Erlangen",
      "latitude": 49.5789476,
      "longitude": 11.0020394,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Einsteinstr. 2, 91074 Herzogenaurach",
      "latitude": 49.5773533,
      "longitude": 10.8840495,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Am Falbenholzweg 15 - 17, 91126 Schwabach",
      "latitude": 49.3239704,
      "longitude": 11.0528891,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Seltsamplatz 19/21, 91301 Forchheim",
      "latitude": 49.72121019999999,
      "longitude": 11.065431,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Rettistr. 3, 91522 Ansbach",
      "latitude": 49.3138705,
      "longitude": 10.569594,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Regensburger Str. 65, 92421 Schwandorf",
      "latitude": 49.3137828,
      "longitude": 12.1008526,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kumpfmühler Str. 8, 93047 Regensburg",
      "latitude": 49.0131306,
      "longitude": 12.0877418,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Franz-von-Taxis-Ring 51, 93049 Regensburg",
      "latitude": 49.0135327,
      "longitude": 12.0518375,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Pommernstr. 17, 93073 Neutraubling",
      "latitude": 48.9795509,
      "longitude": 12.1931881,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bürgermeister-Zimmermann-Str. 1, 93413 Cham",
      "latitude": 49.21937,
      "longitude": 12.669013,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Regensburger Str. 70, 94036 Passau",
      "latitude": 48.57476,
      "longitude": 13.4161893,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schönauerweg 2, 94036 Passau",
      "latitude": 48.56517,
      "longitude": 13.43278,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Landshuter Str. 135/143, 94315 Straubing",
      "latitude": 48.8640955,
      "longitude": 12.575479,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Graflinger Str. 135, 94469 Deggendorf",
      "latitude": 48.8516347,
      "longitude": 12.9596243,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Hofer Str. 12, 95183 Töpen",
      "latitude": 50.38647419999999,
      "longitude": 11.8773994,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Bernecker Str. 39, 95448 Bayreuth",
      "latitude": 49.9545493,
      "longitude": 11.5975376,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Friedrich-von-Schiller-Str. 35, 95448 Bayreuth",
      "latitude": 49.9522717,
      "longitude": 11.5726861,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Obere Königstr. 20, 96052 Bamberg",
      "latitude": 49.8965933,
      "longitude": 10.8936932,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Pödeldorfer Str. 144, 96052 Bamberg",
      "latitude": 49.9002734,
      "longitude": 10.9189112,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Emil-Kemmer-Str. 7, 96103 Hallstadt",
      "latitude": 49.91606729999999,
      "longitude": 10.8659519,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Kulmbacher Str. 32, 96317 Kronach",
      "latitude": 50.2348915,
      "longitude": 11.323441,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Callenberger Str. 16 A, 96450 Coburg",
      "latitude": 50.2657052,
      "longitude": 10.9608113,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Juliuspromenade 64, 97070 Würzburg",
      "latitude": 49.7972029,
      "longitude": 9.9315514,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Schützenstr. 4, 97422 Schweinfurt",
      "latitude": 50.0505553,
      "longitude": 10.2346469,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Heiligenfelder Allee 8, 97688 Bad Kissingen",
      "latitude": 50.1905558,
      "longitude": 10.0614287,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Anger 1, 99084 Erfurt",
      "latitude": 50.9768151,
      "longitude": 11.032127,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Damaschkestr. 1, 99425 Weimar",
      "latitude": 50.9799193,
      "longitude": 11.3097728,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "denn's Biomarkt",
      "address": "Altstadtstr. 11, 99817 Eisenach",
      "latitude": 50.9765463,
      "longitude": 10.3387134,
      "website": "www.denns-biomarkt.de"
  },
  {
      "name": "Famila",
      "address": "Schillerstr. 2, 14641 Nauen",
      "latitude": 52.6105464,
      "longitude": 12.8562811,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rostocker Straße 162 , 17166 Teterow ",
      "latitude": 53.7874405,
      "longitude": 12.571257,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Fr.-W.-Raiffeisen-Str. 1c , 17192 Waren ",
      "latitude": 53.5161667,
      "longitude": 12.6818562,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Silostraße 2 , 17389 Anklam ",
      "latitude": 53.8583108,
      "longitude": 13.6931037,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Wedeler Str. 5 , 17438 Wolgast ",
      "latitude": 54.0482753,
      "longitude": 13.7548091,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Nebelring 9 , 18246 Bützow ",
      "latitude": 53.8278005,
      "longitude": 11.9976657,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Friedrich-Engels-Str. 42 , 18273 Güstrow ",
      "latitude": 53.7780246,
      "longitude": 12.1742018,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Heideweg 25 , 18273 Güstrow ",
      "latitude": 53.7993718,
      "longitude": 12.1549245,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rostocker Landweg , 18311 Ribnitz-Damgarten ",
      "latitude": 54.2243019,
      "longitude": 12.4258658,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Mastweg 6 , 18356 Barth ",
      "latitude": 54.3614145,
      "longitude": 12.7119729,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Grünhufer Bogen 13-17, 18437 Stralsund",
      "latitude": 54.3205335,
      "longitude": 13.0471291,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Langendorfer Berg 1 , 18442 Langendorf bei Stralsund ",
      "latitude": 54.30258019999999,
      "longitude": 13.0223656,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Nonnenseestr. 1 , 18528 Bergen ",
      "latitude": 54.4272238,
      "longitude": 13.4207511,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Käthe-Kollwitz-Str. 2, 19288 Ludwigslust",
      "latitude": 53.3238697,
      "longitude": 11.4999608,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schwarzer Weg 11 , 19348 Perleberg ",
      "latitude": 53.0649051,
      "longitude": 11.8383579,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Lindenstr. 15 , 21244 Buchholz ",
      "latitude": 53.326746,
      "longitude": 9.8808888,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Nordring 4 , 21244 Buchholz ",
      "latitude": 53.35073999999999,
      "longitude": 9.863120000000002,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schützenstr. 47, 21266 Jesteburg",
      "latitude": 53.30121,
      "longitude": 9.959499899999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Auf den Blöcken 7 , 21337 Lüneburg ",
      "latitude": 53.238265,
      "longitude": 10.4620921,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Löhnfeld 10 , 21423 Winsen/Luhe ",
      "latitude": 53.3629367,
      "longitude": 10.1938382,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Liebigstr. 2 , 21465 Reinbek ",
      "latitude": 53.52224409999999,
      "longitude": 10.2313665,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Mecklenburger Straße 1 , 21481 Lauenburg ",
      "latitude": 53.383553,
      "longitude": 10.5432053,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Spandauer Str. 31 , 21502 Geesthacht ",
      "latitude": 53.433918,
      "longitude": 10.342781,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Matthias-Claudius-Str. 1, 21629 Neu Wulmstorf",
      "latitude": 53.4606526,
      "longitude": 9.7861504,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Stadtweg 160, 21684 Stade",
      "latitude": 53.5708718,
      "longitude": 9.471114799999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Eichenlohweg 17 , 22309 Hamburg-Steilshoop ",
      "latitude": 53.6085856,
      "longitude": 10.0431837,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Stormarnstr. 33-41 , 22844 Norderstedt ",
      "latitude": 53.7089344,
      "longitude": 10.0187003,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rissener Str. 105 , 22880 Wedel ",
      "latitude": 53.5845523,
      "longitude": 9.7243499,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Kornkamp 50 , 22926 Ahrensburg ",
      "latitude": 53.692451,
      "longitude": 10.2556361,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Redder 2 , 22941 Bargteheide ",
      "latitude": 53.72100229999999,
      "longitude": 10.277064,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Großenseer Straße 7b, 22946 Trittau ",
      "latitude": 53.6153401,
      "longitude": 10.4000421,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schwartauer Landstraße 4 , 23554 Lübeck ",
      "latitude": 53.8875452,
      "longitude": 10.6865405,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Wesloer Landstraße 50-70 , 23566 Lübeck ",
      "latitude": 53.8713037,
      "longitude": 10.7466364,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Möllerung 11-13 , 23569 Lübeck ",
      "latitude": 53.9016982,
      "longitude": 10.8075197,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Sereetzer Feld 1 , 23611 Sereetz ",
      "latitude": 53.9275287,
      "longitude": 10.723405,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Ravensbusch , 23617 Stockelsdorf ",
      "latitude": 53.88912699999999,
      "longitude": 10.6410361,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Höppnerweg 8 , 23669 Timmendorfer Strand ",
      "latitude": 53.99529,
      "longitude": 10.7804373,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Plöner Landstr. 8-10 , 23701 Eutin ",
      "latitude": 54.1304741,
      "longitude": 10.5801114,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rettiner Weg 77 , 23730 Neustadt i.H. ",
      "latitude": 54.1039878,
      "longitude": 10.8347923,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Vossberg 1 , 23758 Oldenburg ",
      "latitude": 54.2930587,
      "longitude": 10.9099759,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Industriestr. 3 , 23774 Heiligenhafen ",
      "latitude": 54.3647491,
      "longitude": 11.0093627,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Eutiner Str. 45 , 23795 Bad Segeberg ",
      "latitude": 53.9514778,
      "longitude": 10.3103074,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Lily-Braun-Str. 24-28 , 23843 Bad Oldesloe ",
      "latitude": 53.79967,
      "longitude": 10.40301,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Barnitzer Straße 1-7 , 23858 Reinfeld ",
      "latitude": 53.8216342,
      "longitude": 10.5015925,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Grambeker Weg 101 , 23879 Mölln ",
      "latitude": 53.6131457,
      "longitude": 10.6756624,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Prinz-Heinrich Str. 20 , 24106 Kiel ",
      "latitude": 54.3607139,
      "longitude": 10.131677,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Kurt-Schumacher-Platz 4 , 24109 Kiel-Mettenhof ",
      "latitude": 54.3233764,
      "longitude": 10.0541593,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Seekoppelweg 2 , 24113 Kiel-Russee ",
      "latitude": 54.2983407,
      "longitude": 10.0862362,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Grot Steenbusch 35 , 24145 Kiel ",
      "latitude": 54.2826051,
      "longitude": 10.1326559,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Preetzer Str. 298 , 24147 Kiel-Elmschenhagen ",
      "latitude": 54.29836,
      "longitude": 10.1675161,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schönkirchener Str. 80 , 24149 Kiel-Dietrichsdorf ",
      "latitude": 54.3289862,
      "longitude": 10.1978986,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Altenholzer Str. 9-11 , 24161 Altenholz ",
      "latitude": 54.4010842,
      "longitude": 10.1263522,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Posthofstr. 4 , 24321 Lütjenburg ",
      "latitude": 54.2939516,
      "longitude": 10.5854545,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rendsburger Str. 119 , 24340 Eckernförde ",
      "latitude": 54.45268069999999,
      "longitude": 9.8355375,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Hauptstr. 21 , 24536 Neumünster ",
      "latitude": 54.0768441,
      "longitude": 10.0028845,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Haart 194 , 24539 Neumünster ",
      "latitude": 54.0596323,
      "longitude": 10.0079289,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Kisdorfer Weg 13 , 24568 Kaltenkirchen ",
      "latitude": 53.82975380000001,
      "longitude": 9.9808422,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Lohstücker Weg 16 , 24576 Bad Bramstedt ",
      "latitude": 53.9158868,
      "longitude": 9.889735199999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Itzehoer Str. , 24589 Nortorf ",
      "latitude": 54.155949,
      "longitude": 9.8495578,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Gablonzer Str. 1-5 , 24610 Trappenkamp ",
      "latitude": 54.04334040000001,
      "longitude": 10.2153911,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Kreishafenstr. 4-6 , 24768 Rendsburg ",
      "latitude": 54.2929688,
      "longitude": 9.6687709,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Friedrichstädter Str. 55 , 24768 Rendsburg ",
      "latitude": 54.3199514,
      "longitude": 9.6242544,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Friedrich-Ebert-Str. 3 , 24837 Schleswig ",
      "latitude": 54.5200075,
      "longitude": 9.5504918,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schottweg 94 , 24944 Flensburg ",
      "latitude": 54.7979849,
      "longitude": 9.475057099999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Wanderuper Straße 18 , 24963 Tarp ",
      "latitude": 54.6688711,
      "longitude": 9.3937583,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Hans-Böckler- Str. 1 , 25337 Elmshorn ",
      "latitude": 53.7484707,
      "longitude": 9.683613,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Flensburger Str. 3 , 25421 Pinneberg ",
      "latitude": 53.67363,
      "longitude": 9.8011801,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Westring 6 , 25421 Pinneberg ",
      "latitude": 53.6459534,
      "longitude": 9.7713704,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Großer Sand 96-98 , 25436 Uetersen ",
      "latitude": 53.6804472,
      "longitude": 9.6746117,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Pascalstraße 9 , 25451 Quickborn ",
      "latitude": 53.7426556,
      "longitude": 9.9408785,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Fritz-Thiedemann-Ring 40 , 25746 Heide ",
      "latitude": 54.17663959999999,
      "longitude": 9.0938474,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Andreas-Clausen-Str. 2, 25813 Husum",
      "latitude": 54.4950541,
      "longitude": 9.083050799999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Industriestraße 13 , 25917 Leck ",
      "latitude": 54.7769625,
      "longitude": 8.9811335,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Industrieweg 1 , 25980 Westerland ",
      "latitude": 54.9038401,
      "longitude": 8.3120952,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Weserstraße 1 , 27318 Hoya ",
      "latitude": 52.8043895,
      "longitude": 9.1438443,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Auf dem Rusch 1 , 27356 Rotenburg ",
      "latitude": 53.1147959,
      "longitude": 9.4123913,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Hördorfer Weg 50 , 27711 Osterholz-Scharmbeck ",
      "latitude": 53.2323482,
      "longitude": 8.756217,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Zur Hasselklink 3-5, 29229 Celle",
      "latitude": 52.65209189999999,
      "longitude": 10.069968,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Adolfsplatz 3 , 29451 Dannenberg ",
      "latitude": 53.0979981,
      "longitude": 11.0960596,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Kohlenbissener Grund 8-12 , 29633 Munster ",
      "latitude": 52.99037999999999,
      "longitude": 10.10735,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Am Vogelsang 12 , 29640 Schneverdingen ",
      "latitude": 53.1071772,
      "longitude": 9.7892464,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Hans-Böckler-Str. 60-66 , 30851 Langenhagen ",
      "latitude": 52.43055,
      "longitude": 9.71652,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Wedemarkstraße 96 , 30900 Mellendorf ",
      "latitude": 52.5487282,
      "longitude": 9.7463436,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Schapers Kamp 5 , 31311 Uetze ",
      "latitude": 52.4656606,
      "longitude": 10.1895557,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Rudolf-Diesel-Ring 30 , 31535 Neustadt a.Rbge ",
      "latitude": 52.511705,
      "longitude": 9.4778421,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Lemker Str. 20 , 31582 Nienburg ",
      "latitude": 52.643847,
      "longitude": 9.198848199999999,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Hansestr. 1 , 33689 Bielefeld ",
      "latitude": 51.95194859999999,
      "longitude": 8.5701573,
      "website": "www.famila.de"
  },
  {
      "name": "Famila",
      "address": "Braunschweiger Str. 40 , 38518 Gifhorn ",
      "latitude": 52.4773242,
      "longitude": 10.5427579,
      "website": "www.famila.de"
  },
  {
      "name": "Kaufland",
      "address": "Hohenbusch-Markt 1, 01108 Dresden",
      "latitude": 51.141447,
      "longitude": 13.7957308,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Peschelstraße 33, 01139 Dresden",
      "latitude": 51.0850343,
      "longitude": 13.6961135,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kesseldorfer Straße 81, 01159 Dresden",
      "latitude": 51.04147769999999,
      "longitude": 13.6832105,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Harthaer Str. 3, 01169 Dresden",
      "latitude": 51.050163,
      "longitude": 13.661193,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kohlenstraße 18, 01189 Dresden",
      "latitude": 51.01962349999999,
      "longitude": 13.7223169,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Reicker Straße 60, 01219 Dresden",
      "latitude": 51.0187438,
      "longitude": 13.7789329,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dohnaer Str. 246, 01239 Dresden",
      "latitude": 50.9972,
      "longitude": 13.8003159,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Borsbergstraße 35, 01309 Dresden-Striesen",
      "latitude": 51.0442627,
      "longitude": 13.7809686,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An der Prießnitzaue 3, 01328 Dresden-Weißig",
      "latitude": 51.0659528,
      "longitude": 13.8934668,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weintraubenstraße 31, 01445 Radebeul",
      "latitude": 51.09924789999999,
      "longitude": 13.6544479,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Riesaerstr. 54, 01558 Großenhain",
      "latitude": 51.2886045,
      "longitude": 13.4936835,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 74-78, 01587 Riesa",
      "latitude": 51.3058595,
      "longitude": 13.3030829,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Salzstraße 16 A, 01640 Coswig",
      "latitude": 51.1332489,
      "longitude": 13.58577,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schützestraße 1, 01662 Meißen",
      "latitude": 51.1501074,
      "longitude": 13.4582826,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Niederauer Straße 43, 01662 Meißen",
      "latitude": 51.1680994,
      "longitude": 13.5015992,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilsdruffer Straße 52, 01705 Freital-Zauckerode",
      "latitude": 51.0147424,
      "longitude": 13.6473688,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An Der Spinnerei 8, 01705 Freital",
      "latitude": 50.9755243,
      "longitude": 13.6221743,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriering 2, 01744 Dippoldiswalde",
      "latitude": 50.89745,
      "longitude": 13.694165,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Struppener Straße 11a, 01796 Pirna",
      "latitude": 50.9575584,
      "longitude": 13.9582676,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lohmener Straße 12 C, 01796 Pirna",
      "latitude": 50.9801722,
      "longitude": 13.9491007,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelm-Kaulisch-Straße 26, 01844 Neustadt in Sachsen",
      "latitude": 51.0283493,
      "longitude": 14.2192942,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pulsnitzerstraße 16, 01900 Großröhrsdorf",
      "latitude": 51.15358519999999,
      "longitude": 14.0202541,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Willy-Muhle-Straße 25, 01917 Kamenz",
      "latitude": 51.2690441,
      "longitude": 14.112453,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An Der Windmühle 2, 01917 Kamenz",
      "latitude": 51.2861506,
      "longitude": 14.0941209,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Briesker Str., 01968 Senftenberg",
      "latitude": 51.5074595,
      "longitude": 13.9762052,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gesundbrunnenring 62, 02625 Bautzen",
      "latitude": 51.1917485,
      "longitude": 14.4450443,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rumburger Str., 02708 Löbau",
      "latitude": 51.08263969999999,
      "longitude": 14.6624974,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Johann-Andreas-Schubert-Straße, 02730 Ebersbach-Neugersdorf",
      "latitude": 50.9983851,
      "longitude": 14.6157802,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Äußere Weberstraße 87, 02763 Zittau",
      "latitude": 50.8986436,
      "longitude": 14.7809731,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Christian-Keimann-Straße 44, 02763 Zittau",
      "latitude": 50.8934395,
      "longitude": 14.819575,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zittauer Str. 120, 02827 Görlitz",
      "latitude": 51.1265766,
      "longitude": 14.9830144,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Scultetusstr. 24, 02828 Görlitz-Königshufen",
      "latitude": 51.1642273,
      "longitude": 14.9776006,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sachsendamm 30, 02943 Weißwasser",
      "latitude": 51.4982213,
      "longitude": 14.6223365,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Straße E 9, 02977 Hoyerswerda",
      "latitude": 51.4313426,
      "longitude": 14.2844598,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sielower Chaussee 38, 03044 Cottbus",
      "latitude": 51.7833621,
      "longitude": 14.3170701,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hardenbergstraße 5, 03050 Cottbus",
      "latitude": 51.7349086,
      "longitude": 14.3344851,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An Der Lusatia 1, 03130 Spremberg",
      "latitude": 51.55793670000001,
      "longitude": 14.3558541,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Promenade 2, 03149 Forst",
      "latitude": 51.7449808,
      "longitude": 14.6461977,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kaltenborner Str. 68, 03172 Guben",
      "latitude": 51.93928349999999,
      "longitude": 14.7038584,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrich-Schiller-Straße 5B, 03172 Guben",
      "latitude": 51.9513078,
      "longitude": 14.6768192,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Kaufland 2, 03222 Lübbenau",
      "latitude": 51.8671674,
      "longitude": 13.9402449,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sonnewalder Str. 100, 03238 Finsterwalde",
      "latitude": 51.6446643,
      "longitude": 13.6975473,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Georg-Schumann-Str. 105, 04155 Leipzig",
      "latitude": 51.3630582,
      "longitude": 12.3617813,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Georg-Schumann-Str. 290, 04159 Leipzig",
      "latitude": 51.37290789999999,
      "longitude": 12.3292203,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lindenauer Markt 2, 04177 Leipzig",
      "latitude": 51.3373777,
      "longitude": 12.3363486,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kiewer Straße 30, 04205 Leipzig",
      "latitude": 51.3241609,
      "longitude": 12.2761907,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Anton-Zickmantel-Str., 04249 Leipzig",
      "latitude": 51.3026042,
      "longitude": 12.3230414,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dresdner Straße 80, 04317 Leipzig",
      "latitude": 51.3379312,
      "longitude": 12.4051433,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Paunsdorfer Allee 1, 04329 Leipzig",
      "latitude": 51.3483642,
      "longitude": 12.4777518,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Torgauer Str. 279, 04347 Leipzig",
      "latitude": 51.3672403,
      "longitude": 12.457746,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Portitzer Straße 34, 04425 Taucha",
      "latitude": 51.381025,
      "longitude": 12.4882059,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sepp-Verscht-Straße 1, 04463 Großpösna",
      "latitude": 51.2673996,
      "longitude": 12.4975076,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sachsenstraße 1, 04509 Delitzsch",
      "latitude": 51.5378137,
      "longitude": 12.3253452,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Wilhelmschacht 34, 04552 Borna",
      "latitude": 51.111864,
      "longitude": 12.488579,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kauerndorfer Allee 20, 04600 Altenburg",
      "latitude": 50.9969912,
      "longitude": 12.4245029,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Käthe-Kollwitz-Straße 43, 04600 Altenburg",
      "latitude": 50.9805322,
      "longitude": 12.4429221,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Markt 11, 04626 Schmölln",
      "latitude": 50.894758,
      "longitude": 12.3523143,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gerichtswiesen 2, 04668 Grimma",
      "latitude": 51.23214050000001,
      "longitude": 12.7041058,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schillerstraße 6, 04720 Döbeln",
      "latitude": 51.1194405,
      "longitude": 13.1222218,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 107, 04736 Waldheim",
      "latitude": 51.079914,
      "longitude": 12.9956739,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Collmener Straße 12, 04808 Wurzen",
      "latitude": 51.3810431,
      "longitude": 12.7378319,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An der Schondorfer Mark 1, 04838 Eilenburg",
      "latitude": 51.4653905,
      "longitude": 12.6757953,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Turnierplatzweg 1, 04860 Torgau",
      "latitude": 51.548393,
      "longitude": 12.9971061,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Außenring 1, 04860 Torgau",
      "latitude": 51.5630438,
      "longitude": 12.9700861,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Osterodaer Straße 12, 04916 Herzberg",
      "latitude": 51.6958363,
      "longitude": 13.260871,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Leipziger Chaussee 147, 06112 Halle (Saale)",
      "latitude": 51.4545587,
      "longitude": 12.0169567,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Magdeburger Chaussee 23, 06118 Halle",
      "latitude": 51.5229767,
      "longitude": 11.9504983,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zollrain 9, 06124 Halle",
      "latitude": 51.4714289,
      "longitude": 11.9245829,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Südstadtring 90, 06128 Halle (Saale)",
      "latitude": 51.44780790000001,
      "longitude": 11.9587303,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Querfurter Straße 16, 06217 Merseburg",
      "latitude": 51.3713857,
      "longitude": 11.9767299,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hallesche Straße 77, 06295 Lutherstadt Eisleben",
      "latitude": 51.5238733,
      "longitude": 11.5578844,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Merziener Straße 20, 06366 Köthen",
      "latitude": 51.7544542,
      "longitude": 12.0018779,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zepziger Weg 6, 06406 Bernburg",
      "latitude": 51.7800455,
      "longitude": 11.753269,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hoymer Chaussee 108, 06449 Aschersleben",
      "latitude": 51.7608203,
      "longitude": 11.4346802,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Badeborner Weg 2, 06484 Quedlinburg",
      "latitude": 51.7889326,
      "longitude": 11.1593599,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Blankenburger Straße 37, 06502 Thale",
      "latitude": 51.7716463,
      "longitude": 11.0022522,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schützenplatz 2, 06526 Sangerhausen",
      "latitude": 51.4703666,
      "longitude": 11.2945618,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weissenfelser Straße 70, 06618 Naumburg",
      "latitude": 51.1471386,
      "longitude": 11.8320611,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Max-Planck-Straße 3, 06667 Weißenfels",
      "latitude": 51.18781449999999,
      "longitude": 11.9817488,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Drei Wege 5, 06667 Weißenfels-Borau",
      "latitude": 51.1976594,
      "longitude": 11.9995335,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwarzer Weg 40, 06712 Zeitz",
      "latitude": 51.03706649999999,
      "longitude": 12.12881,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hainichener Dorfstr. 1, 06712 Zeitz",
      "latitude": 51.0364946,
      "longitude": 12.1641202,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bismarckstr. 39, 06749 Bitterfeld",
      "latitude": 51.6186021,
      "longitude": 12.3191082,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wittener Str. 28, 06766 Bitterfeld-Wolfen",
      "latitude": 51.688429,
      "longitude": 12.2467526,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thiemendorfer Mark 3, 06796 Brehna",
      "latitude": 51.5533954,
      "longitude": 12.1940229,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Eichengarten 2, 06842 Dessau",
      "latitude": 51.8212707,
      "longitude": 12.3016783,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wolfgangstraße 14, 06844 Dessau",
      "latitude": 51.8397814,
      "longitude": 12.2390742,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zunftstraße 15, 06847 Dessau",
      "latitude": 51.8161749,
      "longitude": 12.216726,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lerchenberg Str. 112-113, 06886 Lutherstadt Wittenberg",
      "latitude": 51.8800276,
      "longitude": 12.6648894,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kronacherstr. 9, 07333 Unterwellenborn",
      "latitude": 50.6597553,
      "longitude": 11.4546729,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Saalfelder Straße 21, 07381 Pößneck",
      "latitude": 50.693293,
      "longitude": 11.588422,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Spielborn 1-3, 07407 Rudolstadt",
      "latitude": 50.6963082,
      "longitude": 11.3258494,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heinrichstraße 30, 07545 Gera",
      "latitude": 50.8757872,
      "longitude": 12.0768616,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schleizer Str. 36-39, 07549 Gera-Lusan",
      "latitude": 50.847656,
      "longitude": 12.0666822,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thüringer Straße 26, 07552 Gera-Bieblach/Ost",
      "latitude": 50.8998189,
      "longitude": 12.0995416,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Obere Donitzschkau 2, 07607 Eisenberg",
      "latitude": 50.9801522,
      "longitude": 11.8987963,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Naumburger Straße 57 a, 07743 Jena",
      "latitude": 50.9516079,
      "longitude": 11.6107754,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Marx-Allee, 07747 Jena-Lobeda",
      "latitude": 50.88420929999999,
      "longitude": 11.6066152,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Oetterdorfer Straße 40, 07907 Schleiz",
      "latitude": 50.5885437,
      "longitude": 11.8135789,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aumaische Straße 27 / 29, 07937 Zeulenroda",
      "latitude": 50.6516406,
      "longitude": 11.9775811,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "August-Bebel-Straße 46, 07973 Greiz",
      "latitude": 50.6531664,
      "longitude": 12.2092674,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schubertstraße, 08058 Zwickau",
      "latitude": 50.7478249,
      "longitude": 12.4811867,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bernhardstraße 5, 08060 Zwickau",
      "latitude": 50.71647460000001,
      "longitude": 12.4633211,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Äussere Dresdner Straße 25, 08066 Zwickau",
      "latitude": 50.71973999999999,
      "longitude": 12.5220247,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zur Sternkoppel 1, 08228 Rodewisch",
      "latitude": 50.519854,
      "longitude": 12.387015,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Brünlasberg 1A, 08280 Aue",
      "latitude": 50.5963755,
      "longitude": 12.6801854,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Albin-Trommler-Straße 1, 08297 Zwönitz",
      "latitude": 50.636114,
      "longitude": 12.7945364,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karlsbader Straße 2 A, 08340 Schwarzenberg",
      "latitude": 50.5397363,
      "longitude": 12.7852045,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Waldenburger Str. F175, 08371 Glauchau",
      "latitude": 50.8335411,
      "longitude": 12.5395076,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Grenayer Str. 10, 08371 Glauchau - Schönbörnchen",
      "latitude": 50.81908,
      "longitude": 12.5147169,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Seiferitzer Allee 1, 08393 Meerane",
      "latitude": 50.8359585,
      "longitude": 12.4510999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Uferstraße 1, 08412 Werdau",
      "latitude": 50.7337317,
      "longitude": 12.3728699,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stiftstraße 6-8, 08412 Werdau-Steinpleis",
      "latitude": 50.7104682,
      "longitude": 12.4157146,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zwickauer Str. 128, 08468 Reichenbach",
      "latitude": 50.6303397,
      "longitude": 12.3107237,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Morgenbergstraße 41, 08525 Plauen",
      "latitude": 50.5139548,
      "longitude": 12.1267229,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alte Jößnitzer Str.30, 08525 Plauen-Kauschwitz",
      "latitude": 50.53233789999999,
      "longitude": 12.104886,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Äussere Reichenbacher Str.64, 08529 Plauen-Chrieschwitz",
      "latitude": 50.4956487,
      "longitude": 12.1710944,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Chemnitzer Str. 65, 09123 Chemnitz",
      "latitude": 50.7837313,
      "longitude": 12.8953484,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thomas-Mann-Platz 1C, 09130 Chemnitz",
      "latitude": 50.8466555,
      "longitude": 12.9379138,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ostring 4, 09212 Limbach-Oberfrohna",
      "latitude": 50.8555873,
      "longitude": 12.7843648,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Mittweidaer Straße 1, 09217 Burgstädt",
      "latitude": 50.9190073,
      "longitude": 12.8155122,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heinrich-Heine-Str. 1a, 09337 Hohenstein-Ernstthal",
      "latitude": 50.80008669999999,
      "longitude": 12.7277632,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auer Straße 20, 09366 Stollberg",
      "latitude": 50.7069369,
      "longitude": 12.7577409,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Chemnitzer Straße 124, 09405 Zschopau",
      "latitude": 50.7565316,
      "longitude": 13.0536757,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gewerbering 2, 09456 Annaberg-Buchholz",
      "latitude": 50.59823859999999,
      "longitude": 13.0209049,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Lautengrund 4, 09496 Marienberg",
      "latitude": 50.6586126,
      "longitude": 13.1584002,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bebel-Platz 2, 09599 Freiberg",
      "latitude": 50.9139393,
      "longitude": 13.3399215,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Häuersteig 2, 09599 Freiberg",
      "latitude": 50.8954248,
      "longitude": 13.328191,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sonnenstraße 7, 09648 Mittweida",
      "latitude": 50.9949787,
      "longitude": 12.9658613,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Jochen-Köhler-Straße 11, 09669 Frankenberg / Sachsen",
      "latitude": 50.9136853,
      "longitude": 13.0294427,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Liebknecht-Straße 13, 10178 Berlin",
      "latitude": 52.5224943,
      "longitude": 13.4074279,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hermann-Blankenstein-Str. 38, 10249 Berlin",
      "latitude": 52.5237385,
      "longitude": 13.4631222,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marktstraße 6, 10317 Berlin",
      "latitude": 52.5035803,
      "longitude": 13.4734615,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sewanstraße 4 Und 6, 10319 Berlin",
      "latitude": 52.49958669999999,
      "longitude": 13.497072,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Storkower Str. 139, 10407 Berlin-Prenzlauer Berg",
      "latitude": 52.5338928,
      "longitude": 13.4565095,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Perleberger Straße 42 A, 10559 Berlin-Moabit",
      "latitude": 52.5284954,
      "longitude": 13.3437301,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Marx-Straße 66, 12043 Berlin-Neukölln",
      "latitude": 52.4820247,
      "longitude": 13.4327194,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Marx-Straße 231-235, 12055 Berlin",
      "latitude": 52.468788,
      "longitude": 13.4436614,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bessemerstraße 57 - 75, 12103 Berlin",
      "latitude": 52.4623303,
      "longitude": 13.3678101,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schöneberger Straße 7, 12103 Berlin",
      "latitude": 52.4680396,
      "longitude": 13.3770837,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ostpreußendamm 60, 12207 Berlin",
      "latitude": 52.4232653,
      "longitude": 13.3121793,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Buckower Chaussee 100-102, 12277 Berlin-Marienfelde",
      "latitude": 52.41048379999999,
      "longitude": 13.3818036,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Johannisthaler Chaussee 295 -, 12351 Berlin",
      "latitude": 52.4293597,
      "longitude": 13.4542947,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gutschmidtstraße 19, 12359 Berlin",
      "latitude": 52.43647499999999,
      "longitude": 13.4479358,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schnellerstraße 21, 12439 Berlin",
      "latitude": 52.4573777,
      "longitude": 13.5076039,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rudower Chaussee 12, 12489 Berlin-Adlershof",
      "latitude": 52.432939,
      "longitude": 13.53474,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichshagener Str. 38-42, 12555 Berlin-Köpenick",
      "latitude": 52.4524598,
      "longitude": 13.5867162,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Märkische Allee 166, 168, 172, 12681 Berlin",
      "latitude": 52.53352289999999,
      "longitude": 13.5382833,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weißenhöher Straße 88-108, 12683 Berlin",
      "latitude": 52.5063235,
      "longitude": 13.5590165,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 9 - 10, 13055 Berlin",
      "latitude": 52.5484733,
      "longitude": 13.5039724,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Romain-Roland-Straße 13, 13089 Berlin",
      "latitude": 52.56448289999999,
      "longitude": 13.4471393,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Walter-Friedrich-Straße 4, 13125 Berlin",
      "latitude": 52.6346403,
      "longitude": 13.4953867,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Breite Straße 19 - 21A, 13187 Berlin-Pankow",
      "latitude": 52.570314,
      "longitude": 13.4038528,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Müllerstraße 123-125, 13349 Berlin",
      "latitude": 52.5529783,
      "longitude": 13.346222,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Brunnenstraße 105-109, 13355 Berlin",
      "latitude": 52.5479628,
      "longitude": 13.391198,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ollenhauerstraße 122, 13403 Berlin",
      "latitude": 52.5677031,
      "longitude": 13.3285545,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Residenzstraße 85, 13409 Berlin",
      "latitude": 52.5591156,
      "longitude": 13.3731472,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eichhorster Weg 96, 13435 Berlin",
      "latitude": 52.6035951,
      "longitude": 13.335529,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Senftenberger Ring 15-17, 13439 Berlin",
      "latitude": 52.59931,
      "longitude": 13.35432,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Grünhofer Weg 9, 13581 Berlin",
      "latitude": 52.53288380000001,
      "longitude": 13.1892285,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelmstraße 21-25, 13593 Berlin",
      "latitude": 52.5213751,
      "longitude": 13.1867692,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pichelswerderstraße 6, 13597 Berlin-Spandau",
      "latitude": 52.5292967,
      "longitude": 13.2126235,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Juliusturm 40-46, 13599 Berlin",
      "latitude": 52.5377425,
      "longitude": 13.2196261,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Goerzallee 195, 14167 Berlin",
      "latitude": 52.41710029999999,
      "longitude": 13.2860525,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zeppelinstraße 132, 14471 Potsdam",
      "latitude": 52.3893329,
      "longitude": 13.0305317,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Babelsberger Str. 16, 14473 Potsdam",
      "latitude": 52.3923298,
      "longitude": 13.0652341,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Moosfenn 1, 14478 Potsdam",
      "latitude": 52.3644669,
      "longitude": 13.0937944,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Potsdamer Straße 6 und 8, 14513 Teltow",
      "latitude": 52.39662269999999,
      "longitude": 13.2406382,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf Dem Strengfeld 6, 14542 Werder",
      "latitude": 52.3629328,
      "longitude": 12.9338412,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Döberitzer Weg 3, 14624 Dallgow-Döberitz",
      "latitude": 52.5303551,
      "longitude": 13.0837023,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Milower Landstr. 6A, 14712 Rathenow",
      "latitude": 52.58972,
      "longitude": 12.3375884,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwedendamm 3, 14712 Rathenow",
      "latitude": 52.608235,
      "longitude": 12.3243088,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An der Bundesstraße 1, 14776 Brandenburg an der Havel",
      "latitude": 52.4088824,
      "longitude": 12.6151816,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dorfstraße 29, 14822 Linthe",
      "latitude": 52.1590502,
      "longitude": 12.7843386,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Burg 22, 14943 Luckenwalde",
      "latitude": 52.0921361,
      "longitude": 13.1780867,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Potsdamer Str. 51 + 53, 14974 Ludwigsfelde",
      "latitude": 52.3033607,
      "longitude": 13.2549565,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heilbronner Straße 30, 15230 Frankfurt a. d. Oder",
      "latitude": 52.3423423,
      "longitude": 14.5471983,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Josef-Geising-Straße 6, 15234 Frankfurt a. d. Oder",
      "latitude": 52.3500732,
      "longitude": 14.5199148,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Spitzkrugring 1 A, 15234 Frankfurt / Oder",
      "latitude": 52.36219999999999,
      "longitude": 14.5248199,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Diedersdorfer Straße 12A, 15306 Seelow",
      "latitude": 52.5292584,
      "longitude": 14.3666685,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Otto-Grotewohl-Ring 72, 15344 Strausberg",
      "latitude": 52.57365859999999,
      "longitude": 13.8971163,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Frankfurter Chaussee 48, 15370 Fredersdorf-Vogelsdorf",
      "latitude": 52.4969446,
      "longitude": 13.7437546,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Juri-Gagarin-Straße, 15517 Fürstenwalde",
      "latitude": 52.3749961,
      "longitude": 14.0762151,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alte Langewahler Chaussee 11, 15517 Fürstenwalde",
      "latitude": 52.3357627,
      "longitude": 14.0810501,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichstraße 13, 15537 Erkner",
      "latitude": 52.4224393,
      "longitude": 13.7504179,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wiesenstraße 7, 15711 Königs Wusterhausen",
      "latitude": 52.29503829999999,
      "longitude": 13.6216212,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Chausseestraße 1, 15745 Wildau",
      "latitude": 52.3143666,
      "longitude": 13.6040184,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stubenrauchstraße 60 a, 15806 Zossen",
      "latitude": 52.2241166,
      "longitude": 13.4397519,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Lückefeld 97, 15831 Blankenfelde-Mahlow",
      "latitude": 52.3572036,
      "longitude": 13.4322619,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Fährstraße 35, 15890 Eisenhüttenstadt",
      "latitude": 52.1438228,
      "longitude": 14.6484612,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Angermünder Straße 66, 16225 Eberswalde",
      "latitude": 52.8497549,
      "longitude": 13.7782326,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eberswalder Straße 87, 16227 Eberswalde",
      "latitude": 52.8381443,
      "longitude": 13.7372244,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eduardshof 3, 16259 Bad Freienwalde",
      "latitude": 52.79449109999999,
      "longitude": 14.0422038,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Platz Der Befreiung 6, 16303 Schwedt / Oder",
      "latitude": 53.0602437,
      "longitude": 14.2835188,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Landsberger Chaussee 17, 16356 Ahrensfelde",
      "latitude": 52.5493491,
      "longitude": 13.5998086,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedensstr. 8, 16515 Oranienburg",
      "latitude": 52.7504763,
      "longitude": 13.2242857,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schönfließer Straße 66, 16540 Hohen Neuendorf",
      "latitude": 52.671318,
      "longitude": 13.2808696,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Postplatz 4-4c, 16761 Hennigsdorf",
      "latitude": 52.637068,
      "longitude": 13.2049538,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Junckerstraße 26, 16816 Neuruppin",
      "latitude": 52.9164361,
      "longitude": 12.7865968,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Meyenburger Chaussee 36, 16909 Wittstock",
      "latitude": 53.174152,
      "longitude": 12.4786785,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Torfsteg 11, 17033 Neubrandenburg",
      "latitude": 53.55650929999999,
      "longitude": 13.2508878,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Juri-Gagarin-Ring 40, 17036 Neubrandenburg",
      "latitude": 53.5564194,
      "longitude": 13.293585,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Drönnewitzer Straße 1, 17109 Demmin",
      "latitude": 53.9060307,
      "longitude": 13.0131566,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Strelitzer Str. 24, 17235 Neustrelitz",
      "latitude": 53.3595559,
      "longitude": 13.0686108,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Georg-Dreke-Ring 60, 17291 Prenzlau",
      "latitude": 53.31843,
      "longitude": 13.869,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stettiner Chaussee 1-3, 17309 Pasewalk",
      "latitude": 53.504182,
      "longitude": 13.9998242,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pütterweg 1, 18059 Rostock",
      "latitude": 54.0763416,
      "longitude": 12.1213727,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Handwerkstraße 1, 18069 Rostock - Schmarl",
      "latitude": 54.1241105,
      "longitude": 12.0722776,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hansestraße 37, 18182 Bentwisch",
      "latitude": 54.1158809,
      "longitude": 12.1917379,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hamburger Allee 140D, 19063 Schwerin",
      "latitude": 53.59246700000001,
      "longitude": 11.4662093,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wahrenbergerstr., 19322 Wittenberge",
      "latitude": 52.9938119,
      "longitude": 11.7327683,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ziegendorfer Chaussee, 19370 Parchim",
      "latitude": 53.4215577,
      "longitude": 11.825459,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bergedorfer Straße 106, 21029 Hamburg",
      "latitude": 53.48736100000001,
      "longitude": 10.2066965,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marktpassage 5, 21149 Hamburg",
      "latitude": 53.4702999,
      "longitude": 9.8516469,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Alten Eisenwerk 2, 21339 Lüneburg",
      "latitude": 53.2587446,
      "longitude": 10.410634,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Böcklerstraße 7, 21339 Lüneburg",
      "latitude": 53.2733927,
      "longitude": 10.4044876,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Freiburger Straße 2, 21682 Stade",
      "latitude": 53.604959,
      "longitude": 9.475995,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Helbingtwiete 7/9, 22047 Hamburg-Wandsbek",
      "latitude": 53.5875906,
      "longitude": 10.0950389,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bramfelder Dorfplatz 18, 22179 Hamburg",
      "latitude": 53.6124565,
      "longitude": 10.0782092,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Krohnstieg 4, 22415 Hamburg",
      "latitude": 53.65004399999999,
      "longitude": 10.0163651,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nedderfeld 70, 22529 Hamburg",
      "latitude": 53.6010252,
      "longitude": 9.9747341,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eckhoffplatz 1, 22547 Hamburg",
      "latitude": 53.59178319999999,
      "longitude": 9.8738872,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stresemannstr. 300, 22761 Hamburg",
      "latitude": 53.5629979,
      "longitude": 9.932013,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 7, 23795 Bad Segeberg",
      "latitude": 53.9339532,
      "longitude": 10.3107186,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ratzeburger Straße 15-19, 23843 Bad Oldesloe",
      "latitude": 53.80789370000001,
      "longitude": 10.3885076,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marktstraße 1, 23968 Gägelow",
      "latitude": 53.9024242,
      "longitude": 11.3789469,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Skandinaviendamm 299, 24109 Kiel",
      "latitude": 54.3201103,
      "longitude": 10.0519699,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hamburger Straße 8, 24558 Henstedt-Ulzburg",
      "latitude": 53.7944609,
      "longitude": 9.9799749,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rudolf-Diesel-Straße 1, 25524 Itzehoe",
      "latitude": 53.920184,
      "longitude": 9.510194,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marschstraße 1, 25746 Heide",
      "latitude": 54.1952051,
      "longitude": 9.089586599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stubbenweg 27, 26125 Oldenburg",
      "latitude": 53.1827407,
      "longitude": 8.228050999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedenstraße 70, 26386 Wilhelmshaven",
      "latitude": 53.535283,
      "longitude": 8.106699299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 1A, 26506 Norden",
      "latitude": 53.5904004,
      "longitude": 7.215804099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nüttermoorer Str. 2, 26789 Leer",
      "latitude": 53.2609152,
      "longitude": 7.457391199999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Deverweg 39 - 45, 26871 Papenburg",
      "latitude": 53.08474640000001,
      "longitude": 7.3830486,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schulstraße 22, 27283 Verden (Aller)",
      "latitude": 52.9526895,
      "longitude": 9.2355888,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bohmsiel 1, 27572 Bremerhaven",
      "latitude": 53.4910255,
      "longitude": 8.6001798,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pferdebade 6, 27580 Bremerhaven",
      "latitude": 53.57163809999999,
      "longitude": 8.599226,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Reinersweg 2, 27751 Delmenhorst",
      "latitude": 53.0385767,
      "longitude": 8.6779706,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stedinger Straße 101, 27753 Delmenhorst",
      "latitude": 53.0615195,
      "longitude": 8.632624999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sebaldsbrücker Heerstr. 155, 28309 Bremen",
      "latitude": 53.05952139999999,
      "longitude": 8.892446399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zum Alten Speicher 1, 28759 Bremen-Grohn",
      "latitude": 53.1678361,
      "longitude": 8.6268076,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Celler Straße 55, 29303 Bergen",
      "latitude": 52.7998487,
      "longitude": 9.9700714,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Marx-Straße 13, 29410 Salzwedel",
      "latitude": 52.8567855,
      "longitude": 11.1507767,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 2-4, 29525 Uelzen",
      "latitude": 52.9667578,
      "longitude": 10.5521871,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heinrich-Hertz-Straße 9, 29664 Walsrode",
      "latitude": 52.864653,
      "longitude": 9.6148505,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rundestraße 5, 30161 Hannover",
      "latitude": 52.3800791,
      "longitude": 9.740185499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Krepenstraße 5, 30165 Hannover",
      "latitude": 52.4089583,
      "longitude": 9.710918699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bornumer Str. 141, 30453 Hannover",
      "latitude": 52.3521207,
      "longitude": 9.694804099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Havelser Straße 2-8, 30823 Garbsen",
      "latitude": 52.4238697,
      "longitude": 9.597106799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Münchener Str.3, 30880 Laatzen",
      "latitude": 52.318803,
      "longitude": 9.7945765,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ladestraße 1, 30890 Barsinghausen",
      "latitude": 52.3052345,
      "longitude": 9.467722,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sedanstraße 16 - 18, 31061 Alfeld (Leine)",
      "latitude": 51.9879499,
      "longitude": 9.822001799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Römerring 8 - 10, 31137 Hildesheim",
      "latitude": 52.15773,
      "longitude": 9.93893,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heinrich-Hertz-Straße 12, 31228 Peine",
      "latitude": 52.3397376,
      "longitude": 10.254976,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kräher Weg 1, 31582 Nienburg/Weser",
      "latitude": 52.6422665,
      "longitude": 9.224587399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Helweg 4, 31655 Stadthagen",
      "latitude": 52.3293303,
      "longitude": 9.2181336,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hannoversche Straße 15, 31675 Bückeburg",
      "latitude": 52.2669023,
      "longitude": 9.065748,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Werkstraße 17, 31789 Hameln",
      "latitude": 52.0754783,
      "longitude": 9.3285326,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Werrestraße 69, 32049 Herford",
      "latitude": 52.1253997,
      "longitude": 8.6744366,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ernst-Hilker-Straße 15, 32758 Detmold",
      "latitude": 51.95272,
      "longitude": 8.8862913,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Klingenbergstraße 31, 32758 Detmold",
      "latitude": 51.95282899999999,
      "longitude": 8.856194799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Husener Straße 121, 33100 Paderborn-Kernstadt",
      "latitude": 51.7029278,
      "longitude": 8.7684345,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Riemekestraße 37, 33102 Paderborn",
      "latitude": 51.7156522,
      "longitude": 8.7400448,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bentelerstraße 4, 33104 Paderborn",
      "latitude": 51.7435534,
      "longitude": 8.7266365,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Anger 22, 33332 Gütersloh",
      "latitude": 51.8997193,
      "longitude": 8.401449099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 36, 33378 Rheda-Wiedenbrück",
      "latitude": 51.8528408,
      "longitude": 8.2871008,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Franzgraben 40-42, 34125 Kassel",
      "latitude": 51.3206339,
      "longitude": 9.517546399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Flechtdorfer Straße 5, 34497 Korbach",
      "latitude": 51.2776088,
      "longitude": 8.869539399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Osttangente 6, 34613 Schwalmstadt",
      "latitude": 50.91239419999999,
      "longitude": 9.1982097,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf der Breitenwiese 28, 35216 Biedenkopf",
      "latitude": 50.9030755,
      "longitude": 8.5395969,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Tannenweg 97, 35440 Linden",
      "latitude": 50.5379586,
      "longitude": 8.6715612,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rothweg 4, 35457 Lollar",
      "latitude": 50.6396787,
      "longitude": 8.7019704,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Forum 1, 35576 Wetzlar",
      "latitude": 50.5648614,
      "longitude": 8.5055093,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Rosengarten 7, 36037 Fulda",
      "latitude": 50.5497284,
      "longitude": 9.671218099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 10, 36433 Bad Salzungen",
      "latitude": 50.8144145,
      "longitude": 10.2277431,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kurze-Geismar-Straße 26, 28, 3, 37073 Göttingen",
      "latitude": 51.5310897,
      "longitude": 9.938277000000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Elliehäuser Weg 23, 37079 Göttingen",
      "latitude": 51.548963,
      "longitude": 9.9001542,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rückingsallee 2, 37154 Northeim",
      "latitude": 51.7092379,
      "longitude": 10.0023147,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thüringer Straße, 37269 Eschwege",
      "latitude": 51.1999039,
      "longitude": 10.0255603,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 48, 37327 Leinefelde",
      "latitude": 51.3876566,
      "longitude": 10.3279576,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Herzberger Landstr. 8, 37520 Osterode",
      "latitude": 51.7141492,
      "longitude": 10.2744808,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Walter-Poser-Straße 2, 37574 Einbeck",
      "latitude": 51.8194337,
      "longitude": 9.849992900000002,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bülte 4, 37603 Holzminden",
      "latitude": 51.84056100000001,
      "longitude": 9.4665498,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Brenkhäuser Straße 14A, 37671 Höxter",
      "latitude": 51.7793186,
      "longitude": 9.380744,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Senefelderstraße 5, 38124 Braunschweig",
      "latitude": 52.2168098,
      "longitude": 10.5282534,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Albert-Schweitzer-Straße 1, 38226 Salzgitter",
      "latitude": 52.15143630000001,
      "longitude": 10.3294156,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Magdeburger Berg 5, 38350 Helmstedt",
      "latitude": 52.2163213,
      "longitude": 11.0298964,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hildesheimer Straße 52a, 38640 Goslar",
      "latitude": 51.91276190000001,
      "longitude": 10.4199556,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Braunschweiger Str. 83-88, 38820 Halberstadt",
      "latitude": 51.898774,
      "longitude": 11.0397198,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Schreiberteich 3, 38855 Wernigerode",
      "latitude": 51.8426348,
      "longitude": 10.7815867,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kantstraße 5A, 39104 Magdeburg",
      "latitude": 52.1301946,
      "longitude": 11.6303849,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zum Handelshof 1, 39108 Magdeburg",
      "latitude": 52.1208667,
      "longitude": 11.6143541,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Halberstädterstraße 182-186, 39112 Magdeburg",
      "latitude": 52.10723549999999,
      "longitude": 11.5922374,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lübecker Straße 122, 39124 Magdeburg",
      "latitude": 52.1542055,
      "longitude": 11.6385445,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Calbesche Str. 31, 39218 Schönebeck/Elbe",
      "latitude": 51.9960977,
      "longitude": 11.7250254,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alte Brücke 3, 39261 Zerbst",
      "latitude": 51.9660945,
      "longitude": 12.0863551,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Legefeld 4, 39307 Genthin",
      "latitude": 52.4172587,
      "longitude": 12.1590659,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrich-Schmelzer-Straße 2, 39340 Haldensleben",
      "latitude": 52.2835359,
      "longitude": 11.431932,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lüneburger Straße 1, 39387 Oschersleben",
      "latitude": 52.0299547,
      "longitude": 11.2288975,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hecklinger Straße 50, 39418 Staßfurt",
      "latitude": 51.8512369,
      "longitude": 11.5604753,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dr.-Kurt-Schumacher-Straße 1, 39576 Stendal",
      "latitude": 52.5998712,
      "longitude": 11.8352001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Busch-Horst-Weg 2, 39638 Gardelegen",
      "latitude": 52.5160847,
      "longitude": 11.4029003,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Professor-Neyses-Platz 5, 40476 Düsseldorf",
      "latitude": 51.2503602,
      "longitude": 6.7908824,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichstraße/Schöneberger S, 40789 Monheim",
      "latitude": 51.0870808,
      "longitude": 6.8901166,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Reyerhütte 1, 41065 Mönchengladbach",
      "latitude": 51.1920576,
      "longitude": 6.4594057,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aachener Straße 387, 41069 Mönchengladbach",
      "latitude": 51.1828848,
      "longitude": 6.4113263,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Johannes-Cleven-Straße 4, 41334 Nettetal",
      "latitude": 51.3051278,
      "longitude": 6.2725805,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bataverstraße 93, 41462 Neuss-Vogelsang",
      "latitude": 51.23127239999999,
      "longitude": 6.6849307,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Römerstraße 120, 41462 Neuss",
      "latitude": 51.2126137,
      "longitude": 6.683364699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ostwall 31, 41515 Grevenbroich",
      "latitude": 51.0887353,
      "longitude": 6.5941101,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kanalstraße 51-55, 41748 Viersen",
      "latitude": 51.2619839,
      "longitude": 6.404883799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bruchweg 27, 41751 Viersen-Dülken",
      "latitude": 51.251334,
      "longitude": 6.3271153,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Antwerpener Straße 4, 41812 Erkelenz",
      "latitude": 51.0778036,
      "longitude": 6.3071481,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Landabsatz 7, 41836 Hückelhoven",
      "latitude": 51.0557323,
      "longitude": 6.220985799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Elberfelder Str. 8, 42285 Wuppertal-Barmen",
      "latitude": 51.2566065,
      "longitude": 7.1651245,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kaiserstraße 39-41, 42329 Wuppertal",
      "latitude": 51.2330279,
      "longitude": 7.0738887,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichstraße 262, 42551 Velbert",
      "latitude": 51.3360362,
      "longitude": 7.050208,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedenstraße 64, 42699 Solingen",
      "latitude": 51.1531106,
      "longitude": 7.0229475,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stresemannstraße 37, 42719 Solingen",
      "latitude": 51.1807604,
      "longitude": 7.0409329,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Presover Straße 20, 42859 Remscheid",
      "latitude": 51.1768079,
      "longitude": 7.2025954,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Körner Hellweg 142, 44143 Dortmund",
      "latitude": 51.5184606,
      "longitude": 7.5110329,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bornstraße 160A, 44145 Dortmund",
      "latitude": 51.5289347,
      "longitude": 7.4705885,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Luisenglück 43, 44225 Dortmund-Hombruch",
      "latitude": 51.4765056,
      "longitude": 7.4325137,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aplerbecker Marktplatz 7-10, 44287 Dortmund",
      "latitude": 51.4910852,
      "longitude": 7.5561371,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heimbrügge 5 - 7, 44359 Dortmund",
      "latitude": 51.5696585,
      "longitude": 7.3803331,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Merschstraße 19, 44534 Lünen",
      "latitude": 51.6154856,
      "longitude": 7.5292773,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Widumer Tor 1, 44575 Castrop-Rauxel",
      "latitude": 51.54857930000001,
      "longitude": 7.3067607,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 211, 44649 Herne",
      "latitude": 51.5278503,
      "longitude": 7.159787199999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Einkaufszentrum 2, 44791 Bochum",
      "latitude": 51.4946979,
      "longitude": 7.286268400000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Speicherstraße 2, 44809 Bochum",
      "latitude": 51.5001683,
      "longitude": 7.204613,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alter Markt 1, 44866 Bochum",
      "latitude": 51.4821697,
      "longitude": 7.1306851,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ottostraße 40-43, 44867 Bochum-Wattenscheid",
      "latitude": 51.4721072,
      "longitude": 7.1206692,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ümminger Straße 90, 44892 Bochum",
      "latitude": 51.4703411,
      "longitude": 7.292751399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Berthold-Beitz-Boulevard 500, 45141 Essen",
      "latitude": 51.4734729,
      "longitude": 7.000060899999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Altenessener Straße 411, 45329 Essen",
      "latitude": 51.4965634,
      "longitude": 7.0071631,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gerichtsstraße 25, 45355 Essen",
      "latitude": 51.47308760000001,
      "longitude": 6.9526587,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Große Weilstraße 18-20, 45525 Hattingen",
      "latitude": 51.3973427,
      "longitude": 7.182562999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Löhrhof 1, 45657 Recklinghausen",
      "latitude": 51.6133281,
      "longitude": 7.2007737,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kurt-Schumacher-Straße 3, 45699 Herten",
      "latitude": 51.5943676,
      "longitude": 7.1364721,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Berliner Platz 14, 45739 Oer-Erkenschwick",
      "latitude": 51.6403644,
      "longitude": 7.260012400000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marler Stern 57, 45768 Marl",
      "latitude": 51.65461579999999,
      "longitude": 7.0991189,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lipper Weg 4, 45770 Marl",
      "latitude": 51.6634849,
      "longitude": 7.128495,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Concordia-Straße 32, 46049 Oberhausen",
      "latitude": 51.4738316,
      "longitude": 6.846685399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstr. 57, 46145 Oberhausen",
      "latitude": 51.5163295,
      "longitude": 6.8502883,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Berliner Platz 8, 46236 Bottrop",
      "latitude": 51.5227971,
      "longitude": 6.929683799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Westwall 61, 46282 Dorsten, Mercaden",
      "latitude": 51.6632525,
      "longitude": 6.964044599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heidener Str. 32, 46325 Borken",
      "latitude": 51.84662729999999,
      "longitude": 6.8617735,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Normannstraße 31, 46446 Emmerich am Rhein",
      "latitude": 51.843629,
      "longitude": 6.2518957,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf Der Höhe 20, 47059 Duisburg",
      "latitude": 51.4404067,
      "longitude": 6.756221399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrich-Ebert-Straße 2, 47119 Duisburg",
      "latitude": 51.4567133,
      "longitude": 6.7364241,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Duisburger Straße 303, 47166 Duisburg",
      "latitude": 51.4969064,
      "longitude": 6.7657953,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kometenplatz 10, 47179 Duisburg",
      "latitude": 51.5254912,
      "longitude": 6.744242799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kirchstraße 96, 47198 Duisburg",
      "latitude": 51.4507712,
      "longitude": 6.6854231,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Römerstraße 570, 47443 Moers-Hochstraß",
      "latitude": 51.4549307,
      "longitude": 6.6581129,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Moerser Straße 290, 47475 Kamp-Lintfort",
      "latitude": 51.4998263,
      "longitude": 6.549573,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Olmerstraße 1, 47533 Kleve",
      "latitude": 51.80254650000001,
      "longitude": 6.1688677,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Flutstraße 81, 47533 Kleve",
      "latitude": 51.7988452,
      "longitude": 6.138440699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf Dem Wall 15, 47574 Goch",
      "latitude": 51.6732816,
      "longitude": 6.160546699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Westwall 1 / Bahnhofstraße 8, 47608 Geldern",
      "latitude": 51.5161402,
      "longitude": 6.3205491,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Beginenpad 5, 47638 Straelen",
      "latitude": 51.4426628,
      "longitude": 6.264664,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Katthagen 6 - 8, 48282 Emsdetten",
      "latitude": 52.17392270000001,
      "longitude": 7.531079199999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bentheimer Straße 118 B, 48529 Nordhorn",
      "latitude": 52.4228633,
      "longitude": 7.0749027,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hansestraße 2 (Gegenüber Bahnh, 48653 Coesfeld",
      "latitude": 51.939588,
      "longitude": 7.1658811,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Andreasstraße 3-5, 48683 Ahaus",
      "latitude": 52.0661353,
      "longitude": 6.9647217,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kurt-Schumacher-Damm 52-54, 49078 Osnabrück",
      "latitude": 52.2656326,
      "longitude": 8.0053587,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ringeler Straße 24 - 26, 49525 Lengerich",
      "latitude": 52.1812021,
      "longitude": 7.854202399999998,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Robert-Bosch-Straße 4, 49593 Bersenbrück",
      "latitude": 52.5557312,
      "longitude": 7.934894,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Soestenstraße 11, 49661 Cloppenburg",
      "latitude": 52.8451846,
      "longitude": 8.0356429,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Neuen Markt 1, 49716 Meppen",
      "latitude": 52.69208010000001,
      "longitude": 7.288902599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 23, 50126 Bergheim",
      "latitude": 50.95299439999999,
      "longitude": 6.641873299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sindorfer Straße 65 - 69, 50171 Kerpen",
      "latitude": 50.8796511,
      "longitude": 6.6932487,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Farehamstraße 5, 50259 Pulheim",
      "latitude": 50.9989809,
      "longitude": 6.800790999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Boltensternstraße 104 - 112, 50735 Köln",
      "latitude": 50.9727156,
      "longitude": 6.9780335,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thebäer Straße 9, 50823 Köln",
      "latitude": 50.94708319999999,
      "longitude": 6.9220093,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Frankfurter Straße 87A, 51065 Köln",
      "latitude": 50.9590197,
      "longitude": 7.015223799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kalker Hauptstraße 112, 51103 Köln",
      "latitude": 50.93762330000001,
      "longitude": 7.0016558,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ostmerheimer Straße 198, 51109 Köln",
      "latitude": 50.9421347,
      "longitude": 7.0509672,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Refrather Weg 1, 51465 Bergisch Gladbach",
      "latitude": 50.9829131,
      "longitude": 7.1232729,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dieringhauser Straße 16, 51645 Gummersbach",
      "latitude": 50.9832524,
      "longitude": 7.528116499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Breslauer Straße 35, 52068 Aachen",
      "latitude": 50.7831704,
      "longitude": 6.124761599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Vaalser Straße 242 - 246, 52074 Aachen",
      "latitude": 50.7697588,
      "longitude": 6.058498800000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstr. 25, 52134 Herzogenrath",
      "latitude": 50.8700872,
      "longitude": 6.0949528,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schumanstraße 4, 52146 Würselen",
      "latitude": 50.8079246,
      "longitude": 6.152490299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf Beuel 19, 52156 Monschau",
      "latitude": 50.5775612,
      "longitude": 6.2571769,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zweifaller Straße 68, 52222 Stolberg",
      "latitude": 50.7640314,
      "longitude": 6.2315083,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 37, 52477 Alsdorf",
      "latitude": 50.8717311,
      "longitude": 6.1578943,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Herzog-Wilhelm-Straße 17-39, 52511 Geilenkirchen",
      "latitude": 50.9630874,
      "longitude": 6.1186338,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Humboldtstraße 26, 52525 Heinsberg",
      "latitude": 51.0695293,
      "longitude": 6.1101002,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Oppelner Straße 128, 53119 Bonn",
      "latitude": 50.7505217,
      "longitude": 7.045944200000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriestraße 10, 53489 Sinzig",
      "latitude": 50.5473901,
      "longitude": 7.258532399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelm-Ostwald-Straße 1F, 53721 Siegburg",
      "latitude": 50.7929021,
      "longitude": 7.223428899999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Walterscheid-Müller-Strasße 14, 53797 Lohmar",
      "latitude": 50.8390281,
      "longitude": 7.2061495,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Theodor-Heuss-Ring 55, 53840 Troisdorf",
      "latitude": 50.8130713,
      "longitude": 7.1560985,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ostallee 3-7, 54290 Trier",
      "latitude": 49.7565296,
      "longitude": 6.650204800000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aachener Straße 58, 54294 Trier",
      "latitude": 49.7553868,
      "longitude": 6.624306499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Saar-Mosel-Platz 2, 54329 Konz",
      "latitude": 49.6989968,
      "longitude": 6.5752615,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An der Römerstraße, 54411 Hermeskeil",
      "latitude": 49.6771024,
      "longitude": 6.9523769,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kölner Straße 11, 54634 Bitburg",
      "latitude": 49.977228,
      "longitude": 6.526439,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rheinallee 120, 55120 Mainz",
      "latitude": 50.02666019999999,
      "longitude": 8.2293368,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Hohen Brückenweg 3, 55276 Oppenheim",
      "latitude": 49.8463046,
      "longitude": 8.3619906,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwabenheimer Weg 5, 55543 Bad Kreuznach",
      "latitude": 49.847727,
      "longitude": 7.8774599,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 131, 56170 Bendorf",
      "latitude": 50.4253134,
      "longitude": 7.571727099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Poststraße 7, 56457 Westerburg",
      "latitude": 50.55485290000001,
      "longitude": 7.973308500000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heddesdorfer Straße 11, 56564 Neuwied",
      "latitude": 50.4318538,
      "longitude": 7.4628285,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Koblenzer Straße 51, 56626 Andernach",
      "latitude": 50.4381744,
      "longitude": 7.416376499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Koblenzer Straße 174 A, 56727 Mayen",
      "latitude": 50.3270367,
      "longitude": 7.248117799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hagener Straße 133, 57072 Siegen",
      "latitude": 50.88777289999999,
      "longitude": 8.028533399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Fludersbach 126, 57074 Siegen",
      "latitude": 50.8634554,
      "longitude": 8.038746999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marburger Straße 41, 57223 Kreuztal",
      "latitude": 50.9617381,
      "longitude": 7.9945852,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Martinstraße 36, 57462 Olpe",
      "latitude": 51.0289112,
      "longitude": 7.850842900000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Siegstraße 14, 57548 Kirchen",
      "latitude": 50.80082760000001,
      "longitude": 7.8808726,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Freiligrathstraße 51, 58099 Hagen / Westfalen",
      "latitude": 51.3780302,
      "longitude": 7.4621865,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auf dem Lölfert 50, 58119 Hagen",
      "latitude": 51.3639948,
      "longitude": 7.5841401,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Dohrbaum 6-8, 58239 Schwerte",
      "latitude": 51.4507655,
      "longitude": 7.5640611,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Großer Markt 7, 58285 Gevelsberg",
      "latitude": 51.3206071,
      "longitude": 7.3388483,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Carl-Bönnhoff-Straße 1, 58300 Wetter (Ruhr)",
      "latitude": 51.3871417,
      "longitude": 7.3862059,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Breite Straße 23, 58452 Witten",
      "latitude": 51.4392252,
      "longitude": 7.3289639,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 26, 58553 Halver",
      "latitude": 51.1844043,
      "longitude": 7.5034044,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Theodor-Heuss-Ring 11, 58636 Iserlohn",
      "latitude": 51.3762172,
      "longitude": 7.699345799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstraße 5, 58638 Iserlohn",
      "latitude": 51.3836141,
      "longitude": 7.674677399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Holzener Straße 1-13, 58708 Menden",
      "latitude": 51.4488573,
      "longitude": 7.7583147,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ökonomierat-Peitzmeier-Platz 2, 59063 Hamm",
      "latitude": 51.6651539,
      "longitude": 7.8280584,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelmstraße 197, 59067 Hamm",
      "latitude": 51.6646669,
      "longitude": 7.7845527,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Münsterstraße 183, 59073 Hamm-Heessen",
      "latitude": 51.7022941,
      "longitude": 7.799201999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Römerstraße 16, 59075 Hamm-Bockum-Hövel",
      "latitude": 51.6927508,
      "longitude": 7.779503200000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zollpost 15, 59174 Kamen",
      "latitude": 51.5789923,
      "longitude": 7.6702908,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "An der Bummannsburg 1, 59192 Bergkamen-Rünthe",
      "latitude": 51.651478,
      "longitude": 7.6783753,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Töddinghauserstraße, 59192 Bergkamen",
      "latitude": 51.6040712,
      "longitude": 7.6297292,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kleiwellenfeld 16, 59229 Ahlen",
      "latitude": 51.7393168,
      "longitude": 7.8776375,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Grevenbrede 10, 59269 Beckum",
      "latitude": 51.7727745,
      "longitude": 8.0395265,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Soester Straße 26, 59457 Werl",
      "latitude": 51.5492104,
      "longitude": 7.916784199999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Senator-Schwartz-Ring 24, 59494 Soest",
      "latitude": 51.5609121,
      "longitude": 8.0808112,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Planckstraße 1, 59557 Lippstadt",
      "latitude": 51.6554499,
      "longitude": 8.3460043,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Westring 10, 59759 Arnsberg-Bruchhausen",
      "latitude": 51.4299188,
      "longitude": 8.0112493,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wächtersbacher Straße 75, 60386 Frankfurt am Main",
      "latitude": 50.1314216,
      "longitude": 8.750346,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kettelerstraße 10, 61231 Bad Nauheim",
      "latitude": 50.3795681,
      "longitude": 8.7323936,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ober-Rodener Straße 13, 15 Und, 63322 Rödermark",
      "latitude": 49.9752527,
      "longitude": 8.804449,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Steinheimer Tor 3, 63450 Hanau",
      "latitude": 50.1319527,
      "longitude": 8.9118374,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weißkirchenweg 11, 63571 Gelnhausen",
      "latitude": 50.18818659999999,
      "longitude": 9.1811046,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Würzburger Straße 144 - 148, 63743 Aschaffenburg",
      "latitude": 49.9681041,
      "longitude": 9.1653118,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eberstädter Straße 200, 64319 Pfungstadt",
      "latitude": 49.8137426,
      "longitude": 8.618929399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rudolf-Diesel-Straße 26 A, 64331 Weiterstadt",
      "latitude": 49.9028588,
      "longitude": 8.6081516,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrich-Ebert-Straße 15 - 17, 64720 Michelstadt",
      "latitude": 49.6763092,
      "longitude": 9.0013466,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Im Flürchen 3, 64807 Dieburg",
      "latitude": 49.8877138,
      "longitude": 8.8467729,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alzeyer Straße 11, 65428 Rüsselsheim",
      "latitude": 49.9839388,
      "longitude": 8.4011556,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Flörsheimer Straße 3, 65479 Raunheim",
      "latitude": 50.0092884,
      "longitude": 8.4358019,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Westerwaldstraße 111-113, 65549 Limburg",
      "latitude": 50.3972797,
      "longitude": 8.056370900000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Saarbrücker Str. 262, 66292 Riegelsberg",
      "latitude": 49.322677,
      "longitude": 6.9391364,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hallerstraße 21, 66333 Völklingen",
      "latitude": 49.2437918,
      "longitude": 6.8409118,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Grubenweg 7, 66386 St. Ingbert",
      "latitude": 49.2825915,
      "longitude": 7.103832499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kirkeler Straße 50, 66538 Neunkirchen",
      "latitude": 49.3295716,
      "longitude": 7.1842868,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rieffstraße 8 -12, 66663 Merzig",
      "latitude": 49.4359537,
      "longitude": 6.6330167,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Daimlerstraße 4, 66763 Dillingen",
      "latitude": 49.3684316,
      "longitude": 6.7137974,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Poststraße 9, 66822 Lebach",
      "latitude": 49.4087843,
      "longitude": 6.9053705,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Franz-Birringer-Straße 27, 66839 Schmelz",
      "latitude": 49.4374231,
      "longitude": 6.8714203,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Torfstraße 10, 66849 Landstuhl",
      "latitude": 49.4132009,
      "longitude": 7.552975900000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zweibrücker Straße 230, 66954 Pirmasens",
      "latitude": 49.2261946,
      "longitude": 7.5919588,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wiesenstraße 5, 66954 Pirmasens",
      "latitude": 49.198549,
      "longitude": 7.6021703,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Waldspitzweg 1, 67105 Schifferstadt",
      "latitude": 49.3837748,
      "longitude": 8.3911132,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wormser Straße 109, 67227 Frankenthal",
      "latitude": 49.5471783,
      "longitude": 8.351410099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kirchheimer Straße 39, 67269 Grünstadt",
      "latitude": 49.5612197,
      "longitude": 8.1689121,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Auestraße 22, 67346 Speyer",
      "latitude": 49.3335309,
      "longitude": 8.438536899999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Mainzer Straße 150, 67547 Worms",
      "latitude": 49.6562062,
      "longitude": 8.3596401,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schönauer Straße 8, 67547 Worms",
      "latitude": 49.6251804,
      "longitude": 8.359226699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pariser Str.123, 67655 Kaiserslautern",
      "latitude": 49.4424827,
      "longitude": 7.7513553,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Maybachstraße 28, 68169 Mannheim",
      "latitude": 49.5031975,
      "longitude": 8.475447299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rosenstraße 70, 68535 Edingen-Neckarhausen",
      "latitude": 49.4534967,
      "longitude": 8.5887582,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Carl-Theodor-Straße 33, 68723 Schwetzingen",
      "latitude": 49.38527149999999,
      "longitude": 8.577582600000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kurfürstenanlage 61, 69115 Heidelberg",
      "latitude": 49.40461620000001,
      "longitude": 8.6812541,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eppelheimer Straße 78, 69123 Heidelberg",
      "latitude": 49.403916,
      "longitude": 8.6462653,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hertzstraße 1, 69126 Heidelberg",
      "latitude": 49.3668948,
      "longitude": 8.6856663,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gewerbestraße 19, 69221 Dossenheim",
      "latitude": 49.4541294,
      "longitude": 8.664676499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neuer Weg-Nord 47, 69412 Eberbach",
      "latitude": 49.4731519,
      "longitude": 8.987694399999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Augsburger Straße 460, 70327 Stuttgart",
      "latitude": 48.7756453,
      "longitude": 9.2577859,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wildunger Straße 2-4, 70372 Stuttgart",
      "latitude": 48.8016267,
      "longitude": 9.221417599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aldinger Straße 70, 70378 Stuttgart-Mühlhausen",
      "latitude": 48.8400427,
      "longitude": 9.2283484,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwabenplatz 1, 70563 Stuttgart-Vaihingen",
      "latitude": 48.7307901,
      "longitude": 9.1085734,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rembrandtstraße 47, 70567 Stuttgart-Möhringen",
      "latitude": 48.7309633,
      "longitude": 9.150078299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Merowingerstr. 5, 70736 Fellbach-Schmiden",
      "latitude": 48.8259917,
      "longitude": 9.275769,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stuttgarter Straße 70, 70736 Fellbach",
      "latitude": 48.8135236,
      "longitude": 9.2663274,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Calwer Straße 4, 71063 Sindelfingen",
      "latitude": 48.7071101,
      "longitude": 8.99733,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwertstraße 7, 71065 Sindelfingen",
      "latitude": 48.7051951,
      "longitude": 9.0179426,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schiesstäle 2, 71083 Herrenberg",
      "latitude": 48.5952002,
      "longitude": 8.8607806,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Römerstraße 34, 71229 Leonberg",
      "latitude": 48.79713,
      "longitude": 9.0060064,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sulzbacher Straße 201, 71522 Backnang",
      "latitude": 48.9632014,
      "longitude": 9.4312147,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriestraße 34, 71522 Backnang",
      "latitude": 48.9363357,
      "longitude": 9.444902299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwieberdinger Str. 94, 71636 Ludwigsburg",
      "latitude": 48.8910814,
      "longitude": 9.1693384,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichstraße 124 - 126, 71638 Ludwigsburg",
      "latitude": 48.88879840000001,
      "longitude": 9.209588799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rielingshäuserstraße 15, 71672 Marbach",
      "latitude": 48.9430011,
      "longitude": 9.2664305,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Steinbeisstr. 15, 71711 Steinheim",
      "latitude": 48.9694996,
      "longitude": 9.266486,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Reutlinger Straße 44, 72072 Tübingen",
      "latitude": 48.5141247,
      "longitude": 9.0669214,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Tubinger Straße, 72108 Rottenburg a.N.",
      "latitude": 48.4727494,
      "longitude": 8.943084299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofplatz 15, 72160 Horb Am Neckar",
      "latitude": 48.4417959,
      "longitude": 8.6875252,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Haiterbacher Straße 82-86, 72202 Nagold",
      "latitude": 48.544061,
      "longitude": 8.7299779,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Max-Eyth-Straße 14, 72250 Freudenstadt",
      "latitude": 48.4646395,
      "longitude": 8.432153099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gammertinger Straße 42-44, 72379 Hechingen",
      "latitude": 48.35451399999999,
      "longitude": 8.975553,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kaullastraße 1, 72379 Hechingen",
      "latitude": 48.37486209999999,
      "longitude": 8.961403599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kientenstraße 6, 72458 Albstadt",
      "latitude": 48.2096527,
      "longitude": 9.0184682,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Sigmaringer Straße 154, 72458 Albstadt",
      "latitude": 48.2020792,
      "longitude": 9.0489028,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Georg-Zimmerer-Straße, 72488 Sigmaringen",
      "latitude": 48.0850328,
      "longitude": 9.2114956,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 110, 72525 Münsingen",
      "latitude": 48.4096524,
      "longitude": 9.5082433,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stuttgarter Straße 50, 72555 Metzingen",
      "latitude": 48.54062210000001,
      "longitude": 9.279107699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Europastraße 7, 72622 Nürtingen",
      "latitude": 48.627885,
      "longitude": 9.340646,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Max-Eyth-Straße 34, 72793 Pfullingen",
      "latitude": 48.4775631,
      "longitude": 9.227801099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stuttgarter Straße 2, 73033 Göppingen",
      "latitude": 48.7042529,
      "longitude": 9.6461939,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bleichereistraße 54, 73066 Uhingen",
      "latitude": 48.7138516,
      "longitude": 9.5631215,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wertstraße 12, 73240 Wendlingen",
      "latitude": 48.6727071,
      "longitude": 9.3641597,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neuwiesenstraße 25, 73312 Geislingen an der Steige",
      "latitude": 48.6102933,
      "longitude": 9.8064696,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Julius-Bausch-Straße 27, 73431 Aalen",
      "latitude": 48.8335691,
      "longitude": 10.0948555,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Daimlerstraße 16, 73431 Aalen",
      "latitude": 48.823778,
      "longitude": 10.0582307,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dr.-Adolf-Schneider-Str. 20, 73479 Ellwangen",
      "latitude": 48.9529121,
      "longitude": 10.1686563,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptstraße 6, 73527 Schwäbisch Gmünd",
      "latitude": 48.8043391,
      "longitude": 9.8401785,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lutherstraße 75, 73614 Schorndorf",
      "latitude": 48.8070793,
      "longitude": 9.5417813,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alleenstraße 32, 73730 Esslingen am Neckar OT Ze",
      "latitude": 48.7245728,
      "longitude": 9.3526387,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Olgastraße 57, 74072 Heilbronn",
      "latitude": 49.1364982,
      "longitude": 9.2073235,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stuttgarter Straße 85, 74074 Heilbronn",
      "latitude": 49.1248434,
      "longitude": 9.2232104,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neckargartacher Straße 111, 74080 Heilbronn-Böckingen",
      "latitude": 49.15130389999999,
      "longitude": 9.1960754,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rötelstraße 35, 74172 Neckarsulm",
      "latitude": 49.1722371,
      "longitude": 9.2217772,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriestraße 12, 74177 Bad Friedrichshall",
      "latitude": 49.2304051,
      "longitude": 9.2112562,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Haller Str. 59, 74189 Weinsberg",
      "latitude": 49.1500664,
      "longitude": 9.2985005,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heilbronner Straße 30, 74193 Schwaigern",
      "latitude": 49.1375715,
      "longitude": 9.065202,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Talstraße 4, 74321 Bietigheim-Bissingen",
      "latitude": 48.9607946,
      "longitude": 9.1311584,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Prinz-Eugen-Straße 10, 74321 Bietigheim-Bissingen",
      "latitude": 48.94786,
      "longitude": 9.1336,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Robert-Mayer-Straße 19, 74360 Ilsfeld",
      "latitude": 49.0577592,
      "longitude": 9.2612206,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Steinbeisweg 30, 74523 Schwäbisch Hall",
      "latitude": 49.10457,
      "longitude": 9.702969999999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstraße 22, 74523 Schwäbisch Hall-Hessental",
      "latitude": 49.1092594,
      "longitude": 9.7927469,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schönebürgstraße 78, 74564 Crailsheim",
      "latitude": 49.14055560000001,
      "longitude": 10.0822207,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hallerstr. 195, 74564 Crailsheim",
      "latitude": 49.1398299,
      "longitude": 10.0341136,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Haagweg 11, 74613 Öhringen",
      "latitude": 49.20188659999999,
      "longitude": 9.500319,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bergstr. 9, 74653 Künzelsau",
      "latitude": 49.2774274,
      "longitude": 9.6839058,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Daimlerstraße 1, 74722 Buchen",
      "latitude": 49.52939000000001,
      "longitude": 9.333720000000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Pfalzgraf-Otto-Straße 50, 74821 Mosbach",
      "latitude": 49.3414601,
      "longitude": 9.1257468,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Martin-Luther-Straße 2, 74889 Sinsheim",
      "latitude": 49.2497708,
      "longitude": 8.8648384,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstraße 25, 74906 Bad Rappenau",
      "latitude": 49.2358596,
      "longitude": 9.096554,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Diedelsheimer Höhe 6, 75015 Bretten",
      "latitude": 49.0404049,
      "longitude": 8.6890822,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eisenbahnstraße 1, 75031 Eppingen",
      "latitude": 49.13684079999999,
      "longitude": 8.9153108,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Mühlkanal 4, 75172 Pforzheim",
      "latitude": 48.8862614,
      "longitude": 8.6684324,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hohwiesenweg 2-2a, 75175 Pforzheim",
      "latitude": 48.8965128,
      "longitude": 8.7222186,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelm-Becker-Straße 15, 75179 Pforzheim",
      "latitude": 48.9012349,
      "longitude": 8.6674548,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "In Der Insel 1, 75365 Calw",
      "latitude": 48.7174881,
      "longitude": 8.7365371,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Carl-Metz-Straße 7, 76185 Karlsruhe-Grünwinkel",
      "latitude": 49.0096471,
      "longitude": 8.351905799999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zehntwiesenstraße 47, 76275 Ettlingen",
      "latitude": 48.9453624,
      "longitude": 8.3892825,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rauentaler Straße 65, 76437 Rastatt",
      "latitude": 48.8602472,
      "longitude": 8.237623,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rheinstraße 136, 76532 Baden-Baden-Oos",
      "latitude": 48.78294,
      "longitude": 8.20859,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Thomas-Howie-Straße 1, 76684 Östringen",
      "latitude": 49.2141586,
      "longitude": 8.6948995,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Mainzer Straße 6, 76726 Germersheim",
      "latitude": 49.22964529999999,
      "longitude": 8.366913499999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Posthiusstraße 5-7, 76726 Germersheim",
      "latitude": 49.2080263,
      "longitude": 8.3622271,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Okenstraße 74, 77652 Offenburg",
      "latitude": 48.4814628,
      "longitude": 7.946860099999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marlener Straße 11, 77656 Offenburg",
      "latitude": 48.4698035,
      "longitude": 7.924605100000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Sundheimer Fort 9, 77694 Kehl",
      "latitude": 48.5484737,
      "longitude": 7.837484899999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Güterstraße 10, 77815 Bühl / Baden",
      "latitude": 48.699103,
      "longitude": 8.132357299999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bühlertalstraße 71, 77815 Bühl",
      "latitude": 48.6957759,
      "longitude": 8.147005,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Offenburger Straße 11, 77933 Lahr/Schwarzwald",
      "latitude": 48.3449657,
      "longitude": 7.8413252,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Bahndamm, 77955 Ettenheim",
      "latitude": 48.2597854,
      "longitude": 7.8085974,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dieselstraße 1, 78073 Bad Dürrheim",
      "latitude": 48.0298203,
      "longitude": 8.5249582,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Georg-Fischer-Straße 15, 78224 Singen (Hohentwiel)",
      "latitude": 47.7531367,
      "longitude": 8.846001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Markthallenstr.1, 78315 Radolfzell",
      "latitude": 47.7393787,
      "longitude": 8.970608,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Zähringerplatz 7, 78464 Konstanz",
      "latitude": 47.672469,
      "longitude": 9.1831666,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Carl-Benz-Straße 18 - 22, 78467 Konstanz",
      "latitude": 47.67704070000001,
      "longitude": 9.1481709,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stockacher Straße 146, 78532 Tuttlingen",
      "latitude": 47.9733913,
      "longitude": 8.8267436,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Obere Wiesen 1, 78549 Spaichingen",
      "latitude": 48.0685759,
      "longitude": 8.7496148,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Saline 5, 78628 Rottweil",
      "latitude": 48.14866910000001,
      "longitude": 8.639570599999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstr. 2-4, 78658 Zimmern Ob Rottweil",
      "latitude": 48.17097099999999,
      "longitude": 8.5764873,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 30, 78713 Schramberg",
      "latitude": 48.2321691,
      "longitude": 8.3814192,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Waldkircher Straße 57, 79106 Freiburg",
      "latitude": 48.0125728,
      "longitude": 7.852756899999998,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karl-Bautz-Str. 20, 79312 Emmendingen",
      "latitude": 48.1174787,
      "longitude": 7.8480059,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Robert-Bosch-Str. 6, 79539 Lörrach",
      "latitude": 47.62596079999999,
      "longitude": 7.6750492,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Großfeldstraße 2, 79618 Rheinfelden",
      "latitude": 47.5752153,
      "longitude": 7.7992358,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schaffhauser Straße 90, 79713 Bad Säckingen",
      "latitude": 47.5596043,
      "longitude": 7.9728884,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Brückenstraße 7, 79761 Waldshut-Tiengen",
      "latitude": 47.6245296,
      "longitude": 8.2185927,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bunzlauer Platz 5-7, 80992 München",
      "latitude": 48.1786311,
      "longitude": 11.5053239,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Berg-am-Laim-Straße 117, 81673 München",
      "latitude": 48.1297223,
      "longitude": 11.6260735,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ollenhauerstraße 4, 81737 München",
      "latitude": 48.1001495,
      "longitude": 11.6438221,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Danziger Straße 17, 82194 Gröbenzell",
      "latitude": 48.1862713,
      "longitude": 11.3870107,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schongauer Straße 20, 82380 Peißenberg",
      "latitude": 47.7936655,
      "longitude": 11.0618227,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bayerwaldstr. 2, 82538 Geretsried",
      "latitude": 47.8831018,
      "longitude": 11.4600582,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Äussere Münchener Straße 100, 83026 Rosenheim",
      "latitude": 47.8482247,
      "longitude": 12.09066,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Grassingerstraße 16, 83043 Bad Aibling",
      "latitude": 47.8706314,
      "longitude": 11.9990835,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Theresienstr. 2, 83278 Traunstein",
      "latitude": 47.8718499,
      "longitude": 12.6371559,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Trostberger Straße 23, 83301 Traunreut",
      "latitude": 47.9662106,
      "longitude": 12.6103704,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Verdistraße 15, 83395 Freilassing",
      "latitude": 47.8439659,
      "longitude": 12.969126,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lenggrieser Straße 47, 83646 Bad Tölz",
      "latitude": 47.7538073,
      "longitude": 11.5634303,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ludwig-Erhard-Straße 9, 84034 Landshut",
      "latitude": 48.5404125,
      "longitude": 12.1004253,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Frontenhausener Straße 1, 84130 Dingolfing",
      "latitude": 48.6294845,
      "longitude": 12.4929745,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lindhofstraße 10, 84307 Eggenfelden",
      "latitude": 48.3983876,
      "longitude": 12.7614984,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Teplitzer Straße 12-14, 84478 Waldkraiburg",
      "latitude": 48.2064793,
      "longitude": 12.4077025,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lindach 10, 84489 Burghausen",
      "latitude": 48.1629779,
      "longitude": 12.8045654,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nagelschmidstraße 6, 84524 Neuötting",
      "latitude": 48.2421872,
      "longitude": 12.7063846,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Münchener Straße 146, 85051 Ingolstadt",
      "latitude": 48.7363387,
      "longitude": 11.4390094,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Richard-Wagner-Str. 40, 85057 Ingolstadt",
      "latitude": 48.7740972,
      "longitude": 11.3993034,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Danziger Straße 1, 85221 Dachau",
      "latitude": 48.2585709,
      "longitude": 11.4666595,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Max-Weinberger-Straße 9, 85276 Pfaffenhofen",
      "latitude": 48.5297409,
      "longitude": 11.5314143,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Joseph-Fraunhofer-Straße 31, 85276 Pfaffenhofen A D Ilm",
      "latitude": 48.5382362,
      "longitude": 11.5132033,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstraße 25, 85356 Freising",
      "latitude": 48.38337809999999,
      "longitude": 11.7780978,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Degernpoint M 1, 85368 Moosburg",
      "latitude": 48.46500959999999,
      "longitude": 11.9622601,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dachauer Straße 61, 85435 Erding",
      "latitude": 48.3051032,
      "longitude": 11.8829861,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Burgerfeld 8, 85570 Markt Schwaben",
      "latitude": 48.1917774,
      "longitude": 11.8515644,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Andreas-Danzer-Weg 2, 85716 Unterschleißheim",
      "latitude": 48.2859194,
      "longitude": 11.5608937,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Biberbachstraße 10, 86154 Augsburg",
      "latitude": 48.40095549999999,
      "longitude": 10.8765987,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Meraner Straße 6, 86165 Augsburg",
      "latitude": 48.3805704,
      "longitude": 10.9313902,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gögginger Str. 119, 86199 Augsburg",
      "latitude": 48.3478937,
      "longitude": 10.8773736,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marquardtstraße 1, 86316 Friedberg",
      "latitude": 48.34824140000001,
      "longitude": 10.9961552,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Germanenstraße 16, 86343 Königsbrunn",
      "latitude": 48.28688409999999,
      "longitude": 10.8902175,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Daimlerstr. 18, 86356 Neusäß",
      "latitude": 48.3942433,
      "longitude": 10.8244596,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Brühlstraße 4, 86381 Krumbach",
      "latitude": 48.2434585,
      "longitude": 10.3672599,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Augsburger Straße 43, 86529 Schrobenhausen",
      "latitude": 48.5509256,
      "longitude": 11.2634316,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neurieder Weg 33, 86609 Donauwörth",
      "latitude": 48.720132,
      "longitude": 10.7624838,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Raiffeisenstraße 4, 86720 Nördlingen",
      "latitude": 48.8575129,
      "longitude": 10.4803661,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Penzinger Feld 21, 86899 Landsberg Am Lech",
      "latitude": 48.0560333,
      "longitude": 10.8924925,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Augsburger Straße 28, 87600 Kaufbeuren",
      "latitude": 47.88393620000001,
      "longitude": 10.6354707,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ailinger Straße 109, 88046 Friedrichshafen",
      "latitude": 47.665326,
      "longitude": 9.4851238,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stockerholzstraße 12, 88048 Friedrichshafen",
      "latitude": 47.6633145,
      "longitude": 9.4336045,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Klausenburgerstraße 12, 88069 Tettnang",
      "latitude": 47.6620752,
      "longitude": 9.5722288,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrichshafener Straße 39, 88097 Eriskirch",
      "latitude": 47.6331996,
      "longitude": 9.524051,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weißenauer Straße 15, 88214 Ravensburg-Südstadt",
      "latitude": 47.7678915,
      "longitude": 9.6042393,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Karlstraße 21, 88250 Weingarten",
      "latitude": 47.8069347,
      "longitude": 9.641538800000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Platzstraße 24, 88348 Bad Saulgau",
      "latitude": 48.00853619999999,
      "longitude": 9.511696500000001,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Obere Stegwiesen 10, 88400 Biberach a. d. Riß",
      "latitude": 48.1280771,
      "longitude": 9.802546699999999,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ulmer Str. 13, 88471 Laupheim",
      "latitude": 48.2291568,
      "longitude": 9.8771233,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nußdorfer Straße 101, 88662 Überlingen am Bodensee",
      "latitude": 47.7630766,
      "longitude": 9.1698723,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Blaubeurer Straße 29, 89077 Ulm",
      "latitude": 48.401102,
      "longitude": 9.9742715,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Olgastraße 4, 89129 Langenau",
      "latitude": 48.49166810000001,
      "longitude": 10.1194078,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Heinrich-Hammer-Straße, 89155 Erbach",
      "latitude": 48.324416,
      "longitude": 9.8938411,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Memminger Straße 54, 89231 Neu-Ulm",
      "latitude": 48.3855711,
      "longitude": 10.0042182,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriestraße 37, 89269 Vöhringen",
      "latitude": 48.2879165,
      "longitude": 10.078009,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Johannes-Scheiffele-Str. 3 - 7, 89407 Dillingen a.d.Donau",
      "latitude": 48.5785285,
      "longitude": 10.478079,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Wilhelmstraße 148, 89518 Heidenheim",
      "latitude": 48.6803143,
      "longitude": 10.1283013,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Aalener Straße 20, 89520 Heidenheim",
      "latitude": 48.7137894,
      "longitude": 10.1615838,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Marktstraße 86, 89537 Giengen an der Brenz",
      "latitude": 48.62103159999999,
      "longitude": 10.2498837,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Biberacher Straße 69, 89584 Ehingen",
      "latitude": 48.2716575,
      "longitude": 9.727387,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Fürther Straße 187, 90429 Nürnberg",
      "latitude": 49.4567608,
      "longitude": 11.0367477,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Schwabacher Straße 99, 90439 Nürnberg",
      "latitude": 49.4371445,
      "longitude": 11.0521992,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dianaplatz 23-25, 90443 Nürnberg",
      "latitude": 49.42727499999999,
      "longitude": 11.0663103,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Oppelner Straße 223, 90473 Nürnberg",
      "latitude": 49.4011185,
      "longitude": 11.1353802,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rothenburger Str. 70, 90522 Oberasbach",
      "latitude": 49.43586819999999,
      "longitude": 10.9668013,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rother Straße 1B, 90530 Wendelstein",
      "latitude": 49.334117,
      "longitude": 11.1150659,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Espenpark 30, 90559 Burgthann - Oberferrieden",
      "latitude": 49.316819,
      "longitude": 11.3404302,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Carl-Thiersch-Str. 4, 91052 Erlangen",
      "latitude": 49.5939699,
      "longitude": 11.025939,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Westl. Stadtmauerstraße 27, 91054 Erlangen",
      "latitude": 49.6002176,
      "longitude": 11.001173,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedrich-Wambsganz-Straße 1, 91154 Roth",
      "latitude": 49.24901389999999,
      "longitude": 11.093198,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nürnberger Straße 22, 91257 Pegnitz",
      "latitude": 49.74929789999999,
      "longitude": 11.5389619,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rothenburger Straße 19, 91315 Höchstadt an der Aisch",
      "latitude": 49.706632,
      "longitude": 10.7992953,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Robert-Bosch-Straße 2, 91413 Neustadt an der Aisch",
      "latitude": 49.5814156,
      "longitude": 10.6372868,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rothenburger Straße 47, 91438 Bad Windsheim",
      "latitude": 49.4980773,
      "longitude": 10.4107855,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ritter-Von-Lang-Allee 7, 91522 Ansbach",
      "latitude": 49.3060413,
      "longitude": 10.588871,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 15, 91541 Rothenburg o. d. Tauber",
      "latitude": 49.37776359999999,
      "longitude": 10.1900552,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dinkelsbühler Str. 34, 91555 Feuchtwangen",
      "latitude": 49.161866,
      "longitude": 10.3270374,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Ansbacher Straße 11, 91710 Gunzenhausen",
      "latitude": 49.1218938,
      "longitude": 10.751903,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eichstätter Str. 29, 91781 Weißenburg",
      "latitude": 49.0273421,
      "longitude": 10.9854542,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Bergsteig 1, 92224 Amberg",
      "latitude": 49.432467,
      "longitude": 11.8878239,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Krötenseestraße 1, 92237 Sulzbach-Rosenberg",
      "latitude": 49.49682019999999,
      "longitude": 11.7437273,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Altdorfer Straße 63, 92318 Neumarkt",
      "latitude": 49.2912157,
      "longitude": 11.4586556,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Untere Bauscherstraße 25, 92637 Weiden",
      "latitude": 49.6612057,
      "longitude": 12.1549867,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Friedenstraße 23, 93053 Regensburg",
      "latitude": 49.0107626,
      "longitude": 12.0992146,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hans-Hayder-Straße 2, 93059 Regensburg",
      "latitude": 49.0340028,
      "longitude": 12.1123009,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Donaustaufer Straße 128, 93059 Regensburg",
      "latitude": 49.0288909,
      "longitude": 12.1217599,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Gewerbepark 48, 93333 Neustadt A.D. Donau",
      "latitude": 48.7981929,
      "longitude": 11.7613396,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Rodingerstraße 22, 93413 Cham",
      "latitude": 49.2035185,
      "longitude": 12.6577112,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neuburger Straße 128, 94036 Passau",
      "latitude": 48.5577607,
      "longitude": 13.4175578,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Florianstraße 1, 94051 Hauzenberg",
      "latitude": 48.6573363,
      "longitude": 13.6304317,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Passauer Straße 160, 94060 Pocking",
      "latitude": 48.41022,
      "longitude": 13.3328994,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Otto-von-Dandl-Ring 11, 94315 Straubing",
      "latitude": 48.8761588,
      "longitude": 12.5490447,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hebbelstraße 6, 94315 Straubing",
      "latitude": 48.8756762,
      "longitude": 12.5736768,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Straubinger Straße 64, 94405 Landau a. d. Isar",
      "latitude": 48.6843934,
      "longitude": 12.6924197,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hösamer Feld 7, 94474 Vilshofen",
      "latitude": 48.6071964,
      "longitude": 13.1696651,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hans-Böckler-Straße 19, 95032 Hof/Saale",
      "latitude": 50.307457,
      "longitude": 11.9167099,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Dr.-Hans-Künzel-Straße 1, 95119 Naila",
      "latitude": 50.32357469999999,
      "longitude": 11.7057924,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Stammbacher Str. 3, 95213 Münchberg",
      "latitude": 50.1901891,
      "longitude": 11.7833271,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Albert-Ruckdeschel-Straße 16, 95326 Kulmbach",
      "latitude": 50.1115846,
      "longitude": 11.4563475,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Weiherstraße 27, 95448 Bayreuth",
      "latitude": 49.96459,
      "longitude": 11.5990486,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Leopoldstraße 30, 95615 Marktredwitz",
      "latitude": 50.0001796,
      "longitude": 12.0873318,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Forchheimer Straße 15, 96050 Bamberg",
      "latitude": 49.8790468,
      "longitude": 10.9202936,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Industriestraße 9, 96120 Bischberg",
      "latitude": 49.9185294,
      "longitude": 10.8077308,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Robert-Koch-Straße 5, 96215 Lichtenfels",
      "latitude": 50.1375973,
      "longitude": 11.0738529,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bettelhecker Str.155, 96515 Sonneberg",
      "latitude": 50.36534899999999,
      "longitude": 11.140182,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Am Dreistock 12, 97318 Kitzingen",
      "latitude": 49.75536959999999,
      "longitude": 10.1766153,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hauptbahnhofstraße 4, 97424 Schweinfurt",
      "latitude": 50.0384699,
      "longitude": 10.2187478,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Meininger Straße 10, 97616 Bad Neustadt a.d. Saale",
      "latitude": 50.32576479999999,
      "longitude": 10.2217634,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Steubenstraße 1, 97688 Bad Kissingen",
      "latitude": 50.2092079,
      "longitude": 10.0818463,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bismarckstraße 26, 97877 Wertheim",
      "latitude": 49.7665847,
      "longitude": 9.5093228,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Hermann-Von-Mittnacht-Str. 10, 97999 Igersheim",
      "latitude": 49.4864665,
      "longitude": 9.8197467,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Würzburger Str., 98529 Suhl",
      "latitude": 50.6056327,
      "longitude": 10.6799032,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Steinerne Wiese 39, 98574 Schmalkalden",
      "latitude": 50.7226972,
      "longitude": 10.4481236,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Werrastraße 14, 98617 Meiningen",
      "latitude": 50.5572822,
      "longitude": 10.4134288,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Eisfelder Straße 60, 98646 Hildburghausen",
      "latitude": 50.4214143,
      "longitude": 10.7458682,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Mühltor 1, 98693 Ilmenau",
      "latitude": 50.6831639,
      "longitude": 10.9186274,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Leipziger Straße, 99085 Erfurt",
      "latitude": 50.98986,
      "longitude": 11.0562904,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Nordhäuser Straße 73 T, 99091 Erfurt",
      "latitude": 51.0084013,
      "longitude": 10.9933994,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Kranichfelder Str. 103, 99097 Erfurt-Melchendorf",
      "latitude": 50.9554566,
      "longitude": 11.0694661,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Alfred-Ley-Str. 12, 99310 Arnstadt",
      "latitude": 50.85537799999999,
      "longitude": 10.9566434,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Humboldtstraße 90, 99425 Weimar",
      "latitude": 50.96441429999999,
      "longitude": 11.3107435,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bernhard-Prager-Gasse 1-7, 99510 Apolda",
      "latitude": 51.0254608,
      "longitude": 11.5128046,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Mainzer Straße 20, 99610 Sömmerda",
      "latitude": 51.1571261,
      "longitude": 11.1428901,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Frankenhäuser Straße 1 A-D, 99706 Sondershausen",
      "latitude": 51.3708384,
      "longitude": 10.881924,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bahnhofstraße 8, 99817 Eisenach",
      "latitude": 50.9759123,
      "longitude": 10.3280018,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Neue Wiese 1, 99817 Eisenach",
      "latitude": 50.9983979,
      "longitude": 10.3544847,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Bürgeraue 2, 99867 Gotha",
      "latitude": 50.9487297,
      "longitude": 10.6962004,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Lindenbühl 11, 99947 Bad Langensalza",
      "latitude": 51.10547159999999,
      "longitude": 10.6457486,
      "website": "www.kaufland.de"
  },
  {
      "name": "Kaufland",
      "address": "Papiermühlenweg 18, 99974 Mühlhausen",
      "latitude": 51.22436099999999,
      "longitude": 10.4512654,
      "website": "www.kaufland.de"
  },
  {
      "name": "basic",
      "address": "Ludwigstraße 2, 86152 Augsburg",
      "latitude": 48.370324,
      "longitude": 10.8955071,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Eichleitnerstraße 14, 86199 Augsburg",
      "latitude": 48.3480802,
      "longitude": 10.8865802,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Berger Straße 40–42, 60316 Frankfurt",
      "latitude": 50.1200244,
      "longitude": 8.695494799999999,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Eckenheimer Landstraße 127, 60318 Frankfurt",
      "latitude": 50.1280188,
      "longitude": 8.6843797,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Levelingstr. 3, 85049 Ingolstadt",
      "latitude": 48.7713875,
      "longitude": 11.386232,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Herzog-Albrecht-Str. 19, 84034 Landshut",
      "latitude": 48.54443510000001,
      "longitude": 12.1359978,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "B 1, 3-5 (Kurpfalzstraße), 68159 Mannheim",
      "latitude": 49.4857576,
      "longitude": 8.4633833,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Richard-Strauss-Straße 48, 81677 München",
      "latitude": 48.141412,
      "longitude": 11.6155755,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Westenriederstraße 35, 80331 München",
      "latitude": 48.1351919,
      "longitude": 11.5794235,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Müllerstraße 45, 80469 München",
      "latitude": 48.1313081,
      "longitude": 11.5681453,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Agnes-Bernauer-Str. 73, 80687 München",
      "latitude": 48.1393227,
      "longitude": 11.5037679,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Nymphenburger Straße 82, 80636 München",
      "latitude": 48.1501303,
      "longitude": 11.5469616,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Amalienburgstraße 2–6, 81247 München",
      "latitude": 48.1652153,
      "longitude": 11.4907652,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Schleißheimer Straße 158–162, 80797 München",
      "latitude": 48.16253,
      "longitude": 11.56436,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Leopoldstraße / Rheinstraße 1, 80803 München",
      "latitude": 48.16711429999999,
      "longitude": 11.5859712,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Belgradstr. 59, 80796 München",
      "latitude": 48.1661383,
      "longitude": 11.5736364,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Passauerstraße 183, 81369 München",
      "latitude": 48.1034123,
      "longitude": 11.5309604,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Hafelhofweg 5, 81825 München",
      "latitude": 48.1227512,
      "longitude": 11.6705097,
      "website": "www.basicbio.de"
  },
  {
      "name": "basic",
      "address": "Grubholzer Straße 2b, 83026 Rosenheim",
      "latitude": 47.8511377,
      "longitude": 12.0941827,
      "website": "www.basicbio.de"
  },
  {
      "name": "dm",
      "address": "Elbestraße 68, 55122 Mainz",
      "latitude": 50.0054252,
      "longitude": 8.221841,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Industriestraße 16, 56412 Heiligenroth",
      "latitude": 50.4484512,
      "longitude": 7.849215099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schloßstr. 51, 51429 Bergisch Gladbach",
      "latitude": 50.9655004,
      "longitude": 7.160700899999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dürener Straße 154-158, 50931 Köln",
      "latitude": 50.93038670000001,
      "longitude": 6.9159872,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Breslauer Straße 1a, 66121 Saarbrücken",
      "latitude": 49.227507,
      "longitude": 7.0364096,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rüttenscheider Straße 104, 45130 Essen",
      "latitude": 51.4348396,
      "longitude": 7.0043242,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 92, 41747 Viersen",
      "latitude": 51.2557679,
      "longitude": 6.3913042,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Auwiesenweg 36, 94209 Regen",
      "latitude": 48.972216,
      "longitude": 13.133539,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwarze-Brüder-Straße 7, 44137 Dortmund",
      "latitude": 51.5137674,
      "longitude": 7.4631606,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 23, 44623 Herne",
      "latitude": 51.5388981,
      "longitude": 7.223892600000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Humboldtring 13, 45472 Mülheim an der Ruhr",
      "latitude": 51.43817809999999,
      "longitude": 6.9545923,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neusser Straße 256, 50733 Köln",
      "latitude": 50.9638666,
      "longitude": 6.954150299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kölner Straße 74-76, 41539 Dormagen",
      "latitude": 51.0928141,
      "longitude": 6.8413464,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kortumstraße 52, 44787 Bochum",
      "latitude": 51.47921650000001,
      "longitude": 7.217613900000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sternstraße 56, 53111 Bonn",
      "latitude": 50.7358389,
      "longitude": 7.0990245,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rotebühlstraße 98-100, 70178 Stuttgart",
      "latitude": 48.7711551,
      "longitude": 9.1593064,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bonner Talweg 38-40, 53113 Bonn",
      "latitude": 50.7260778,
      "longitude": 7.1010708,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 180-182, 51465 Bergisch Gladbach",
      "latitude": 50.991291,
      "longitude": 7.1288705,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hochstraße 36, 51688 Wipperfürth",
      "latitude": 51.1160946,
      "longitude": 7.3941681,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Unterländer Straße 70, 70435 Stuttgart",
      "latitude": 48.8324672,
      "longitude": 9.1681986,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Oststraße 38, 44866 Bochum",
      "latitude": 51.4804981,
      "longitude": 7.136111499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Aachener Straße 1253, 50858 Köln",
      "latitude": 50.9374641,
      "longitude": 6.8355872,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neuer Markt 40-42, 42781 Haan",
      "latitude": 51.19357970000001,
      "longitude": 7.010765200000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Steinweg 44, 38518 Gifhorn",
      "latitude": 52.4856768,
      "longitude": 10.5465775,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Georg-Kohl-Straße 1, 74336 Brackenheim",
      "latitude": 49.07533230000001,
      "longitude": 9.065933099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lebacher Straße 80, 66113 Saarbrücken",
      "latitude": 49.2456897,
      "longitude": 6.969241299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hürth-Park L011, 50354 Hürth",
      "latitude": 50.8791701,
      "longitude": 6.8747599,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Orkotten 5, 48291 Telgte",
      "latitude": 51.9791924,
      "longitude": 7.783813500000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "F 1 2, 68159 Mannheim",
      "latitude": 49.488923,
      "longitude": 8.467051500000002,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Im Gewerbepark C 5b, 93059 Regensburg",
      "latitude": 49.030238,
      "longitude": 12.1248463,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kaiser-Joseph-Straße 209, 79098 Freiburg im Breisgau",
      "latitude": 47.9945142,
      "longitude": 7.849675299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Seckenheimer Straße 62-64, 68165 Mannheim",
      "latitude": 49.4793436,
      "longitude": 8.481232799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Brückstraße 28, 45239 Essen",
      "latitude": 51.3881075,
      "longitude": 7.0020899,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lindenstraße 2, 83700 Rottach-Egern",
      "latitude": 47.6885046,
      "longitude": 11.7675587,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwabstraße 93, 70193 Stuttgart",
      "latitude": 48.7756108,
      "longitude": 9.155619,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schloßplatz 14, 77933 Lahr",
      "latitude": 48.3397218,
      "longitude": 7.8716326,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Venloer Straße 247, 50823 Köln",
      "latitude": 50.94693609999999,
      "longitude": 6.922456299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ludwigsstraße 11, 55116 Mainz",
      "latitude": 49.9988185,
      "longitude": 8.2704413,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Breiter Weg 23-26, 39104 Magdeburg",
      "latitude": 52.1321935,
      "longitude": 11.6376504,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Karlstraße 106, 76137 Karlsruhe",
      "latitude": 48.9989589,
      "longitude": 8.3936453,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Main-Taunus-Zentrum 59, 65843 Sulzbach (Taunus)",
      "latitude": 50.1203586,
      "longitude": 8.525248099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marktstraße 41, 71364 Winnenden",
      "latitude": 48.8764961,
      "longitude": 9.3988988,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rohrbacher Straße 3, 69115 Heidelberg",
      "latitude": 49.408334,
      "longitude": 8.6928126,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kaiserstraße 91, 79761 Waldshut-Tiengen",
      "latitude": 47.6225213,
      "longitude": 8.2093987,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Harkortstraße 36, 44225 Dortmund",
      "latitude": 51.4755583,
      "longitude": 7.442745500000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hertzstraße 1, 69126 Heidelberg",
      "latitude": 49.3668948,
      "longitude": 8.6856663,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 20, 40597 Düsseldorf",
      "latitude": 51.1638265,
      "longitude": 6.874317,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 17-19, 64625 Bensheim",
      "latitude": 49.6817041,
      "longitude": 8.6220416,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lindwurmstraße 95, 80337 München",
      "latitude": 48.1284734,
      "longitude": 11.5571747,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Grünwalder Weg 22, 82008 Unterhaching",
      "latitude": 48.0568196,
      "longitude": 11.6048497,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rathausplatz 7, 67227 Frankenthal (Pfalz)",
      "latitude": 49.5349205,
      "longitude": 8.3541862,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Erich-Ollenhauer-Straße 7, 30851 Langenhagen",
      "latitude": 52.4352639,
      "longitude": 9.755289399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neustraße 41, 46535 Dinslaken",
      "latitude": 51.562428,
      "longitude": 6.736567399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 92, 68259 Mannheim",
      "latitude": 49.4873388,
      "longitude": 8.5283923,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neisser Straße 12, 76139 Karlsruhe",
      "latitude": 49.03522,
      "longitude": 8.44437,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 103, 82166 Gräfelfing",
      "latitude": 48.1196047,
      "longitude": 11.4273662,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Untere Hauptstraße 23, 85354 Freising",
      "latitude": 48.4016575,
      "longitude": 11.7463383,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lange Straße 18, 44532 Lünen",
      "latitude": 51.6143665,
      "longitude": 7.5238478,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Flach-Fengler-Straße 51, 50389 Wesseling",
      "latitude": 50.822586,
      "longitude": 6.9786739,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Theodor-Ludwig-Straße 11, 79312 Emmendingen",
      "latitude": 48.1215257,
      "longitude": 7.8507349,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrichstraße 21, 68199 Mannheim",
      "latitude": 49.4523878,
      "longitude": 8.4917958,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rommelspütt 5, 42105 Wuppertal",
      "latitude": 51.2594936,
      "longitude": 7.147255599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Düsseldorfer Straße 46-48, 42697 Solingen",
      "latitude": 51.1614465,
      "longitude": 6.999630799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Horster Straße 12, 45964 Gladbeck",
      "latitude": 51.57284310000001,
      "longitude": 6.9930429,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Augustenstraße 67, 80333 München",
      "latitude": 48.1500432,
      "longitude": 11.5632982,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dürerstraße 3, 76149 Karlsruhe",
      "latitude": 49.0462336,
      "longitude": 8.3813214,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Pfinztalstraße 46-50, 76227 Karlsruhe",
      "latitude": 48.9992715,
      "longitude": 8.472287399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 12, 71638 Ludwigsburg",
      "latitude": 48.8925696,
      "longitude": 9.1854313,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 13, 86368 Gersthofen",
      "latitude": 48.4252601,
      "longitude": 10.8755852,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hattinger Straße 819-821, 44879 Bochum",
      "latitude": 51.4271334,
      "longitude": 7.162656699999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 63, 77652 Offenburg",
      "latitude": 48.4700415,
      "longitude": 7.9433085,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kortumstraße 87-89, 44787 Bochum",
      "latitude": 51.48209,
      "longitude": 7.21646,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Willy-Brandt-Platz 7, 04109 Leipzig",
      "latitude": 51.3450103,
      "longitude": 12.3820464,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marktplatz 6, 57234 Wilnsdorf",
      "latitude": 50.8174208,
      "longitude": 8.1073494,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ollenhauerstraße 6, 81737 München",
      "latitude": 48.1007548,
      "longitude": 11.6445356,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ringstr. 21, 09247 Chemnitz",
      "latitude": 50.8652407,
      "longitude": 12.8676944,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mittelstraße 27-29, 58285 Gevelsberg",
      "latitude": 51.3193377,
      "longitude": 7.3388214,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lister Meile 77-79, 30161 Hannover",
      "latitude": 52.3875618,
      "longitude": 9.7489694,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Nordhäuser Straße 73t, 99091 Erfurt",
      "latitude": 51.0084013,
      "longitude": 10.9933994,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lockwitzer Straße 1, 01219 Dresden",
      "latitude": 51.02731199999999,
      "longitude": 13.7604613,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Obere Straße 6-10, 07318 Saalfeld/Saale",
      "latitude": 50.6469284,
      "longitude": 11.3605424,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bautzner Straße 2, 02763 Zittau",
      "latitude": 50.8972089,
      "longitude": 14.8058914,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Teichgraben 1, 07743 Jena",
      "latitude": 50.9270763,
      "longitude": 11.5848386,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rosenheimer Straße 30-32, 81669 München",
      "latitude": 48.1297636,
      "longitude": 11.5913038,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 5, 57072 Siegen",
      "latitude": 50.8740673,
      "longitude": 8.0183988,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hermannstraße 41-45, 44263 Dortmund",
      "latitude": 51.4892145,
      "longitude": 7.5007854,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Aachener Straße 70A, 40223 Düsseldorf",
      "latitude": 51.2036331,
      "longitude": 6.772774200000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bliesstraße 66-68, 66538 Neunkirchen",
      "latitude": 49.35111000000001,
      "longitude": 7.204339999999998,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ulrich-Gminder-Straße 2/1, 72654 Neckartenzlingen",
      "latitude": 48.58567,
      "longitude": 9.226989999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gürzenichstraße 6-16, 50667 Köln",
      "latitude": 50.9360306,
      "longitude": 6.957535399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Konrad-Adenauer-Platz 14, 40210 Düsseldorf",
      "latitude": 51.2200155,
      "longitude": 6.792801000000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Südpark 7, 86633 Neuburg a.d. Donau",
      "latitude": 48.720295,
      "longitude": 11.172097,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marktstraße 17, 70372 Stuttgart",
      "latitude": 48.80398899999999,
      "longitude": 9.215354699999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kaiserstraße 29, 44135 Dortmund",
      "latitude": 51.5134959,
      "longitude": 7.476697499999998,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Epplestraße 6, 70597 Stuttgart",
      "latitude": 48.7484854,
      "longitude": 9.169745899999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lindenpark 6, 78183 Hüfingen",
      "latitude": 47.9338936,
      "longitude": 8.496605599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Carl-Kistner-Straße 3, 79115 Freiburg im Breisgau",
      "latitude": 47.9913256,
      "longitude": 7.816283499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neumarkt 2-4, 50667 Köln",
      "latitude": 50.9365676,
      "longitude": 6.9486064,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Zum Kaiserstuhl 10, 79206 Breisach am Rhein",
      "latitude": 48.03287,
      "longitude": 7.593129999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Talstraße 4, 74321 Bietigheim-Bissingen",
      "latitude": 48.9607946,
      "longitude": 9.1311584,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Einsteinstraße 130, 81675 München",
      "latitude": 48.1362738,
      "longitude": 11.6139143,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kupferdreher Strasse 166, 45257 Essen",
      "latitude": 51.3908141,
      "longitude": 7.08263,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ickerner Straße 56, 44581 Castrop-Rauxel",
      "latitude": 51.5918437,
      "longitude": 7.338075099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bilker Allee 43, 40219 Düsseldorf",
      "latitude": 51.2105645,
      "longitude": 6.767087099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 71, 75417 Mühlacker",
      "latitude": 48.9513568,
      "longitude": 8.8419922,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 435, 79576 Weil am Rhein",
      "latitude": 47.5900574,
      "longitude": 7.5924133,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Cumianastraße 1, 91058 Erlangen",
      "latitude": 49.5749411,
      "longitude": 11.0017427,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Binger Straße 208, 55218 Ingelheim am Rhein",
      "latitude": 49.9734186,
      "longitude": 8.0374901,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kupferstraße 2, 48653 Coesfeld",
      "latitude": 51.9441135,
      "longitude": 7.165744900000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Karl-Theodor-Straße 65, 80803 München",
      "latitude": 48.1667529,
      "longitude": 11.5765192,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Puschkinplatz 10-14, 07973 Greiz",
      "latitude": 50.6569617,
      "longitude": 12.1991387,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sonnenhof 2, 55469 Simmern",
      "latitude": 49.9811229,
      "longitude": 7.536135300000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ludwigsburger Straße 9, 04209 Leipzig",
      "latitude": 51.3205761,
      "longitude": 12.2895966,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dellstrasse 22, 46459 Rees",
      "latitude": 51.759702,
      "longitude": 6.396351999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Industriestraße 2, 63768 Hösbach",
      "latitude": 50.0060113,
      "longitude": 9.222230999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Siebenmorgen 40, 51427 Bergisch Gladbach",
      "latitude": 50.9578599,
      "longitude": 7.1156621,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Reichenstraße 18, 02625 Bautzen",
      "latitude": 51.1807354,
      "longitude": 14.4264568,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sarresdorfer Straße 55a, 54568 Gerolstein",
      "latitude": 50.223313,
      "longitude": 6.649119,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Leopoldstraße 6, 75172 Pforzheim",
      "latitude": 48.8912121,
      "longitude": 8.6988377,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Münchner Straße 32, 85221 Dachau",
      "latitude": 48.2548761,
      "longitude": 11.4392894,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwarzwaldstraße 78, 79117 Freiburg im Breisgau",
      "latitude": 47.9886801,
      "longitude": 7.860522799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Michelinstraße 142, 96103 Hallstadt",
      "latitude": 49.9233039,
      "longitude": 10.89472,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schleißheimer Straße 506, 80933 München",
      "latitude": 48.21298969999999,
      "longitude": 11.5636486,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Seeackerstraße 33, 90765 Fürth",
      "latitude": 49.4953967,
      "longitude": 10.995057,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Alte Frankfurter Straße 23, 68305 Mannheim",
      "latitude": 49.5251008,
      "longitude": 8.4853372,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Buchholzer Straße 16, 09456 Annaberg-Buchholz",
      "latitude": 50.5784253,
      "longitude": 13.0019557,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Karlstraße 12, 89518 Heidenheim an der Brenz",
      "latitude": 48.68001899999999,
      "longitude": 10.1530523,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hinter den Gärten 1, 50189 Elsdorf",
      "latitude": 50.933304,
      "longitude": 6.570789599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Luchsstraße 1, 46149 Oberhausen",
      "latitude": 51.5318203,
      "longitude": 6.8408183,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rudolf-Diesel-Straße 31+35, 78532 Tuttlingen",
      "latitude": 47.99583819999999,
      "longitude": 8.8291512,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lippertsreuter Straße 4b, 88662 Überlingen",
      "latitude": 47.7704004,
      "longitude": 9.173026499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kurfürstendamm 34, 10719 Berlin",
      "latitude": 52.5026483,
      "longitude": 13.3241298,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bäckerstraße 35, 32052 Herford",
      "latitude": 52.1136568,
      "longitude": 8.671157599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Markt 1, 45657 Recklinghausen",
      "latitude": 51.61397700000001,
      "longitude": 7.1976157,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Borsigallee 26, 60388 Frankfurt am Main",
      "latitude": 50.140602,
      "longitude": 8.7520773,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Müllerstraße 40b, 13353 Berlin",
      "latitude": 52.5502669,
      "longitude": 13.3531,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Nicolaistraße 28, 01307 Dresden",
      "latitude": 51.04623530000001,
      "longitude": 13.7704112,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gutenbergstraße 151, 47803 Krefeld",
      "latitude": 51.330341,
      "longitude": 6.545493,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lange Straße 21, 31515 Wunstorf",
      "latitude": 52.4257679,
      "longitude": 9.4265254,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gewerbestraße 3, 79585 Steinen",
      "latitude": 47.6411112,
      "longitude": 7.7467951,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bochumer Straße 138, 45661 Recklinghausen",
      "latitude": 51.5717666,
      "longitude": 7.211984999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Münchner Straße 140, 85757 Karlsfeld",
      "latitude": 48.22714980000001,
      "longitude": 11.4638817,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Frankfurter Allee 111, 10247 Berlin",
      "latitude": 52.5142282,
      "longitude": 13.4738877,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bürgermeister-Fischer-Straße 5, 86150 Augsburg",
      "latitude": 48.3665341,
      "longitude": 10.8964002,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hochstraße 96, 52525 Heinsberg",
      "latitude": 51.0622791,
      "longitude": 6.0945295,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 26, 59755 Arnsberg",
      "latitude": 51.45190669999999,
      "longitude": 7.962215999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "August-Borsig-Straße 2, 97526 Sennfeld",
      "latitude": 50.0371613,
      "longitude": 10.2489774,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lange Str. 5, 63741 Aschaffenburg",
      "latitude": 49.98188,
      "longitude": 9.145811,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schadowstraße 64-66, 40212 Düsseldorf",
      "latitude": 51.2273347,
      "longitude": 6.7854024,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ernst-Reuter-Allee 11, 39104 Magdeburg",
      "latitude": 52.13010149999999,
      "longitude": 11.637582,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Frankfurter Straße 56, 97082 Würzburg",
      "latitude": 49.79492519999999,
      "longitude": 9.9065263,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Laufenpark 5, 79725 Laufenburg (Baden)",
      "latitude": 47.56454129999999,
      "longitude": 8.0747612,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hochstraße 16, 45964 Gladbeck",
      "latitude": 51.57325220000001,
      "longitude": 6.9909481,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Fürther Straße 301-303, 90429 Nürnberg",
      "latitude": 49.459543,
      "longitude": 11.0233272,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Große Straße 62, 49074 Osnabrück",
      "latitude": 52.2746777,
      "longitude": 8.0458266,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Turmstraße 59, 10551 Berlin",
      "latitude": 52.527657,
      "longitude": 13.3295208,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Adalbertstraße 80-82, 52062 Aachen",
      "latitude": 50.7752024,
      "longitude": 6.0926958,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hohenzollernring 2-10, 50672 Köln",
      "latitude": 50.93703,
      "longitude": 6.939410000000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heinrich-Böll-Straße 1, 58710 Menden (Sauerland)",
      "latitude": 51.4156505,
      "longitude": 7.8285319,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Äußerer Laufer Platz 24, 90403 Nürnberg",
      "latitude": 49.45692950000001,
      "longitude": 11.087766,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 61, 77694 Kehl",
      "latitude": 48.5734193,
      "longitude": 7.810674499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Plochinger Straße 40-42, 73779 Deizisau",
      "latitude": 48.7138048,
      "longitude": 9.3943964,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Berliner Straße 6, 02826 Görlitz",
      "latitude": 51.1510983,
      "longitude": 14.9843673,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hasenheide 107-108, 10967 Berlin",
      "latitude": 52.4864292,
      "longitude": 13.4215085,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mainzer Straße 67, 67657 Kaiserslautern",
      "latitude": 49.452388,
      "longitude": 7.784598399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sonnenstr. 15, 85764 Oberschleißheim",
      "latitude": 48.2436241,
      "longitude": 11.5497878,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neuköllner Straße 344, 12355 Berlin",
      "latitude": 52.4159085,
      "longitude": 13.4950663,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rochusstraße 194, 53123 Bonn",
      "latitude": 50.7153998,
      "longitude": 7.049078199999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gewerbestraße 1, 69221 Dossenheim",
      "latitude": 49.45512189999999,
      "longitude": 8.665845,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Grüneburgweg 58-62, 60322 Frankfurt am Main",
      "latitude": 50.1214962,
      "longitude": 8.671287999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Systemformstraße 1, 83209 Prien a. Chiemsee",
      "latitude": 47.84713439999999,
      "longitude": 12.3490011,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Otto-Hahn-Straße 10b, 74731 Walldürn",
      "latitude": 49.5746362,
      "longitude": 9.3686592,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Otto-Wallach-Straße 5, 65203 Wiesbaden",
      "latitude": 50.04411349999999,
      "longitude": 8.2178683,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Walsroder Straße 125, 30853 Langenhagen",
      "latitude": 52.4465069,
      "longitude": 9.7403442,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Spicher Straße 101, 53844 Troisdorf",
      "latitude": 50.81122329999999,
      "longitude": 7.1231472,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Brühlweg 15, 74909 Meckesheim",
      "latitude": 49.3246975,
      "longitude": 8.8134441,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Teltower Damm 15, 14169 Berlin",
      "latitude": 52.4334403,
      "longitude": 13.2605135,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rheinweg 156-158, 53129 Bonn",
      "latitude": 50.713,
      "longitude": 7.1100629,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ansbacher Str. 80, 90449 Nürnberg",
      "latitude": 49.421109,
      "longitude": 11.0312731,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Giesinger Bahnhofplatz 7, 81539 München",
      "latitude": 48.111141,
      "longitude": 11.5953585,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Niederstraße 39-45, 41460 Neuss",
      "latitude": 51.1999769,
      "longitude": 6.687899499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "In der Dörrwiese 4, 66706 Perl",
      "latitude": 49.4750184,
      "longitude": 6.3743798,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Syltstraße 10, 51377 Leverkusen",
      "latitude": 51.0331289,
      "longitude": 7.0116238,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hans-Stießberger-Straße 5, 85540 Haar",
      "latitude": 48.1095902,
      "longitude": 11.7184069,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hohe Straße 45-49, 46483 Wesel",
      "latitude": 51.6574384,
      "longitude": 6.6181994,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mannheimer Landstraße 5b, 68782 Brühl",
      "latitude": 49.4084924,
      "longitude": 8.5389181,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bärenfelser Straße 4, 79539 Lörrach",
      "latitude": 47.6260122,
      "longitude": 7.676371100000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gernsbacher Straße 13, 76530 Baden-Baden",
      "latitude": 48.7621833,
      "longitude": 8.2416386,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Anger 66-73, 99084 Erfurt",
      "latitude": 50.9769704,
      "longitude": 11.0345012,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hackerbrücke 4, 80335 München",
      "latitude": 48.1424667,
      "longitude": 11.549003,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Pferdemarkt 1, 31785 Hameln",
      "latitude": 52.1041451,
      "longitude": 9.356593,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Teplitzer Straße 9, 84478 Waldkraiburg",
      "latitude": 48.20808299999999,
      "longitude": 12.4077919,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Eichhornstraße 13, 97070 Würzburg",
      "latitude": 49.7955932,
      "longitude": 9.9331696,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Industriestraße 11e, 67063 Ludwigshafen am Rhein",
      "latitude": 49.4858514,
      "longitude": 8.420091,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marktplatz 21, 85598 Baldham",
      "latitude": 48.09975,
      "longitude": 11.788218,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "An der Fohlenweide 13a, 67112 Mutterstadt",
      "latitude": 49.4252227,
      "longitude": 8.3627386,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Grimmaische Straße 14, 04109 Leipzig",
      "latitude": 51.3394426,
      "longitude": 12.3786666,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hildesheimer Straße 213, 30519 Hannover",
      "latitude": 52.3440453,
      "longitude": 9.7639444,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Fischerstraße 106, 47055 Duisburg",
      "latitude": 51.4019527,
      "longitude": 6.7612158,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Wilmersdorfer Straße 46, 10627 Berlin",
      "latitude": 52.509249,
      "longitude": 13.304609,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Breite Straße 70, 39576 Stendal",
      "latitude": 52.6052881,
      "longitude": 11.8613288,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Robert-Gerwig-Straße 5, 79761 Waldshut-Tiengen",
      "latitude": 47.623249,
      "longitude": 8.2186494,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedensstraße 25, 06712 Zeitz",
      "latitude": 51.04241769999999,
      "longitude": 12.1264061,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 27, 79798 Jestetten",
      "latitude": 47.64988659999999,
      "longitude": 8.5683396,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "In den Geldäckern 6, 67304 Eisenberg (Pfalz)",
      "latitude": 49.5570364,
      "longitude": 8.0800571,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstätter Straße 149, 70178 Stuttgart",
      "latitude": 48.7644413,
      "longitude": 9.1699898,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 1, 94032 Passau",
      "latitude": 48.5736758,
      "longitude": 13.4567429,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Prager Straße 15, 01069 Dresden",
      "latitude": 51.0450609,
      "longitude": 13.7348425,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sankt-Annen-Straße 23, 14776 Brandenburg an der Havel",
      "latitude": 52.4079937,
      "longitude": 12.5654356,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Alter Rathausplatz 14, 58636 Iserlohn",
      "latitude": 51.3740453,
      "longitude": 7.697603,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schadowstraße 11, 40212 Düsseldorf",
      "latitude": 51.2259612,
      "longitude": 6.781507299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Eberhardstraße 35/37, 70173 Stuttgart",
      "latitude": 48.7731918,
      "longitude": 9.1781804,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrich-Ebert-Platz 1, 51373 Leverkusen",
      "latitude": 51.0329023,
      "longitude": 6.987721499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schleswiger Chaussee 41-43, 24768 Rendsburg",
      "latitude": 54.3122236,
      "longitude": 9.644440399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neumarkt 15-17, 47441 Moers",
      "latitude": 51.4524313,
      "longitude": 6.625877999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 49, 72172 Sulz am Neckar",
      "latitude": 48.3671622,
      "longitude": 8.6378121,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Wickerer Straße 50, 65439 Flörsheim am Main",
      "latitude": 50.0155131,
      "longitude": 8.4232663,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gartenstraße 102, 53225 Bonn",
      "latitude": 50.7506079,
      "longitude": 7.1307879,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sternstraße 2b, 01139 Dresden",
      "latitude": 51.0797264,
      "longitude": 13.7126171,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Güterstraße 1e, 79618 Rheinfelden (Baden)",
      "latitude": 47.5569516,
      "longitude": 7.782186299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Güterstraße 8, 77815 Bühl",
      "latitude": 48.6981751,
      "longitude": 8.132089900000002,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lotharstraße 11-13, 55116 Mainz",
      "latitude": 50.0016304,
      "longitude": 8.2668717,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Hauptbahnhof 5, 45127 Essen",
      "latitude": 51.4519984,
      "longitude": 7.0144619,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Treidlerstraße 1, 68535 Edingen-Neckarhausen",
      "latitude": 49.4565812,
      "longitude": 8.5956789,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Chemnitzer Straße 1, 09385 Lugau",
      "latitude": 50.7449144,
      "longitude": 12.7480044,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Winterhuder Marktplatz 8, 22299 Hamburg",
      "latitude": 53.5946451,
      "longitude": 10.0005587,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kröpeliner Straße 85, 18055 Rostock",
      "latitude": 54.08876650000001,
      "longitude": 12.137392,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Henriette-Herz-Platz 4, 10178 Berlin",
      "latitude": 52.5222855,
      "longitude": 13.4028304,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Oskar-von-Miller-Straße 6, 97424 Schweinfurt",
      "latitude": 50.04187280000001,
      "longitude": 10.2059711,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Oppenheimer Straße 44, 55268 Nieder-Olm",
      "latitude": 49.90348059999999,
      "longitude": 8.202676799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Unteröwisheimer Straße 19, 76698 Ubstadt-Weiher",
      "latitude": 49.1557081,
      "longitude": 8.6312176,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Eberstädter Straße 94d, 64319 Pfungstadt",
      "latitude": 49.8058165,
      "longitude": 8.6068417,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Güterstraße 1, 69168 Wiesloch",
      "latitude": 49.2906572,
      "longitude": 8.6968705,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 94, 73312 Geislingen an der Steige",
      "latitude": 48.6236165,
      "longitude": 9.8353785,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Planckstraße 12, 72250 Freudenstadt",
      "latitude": 48.4644954,
      "longitude": 8.4383833,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Achener Weg 1, 88316 Isny im Allgäu",
      "latitude": 47.6979034,
      "longitude": 10.0431325,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Elsa-Brandström-Straße 3, 58675 Hemer",
      "latitude": 51.3836993,
      "longitude": 7.768637099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kaßstraße 42, 46446 Emmerich",
      "latitude": 51.831083,
      "longitude": 6.244992,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rietstraße 40, 78050 Villingen-Schwenningen",
      "latitude": 48.0599176,
      "longitude": 8.456337999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Trierer Straße 43, 66706 Perl",
      "latitude": 49.47617,
      "longitude": 6.38552,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Stummplatz 1, 66538 Neunkirchen",
      "latitude": 49.34744209999999,
      "longitude": 7.1737129,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Holtenauer Straße 122, 24105 Kiel",
      "latitude": 54.3370359,
      "longitude": 10.1338573,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Theodor-Fontane-Straße 14, 85609 Aschheim",
      "latitude": 48.1628846,
      "longitude": 11.7297673,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Königsallee 60d, 40212 Düsseldorf",
      "latitude": 51.22217999999999,
      "longitude": 6.780069999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Im Rebacker 8, 79591 Eimeldingen",
      "latitude": 47.6264975,
      "longitude": 7.598695500000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Deverweg 33-37, 26871 Papenburg",
      "latitude": 53.0837224,
      "longitude": 7.383804899999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Fackelstraße 15, 67655 Kaiserslautern",
      "latitude": 49.4437485,
      "longitude": 7.7674892,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bautzner Straße 35, 01099 Dresden",
      "latitude": 51.06325709999999,
      "longitude": 13.7532836,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Stuttgarter Straße 77, 70469 Stuttgart",
      "latitude": 48.8091011,
      "longitude": 9.158779599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neumarkt 5, 01662 Meißen",
      "latitude": 51.1594458,
      "longitude": 13.472158,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bavierstraße 10, 40699 Erkrath",
      "latitude": 51.22278559999999,
      "longitude": 6.910801299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Stadionstraße 10, 39218 Schönebeck",
      "latitude": 52.0147616,
      "longitude": 11.7167877,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrichsfelder Straße 30, 46562 Voerde (Niederrhein)",
      "latitude": 51.59907519999999,
      "longitude": 6.684146699999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Siemensstraße 10, 44579 Castrop-Rauxel",
      "latitude": 51.5811518,
      "longitude": 7.3101369,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Edisonstraße 2, 86199 Augsburg",
      "latitude": 48.346371,
      "longitude": 10.8809576,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Schützenplatz 6, 42899 Remscheid",
      "latitude": 51.2116084,
      "longitude": 7.2356498,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Fürstenrieder Straße 51, 80686 München",
      "latitude": 48.1366233,
      "longitude": 11.5033489,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rostocker Straße 2, 65191 Wiesbaden",
      "latitude": 50.087885,
      "longitude": 8.2895436,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Riga-Ring 11, 59494 Soest",
      "latitude": 51.5680793,
      "longitude": 8.1299186,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 241, 44649 Herne",
      "latitude": 51.5304537,
      "longitude": 7.157722199999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Emmericher Straße 237b, 47533 Kleve",
      "latitude": 51.7964004,
      "longitude": 6.1510836,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Würzburger Straße 57a, 96049 Bamberg",
      "latitude": 49.8754581,
      "longitude": 10.885602,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rüttenscheider Straße 62-64, 45130 Essen",
      "latitude": 51.4380699,
      "longitude": 7.0052276,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Biberger Straße 64, 82008 Unterhaching",
      "latitude": 48.0677584,
      "longitude": 11.6196017,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Bergsteig 2, 92224 Amberg",
      "latitude": 49.4337789,
      "longitude": 11.8848879,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Louis-Appia-Passage 6, 60314 Frankfurt am Main",
      "latitude": 50.112263,
      "longitude": 8.705582699999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Breisgauer Straße 5, 14129 Berlin",
      "latitude": 52.4389608,
      "longitude": 13.2156798,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sählingstraße 1a, 57319 Bad Berleburg",
      "latitude": 51.0565137,
      "longitude": 8.395000399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Elberfelder Straße 29, 58095 Hagen",
      "latitude": 51.3578719,
      "longitude": 7.4710627,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heidestraße 17a, 45476 Mülheim an der Ruhr",
      "latitude": 51.45128099999999,
      "longitude": 6.8484649,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schloßstraße 15, 12163 Berlin",
      "latitude": 52.4619126,
      "longitude": 13.3250933,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 18, 36037 Fulda",
      "latitude": 50.5533724,
      "longitude": 9.6818332,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mendener Straße 140, 58636 Iserlohn",
      "latitude": 51.3799742,
      "longitude": 7.716153500000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lange Straße 58-62, 29664 Walsrode",
      "latitude": 52.8612962,
      "longitude": 9.587913,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Josef-Schregel-Straße 57-59, 52349 Düren",
      "latitude": 50.8101356,
      "longitude": 6.4784717,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Westendstraße 98, 80339 München",
      "latitude": 48.1383281,
      "longitude": 11.5369656,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Stralsunder Straße 9, 16515 Oranienburg",
      "latitude": 52.7549399,
      "longitude": 13.2473032,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Weisweiler Straße 8, 79771 Klettgau",
      "latitude": 47.6575012,
      "longitude": 8.4295519,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Breite Straße 4, 21614 Buxtehude",
      "latitude": 53.4767946,
      "longitude": 9.699891599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Eppendorfer Landstraße 108, 20249 Hamburg",
      "latitude": 53.5925206,
      "longitude": 9.989005899999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Industriestraße 16, 56412 Heiligenroth",
      "latitude": 50.4484512,
      "longitude": 7.849215099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kölner Straße 99, 42651 Solingen",
      "latitude": 51.1713051,
      "longitude": 7.0818558,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Osdorfer Landstraße 131, 22609 Hamburg",
      "latitude": 53.5704053,
      "longitude": 9.860387399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kieler Straße 54, 24340 Eckernförde",
      "latitude": 54.4699336,
      "longitude": 9.8372493,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heinrich-Dathe-Platz 1, 10319 Berlin",
      "latitude": 52.49807449999999,
      "longitude": 13.5215372,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Steinstraße 43, 47441 Moers",
      "latitude": 51.4507407,
      "longitude": 6.6277557,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Poststraße 2, 98693 Ilmenau",
      "latitude": 50.6852677,
      "longitude": 10.9167682,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kaiserstraße 64-66, 61169 Friedberg (Hessen)",
      "latitude": 50.33760400000001,
      "longitude": 8.7543299,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Centroallee 34-35, 46047 Oberhausen",
      "latitude": 51.4903937,
      "longitude": 6.878239199999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 54a, 18528 Bergen auf Rügen",
      "latitude": 54.41852189999999,
      "longitude": 13.425739,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Saarstraße 8, 79798 Jestetten",
      "latitude": 47.6534657,
      "longitude": 8.5743142,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Werdauer Straße 73, 08427 Fraureuth",
      "latitude": 50.7128318,
      "longitude": 12.3695989,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gottlieb-Daimler-Straße 9, 69207 Sandhausen",
      "latitude": 49.3402854,
      "longitude": 8.667183,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lindenstraße 12, 06406 Bernburg (Saale)",
      "latitude": 51.79333159999999,
      "longitude": 11.7433632,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Zeil 123, 60313 Frankfurt am Main",
      "latitude": 50.1136008,
      "longitude": 8.6802004,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedensstraße 15, 17192 Waren (Müritz)",
      "latitude": 53.51516299999999,
      "longitude": 12.6857212,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Jahnstraße 19, 66763 Dillingen/Saar",
      "latitude": 49.3560477,
      "longitude": 6.7219944,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Rethelstraße 161, 40237 Düsseldorf",
      "latitude": 51.2382819,
      "longitude": 6.801117899999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Louisenstraße 14-16, 61348 Bad Homburg vor der Höhe",
      "latitude": 50.2286383,
      "longitude": 8.6130354,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hannoversche Straße 90, 49084 Osnabrück",
      "latitude": 52.2579667,
      "longitude": 8.0844274,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neumarkt 11, 65549 Limburg a. d. Lahn",
      "latitude": 50.3867334,
      "longitude": 8.0635651,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Im Forum 5a, 63450 Hanau",
      "latitude": 50.1348481,
      "longitude": 8.9171818,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Orleansplatz 10-12, 81667 München",
      "latitude": 48.1278246,
      "longitude": 11.6045092,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dr.-Gessler-Straße 41-47, 93051 Regensburg",
      "latitude": 49.0070389,
      "longitude": 12.0618218,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Babelsberger Str. 16, 14473 Potsdam",
      "latitude": 52.3923298,
      "longitude": 13.0652341,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marktbreiter Straße 54 a, 97199 Ochsenfurt",
      "latitude": 49.6651576,
      "longitude": 10.0752703,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sendlinger Straße 12a, 80331 München",
      "latitude": 48.13618779999999,
      "longitude": 11.5711847,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Prager Platz 1-3, 10779 Berlin",
      "latitude": 52.4933981,
      "longitude": 13.332398,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schönhauser Allee 80, 10439 Berlin",
      "latitude": 52.5496693,
      "longitude": 13.4159766,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Venloer Straße 127, 50259 Pulheim",
      "latitude": 50.9983251,
      "longitude": 6.800585,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hauptstraße 50, 58332 Schwelm",
      "latitude": 51.28420389999999,
      "longitude": 7.2936155,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lange Straße 90, 17489 Greifswald",
      "latitude": 54.09615669999999,
      "longitude": 13.3805137,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kreillerstraße 200, 81825 München",
      "latitude": 48.1222164,
      "longitude": 11.6613746,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bäckerstraße 21-23, 32423 Minden",
      "latitude": 52.29013,
      "longitude": 8.91791,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Joachim-Gottschalk-Weg 21, 12353 Berlin",
      "latitude": 52.4228341,
      "longitude": 13.4756587,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mainzer Landstraße 15, 65589 Hadamar",
      "latitude": 50.4423968,
      "longitude": 8.042077299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Wallerfanger Straße 60, 66780 Rehlingen",
      "latitude": 49.3727774,
      "longitude": 6.6828533,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Herzog-Friedrich-Straße 30-42, 24103 Kiel",
      "latitude": 54.3176947,
      "longitude": 10.1313264,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kirchdorfer Straße 15d, 83052 Bruckmühl",
      "latitude": 47.8844957,
      "longitude": 11.9138199,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrich-Ebert-Straße 145-147, 48153 Münster",
      "latitude": 51.9434191,
      "longitude": 7.629902299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Ladestraße 5a, 04683 Naunhof",
      "latitude": 51.27921509999999,
      "longitude": 12.591168,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Augustusburger Straße 96, 09557 Flöha",
      "latitude": 50.8487774,
      "longitude": 13.0798447,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Im Steinfacht 3, 79739 Schwörstadt",
      "latitude": 47.5898865,
      "longitude": 7.861972400000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 37, 06618 Naumburg (Saale)",
      "latitude": 51.1627545,
      "longitude": 11.7987235,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwanenstraße 1, 85586 Poing",
      "latitude": 48.1807885,
      "longitude": 11.7982451,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schmidtkuhlsweg 19, 27607 Geestland",
      "latitude": 53.6172192,
      "longitude": 8.596471400000002,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Freudenstädter Straße 2, 72202 Nagold",
      "latitude": 48.5501206,
      "longitude": 8.7238788,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Tilsiter Straße 15, 71065 Sindelfingen",
      "latitude": 48.70438910000001,
      "longitude": 9.0315957,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hüsingstraße 28, 58239 Schwerte",
      "latitude": 51.4415248,
      "longitude": 7.5666853,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Osterstraße 111, 20259 Hamburg",
      "latitude": 53.5756181,
      "longitude": 9.9527717,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Widayweg 2, 59823 Arnsberg",
      "latitude": 51.3962806,
      "longitude": 8.1349594,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schleussnerstraße 100b, 63263 Neu-Isenburg",
      "latitude": 50.0476745,
      "longitude": 8.6775978,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Westerwaldstraße 97, 56579 Rengsdorf",
      "latitude": 50.5108747,
      "longitude": 7.4840626,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Klaus-Conrad-Straße 1a, 92533 Wernberg-Köblitz",
      "latitude": 49.5328666,
      "longitude": 12.1372909,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Westring 7, 85614 Kirchseeon",
      "latitude": 48.0815441,
      "longitude": 11.8559008,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dörpfeldstraße 33-35, 12489 Berlin",
      "latitude": 52.4376269,
      "longitude": 13.5476772,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Marienplatz 11, 33098 Paderborn",
      "latitude": 51.7169391,
      "longitude": 8.7519694,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hagener Straße 26, 58642 Iserlohn",
      "latitude": 51.3652737,
      "longitude": 7.614514400000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lechhauser Straße 13, 86153 Augsburg",
      "latitude": 48.3720171,
      "longitude": 10.9101649,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Großer Burstah 18, 20457 Hamburg",
      "latitude": 53.5486745,
      "longitude": 9.990100499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Leopoldstraße 23, 80802 München",
      "latitude": 48.15771849999999,
      "longitude": 11.584379,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Speyerbach 4, 67433 Neustadt an der Weinstraße",
      "latitude": 49.35241000000001,
      "longitude": 8.160196,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lindenstraße 4, 53489 Sinzig",
      "latitude": 50.5451288,
      "longitude": 7.2573066,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Rübenacker 2, 41516 Grevenbroich",
      "latitude": 51.1329589,
      "longitude": 6.6166182,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Berger Straße 93-95, 60316 Frankfurt am Main",
      "latitude": 50.1226418,
      "longitude": 8.7003488,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hermann-Weinhauser-Straße 90, 81673 München",
      "latitude": 48.1328649,
      "longitude": 11.6318777,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Uerdinger Straße 103-107, 47799 Krefeld",
      "latitude": 51.3358611,
      "longitude": 6.578206499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hohenzollernring 58, 50672 Köln",
      "latitude": 50.9399277,
      "longitude": 6.9402364,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 44a, 17489 Greifswald",
      "latitude": 54.0918757,
      "longitude": 13.3732754,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Münchener Str. 27, 83022 Rosenheim",
      "latitude": 47.8531503,
      "longitude": 12.1222796,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hohe Strasse 73-75, 50667 Köln",
      "latitude": 50.93729829999999,
      "longitude": 6.9561341,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Fauerbacher Straße 12-14, 61169 Friedberg (Hessen)",
      "latitude": 50.3362419,
      "longitude": 8.7609613,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hindenburgstraße 73, 41061 Mönchengladbach",
      "latitude": 51.1952315,
      "longitude": 6.438903499999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Veerßer Straße 59, 29525 Uelzen",
      "latitude": 52.9607056,
      "longitude": 10.5573674,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Sonnenstraße 12, 80331 München",
      "latitude": 48.1369669,
      "longitude": 11.5642987,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Am Reuschenberger Markt 3, 41466 Neuss",
      "latitude": 51.1666064,
      "longitude": 6.6832709,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bismarckstraße 13, 25421 Pinneberg",
      "latitude": 53.6623564,
      "longitude": 9.795852799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Raiffeisenstraße 16, 63179 Obertshausen",
      "latitude": 50.0821219,
      "longitude": 8.872647299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Gerold-Janssen-Straße 2 A, 28359 Bremen",
      "latitude": 53.1028005,
      "longitude": 8.87938,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Leipziger Straße 5, 06108 Halle (Saale)",
      "latitude": 51.4820816,
      "longitude": 11.972063,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Wurzener Straße 1, 04668 Grimma",
      "latitude": 51.2391587,
      "longitude": 12.7299157,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrich-Ebert-Strasse 2, 48529 Nordhorn",
      "latitude": 52.4274826,
      "longitude": 7.0620322,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Engersche Straße 96, 33611 Bielefeld",
      "latitude": 52.0508197,
      "longitude": 8.5525358,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Prerower Platz 1, 13051 Berlin",
      "latitude": 52.5647089,
      "longitude": 13.5063883,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Holm 2-8, 24937 Flensburg",
      "latitude": 54.7862482,
      "longitude": 9.434088599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heddesdorfer Straße 11, 56564 Neuwied",
      "latitude": 50.4318538,
      "longitude": 7.4628285,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hainbuchenring 15, 82061 Neuried",
      "latitude": 48.0881057,
      "longitude": 11.4609231,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heerstraße 3 a, 49492 Westerkappeln",
      "latitude": 52.313883,
      "longitude": 7.8713494,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Reichenbacher Str. 53/55, 02827 Görlitz",
      "latitude": 51.1475444,
      "longitude": 14.9492225,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Medinghovener Str. 1, 53347 Alfter",
      "latitude": 50.7159403,
      "longitude": 7.0274606,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Olvenstedter Graseweg 37, 39128 Magdeburg",
      "latitude": 52.1601527,
      "longitude": 11.6041615,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Siemensdamm 43/44, 13629 Berlin",
      "latitude": 52.5362669,
      "longitude": 13.2751465,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Jahnstraße 10 a, 69509 Mörlenbach",
      "latitude": 49.5928249,
      "longitude": 8.732215799999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Mariannenpark 10, 41569 Rommerskirchen",
      "latitude": 51.0328354,
      "longitude": 6.694653,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Großstraße 15-17, 25813 Husum",
      "latitude": 54.47701,
      "longitude": 9.049859999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "In den Weingärten 80, 55276 Oppenheim",
      "latitude": 49.8467978,
      "longitude": 8.360801,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Hainstraße 21, 04109 Leipzig",
      "latitude": 51.3426218,
      "longitude": 12.372733,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwarzbachstraße 14, 40822 Mettmann",
      "latitude": 51.2517903,
      "longitude": 6.9786215,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Dammstr. 9, 14641 Nauen",
      "latitude": 52.609647,
      "longitude": 12.8802866,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrichstraße 15, 47798 Krefeld",
      "latitude": 51.3340887,
      "longitude": 6.5619874,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heegbarg 31, 22391 Hamburg",
      "latitude": 53.6543125,
      "longitude": 10.0907069,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Frankfurter Straße 51, 61197 Florstadt",
      "latitude": 50.3313867,
      "longitude": 8.937798299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Kalker Hauptstraße 114, 51103 Köln",
      "latitude": 50.937574,
      "longitude": 7.0016959,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Otto-Hahn-Straße 18, 68623 Lampertheim",
      "latitude": 49.5966767,
      "longitude": 8.4858342,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bodanstraße 1, 78462 Konstanz",
      "latitude": 47.6569379,
      "longitude": 9.176113299999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schlachthofstraße 33, 91541 Rothenburg ob der Tauber",
      "latitude": 49.37341929999999,
      "longitude": 10.1890422,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "St.Wendeler Straße 4, 66636 Tholey",
      "latitude": 49.4829275,
      "longitude": 7.038214099999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Erlenweg 6, 66706 Perl",
      "latitude": 49.5182949,
      "longitude": 6.375541,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Leopoldstraße 158, 80804 München",
      "latitude": 48.1706578,
      "longitude": 11.5864257,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Heinkelstraße 1, 71634 Ludwigsburg",
      "latitude": 48.9214963,
      "longitude": 9.1517178,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Friedrich-Karl-Straße 101, 50735 Köln",
      "latitude": 50.9744973,
      "longitude": 6.960375,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Nürnberger Platz 1, 01187 Dresden",
      "latitude": 51.0319357,
      "longitude": 13.7261547,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofplatz 7, 80335 München",
      "latitude": 48.140362,
      "longitude": 11.5618223,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schlesierweg 15, 38440 Wolfsburg",
      "latitude": 52.41443229999999,
      "longitude": 10.7497319,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Wilmersdorfer Straße 126/127, 10627 Berlin",
      "latitude": 52.5097783,
      "longitude": 13.3062594,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Göltzschtalstraße 45, 08209 Auerbach/Vogtland",
      "latitude": 50.501033,
      "longitude": 12.3974225,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Peter-Achnitz-Straße 4, 50129 Bergheim",
      "latitude": 50.9802381,
      "longitude": 6.6797854,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Koblenzer Straße 63, 53173 Bonn",
      "latitude": 50.683646,
      "longitude": 7.1560932,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Saline 5, 78628 Rottweil",
      "latitude": 48.14866910000001,
      "longitude": 8.639570599999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Zähringerplatz 9, 78464 Konstanz",
      "latitude": 47.672469,
      "longitude": 9.1831666,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofstraße 1, 48431 Rheine",
      "latitude": 52.27709,
      "longitude": 7.436272100000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Emil-Schwate-Straße 22, 84364 Bad Birnbach",
      "latitude": 48.43693349999999,
      "longitude": 13.0946193,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Raiffeisenstraße 3, 46499 Hamminkeln",
      "latitude": 51.7293409,
      "longitude": 6.590917999999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Pariser Bogen 5-7, 44269 Dortmund",
      "latitude": 51.5007599,
      "longitude": 7.5229317,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Neuhauser Straße 5, 80331 München",
      "latitude": 48.1381647,
      "longitude": 11.5708363,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Bahnhofsplatz 10+11, 79539 Lörrach",
      "latitude": 47.6142502,
      "longitude": 7.664145500000001,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Tonnaer Straße 36, 99947 Bad Langensalza",
      "latitude": 51.1045791,
      "longitude": 10.6583131,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Tübinger Straße 3e, 80686 München",
      "latitude": 48.133439,
      "longitude": 11.5243243,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Römerweg 57, 71083 Herrenberg",
      "latitude": 48.6114422,
      "longitude": 8.8511477,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lohgerbe 1, 79713 Bad Säckingen",
      "latitude": 47.5534006,
      "longitude": 7.946938399999999,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Schwartauer Landstraße 4, 23554 Lübeck",
      "latitude": 53.8875452,
      "longitude": 10.6865405,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Paul-Heilig-Straße 10, 88630 Pfullendorf",
      "latitude": 47.9254086,
      "longitude": 9.247569,
      "website": "www.dm.de"
  },
  {
      "name": "dm",
      "address": "Lämmersieth 23, 22305 Hamburg",
      "latitude": 53.5847704,
      "longitude": 10.0524827,
      "website": "www.dm.de"
  },
  {
      "name": "E center Jäckel",
      "address": "Provianthofstr. 3 , 01099 Dresden",
      "latitude": 51.08072170000001,
      "longitude": 13.758255,
      "website": "https://www.edeka.de/eh/nordbayern-sachsen-th%C3%BCringen/e-center-j%C3%A4ckel-provianthofstra%C3%9Fe-3/index.jsp"
  },
  {
      "name": "EDEKA Jäckel",
      "address": "Schandauerstrasse 74-82, 01277 Dresden",
      "latitude": 51.0395893,
      "longitude": 13.8049525,
      "website": "https://www.edeka.de/eh/nordbayern-sachsen-th%C3%BCringen/edeka-j%C3%A4ckel-schandauer-stra%C3%9Fe-74/index.jsp"
  },
  {
      "name": "EDEKA Starke",
      "address": "Dresdner Straße 18 , 01689 Weinböhla",
      "latitude": 51.1577352,
      "longitude": 13.5628669,
      "website": "https://www.edeka.de/eh/nordbayern-sachsen-th%C3%BCringen/edeka-starke-dresdner-stra%C3%9Fe-18/index.jsp"
  },
  {
      "name": "EDEKA Zellmer",
      "address": "Stieberstraße 55 / Husarenhof , 02625 Bautzen",
      "latitude": 51.1711629,
      "longitude": 14.4353137,
      "website": "https://www.edeka.de/eh/nordbayern-sachsen-th%C3%BCringen/edeka-zellmer-stieberstr.-55/index.jsp"
  },
  {
      "name": "EDEKA Glässer",
      "address": "Barbara-Uthmann-Ring 46 , 09456 Annaberg-Buchholz",
      "latitude": 50.59346379999999,
      "longitude": 13.0158163,
      "website": "https://www.edeka.de/eh/nordbayern-sachsen-th%C3%BCringen/edeka-gl%C3%A4sser-barbara-uthmann-ring-46/index.jsp"
  },
  {
      "name": "REWE",
      "address": "Zinnhütte 11-13, 21255 Tostedt",
      "latitude": 53.2696184,
      "longitude": 9.733060900000002,
      "website": "https://www.rewe.de/marktseite/tostedt/250203/rewe-markt-zinnhuette-11/"
  },
  {
      "name": "EDEKA Lars Janke",
      "address": "Hauptstraße 17, 21279 Hollenstedt",
      "latitude": 53.36635889999999,
      "longitude": 9.710650399999999,
      "website": "https://www.edeka.de/eh/nord/edeka-lars-janke-hauptstra%C3%9Fe-17/index.jsp"
  },
  {
      "name": "REWE",
      "address": "Harburger Straße 37 - 39, 21614 Buxtehude",
      "latitude": 53.4769143,
      "longitude": 9.709448499999999
  },
  {
      "name": "REWE Center",
      "address": "Konrad-Adenauer-Allee 3, 21614 Buxtehude",
      "latitude": 53.4706974,
      "longitude": 9.7145008,
      "website": "https://www.rewe.de/marktseite/buxtehude/541821/rewe-center-konrad-adenauer-allee-3/"
  },
  {
      "name": "REWE Burmeister",
      "address": "Beckdorfer Str. 16, 21641 Apensen",
      "latitude": 53.4303579,
      "longitude": 9.6117368,
      "website": "https://www.rewe.de/marktseite/apensen/565544/rewe-markt-beckdorfer-strasse-16/"
  },
  {
      "name": "REWE Boie",
      "address": "Paschberg 18, 21698 Harsefeld",
      "latitude": 53.45523919999999,
      "longitude": 9.5129557,
      "website": "https://www.rewe.de/marktseite/harsefeld/541801/rewe-markt-paschberg-18/"
  },
  {
      "name": "Schlemmer Markt Freund",
      "address": "Holtenauer Straße 70 - 72, 24105 Kiel",
      "latitude": 54.3325177,
      "longitude": 10.1327551,
      "website": "www.mein-schlemmerfreund.de"
  },
  {
      "name": "EDEKA Maron",
      "address": "Raiffeisenplatz 18, 25704 Meldorf",
      "latitude": 54.0912754,
      "longitude": 9.0785498,
      "website": "www.edeka-maron.de"
  },
  {
      "name": "REWE",
      "address": "Wunstorfer Straße 26, 30453 Hannover",
      "latitude": 52.3765192,
      "longitude": 9.6930521
  },
  {
      "name": "EDEKA Ramöller",
      "address": "Gerhart-Hauptmann-Straße 239 - 241, 32257 Bünde",
      "latitude": 52.2256893,
      "longitude": 8.5803307,
      "website": "https://www.edeka.de/eh/minden-hannover/edeka-ram%C3%B6ller-gerhard-hauptmann-str.-239-241/index.jsp"
  },
  {
      "name": "Rewe Goce Jandreoski",
      "address": "Osnarbrücker Landstraße 1, 33335 Gütersloh",
      "latitude": 51.9112841,
      "longitude": 8.425003199999999
  },
  {
      "name": "Rewe Scheifler",
      "address": "Beckhausstraße 64, 33611 Bielefeld",
      "latitude": 52.0384229,
      "longitude": 8.545293899999999
  },
  {
      "name": "Rewe Quermann ",
      "address": "Babenhauser Str. 20 , 33613 Bielefeld",
      "latitude": 52.0596038,
      "longitude": 8.5155044
  },
  {
      "name": "E Neukauf Brinkmann",
      "address": "Windelsbleicher Straße 229, 33659 Bielefeld",
      "latitude": 51.9598567,
      "longitude": 8.5207485
  },
  {
      "name": "Eins A Lebensmittelhandels GmbH & Co. KG ",
      "address": "Philipp-Reis-Str. 4-6 , 35410 Butzbach",
      "latitude": 50.43543,
      "longitude": 8.68379
  },
  {
      "name": "Rewe Stotko",
      "address": "Alter Weg 3, 35415 Pohlheim",
      "latitude": 50.538733,
      "longitude": 8.754598699999999
  },
  {
      "name": "Rewe Travaci",
      "address": "Am Lindenbaum 1, 35428 Langgöns",
      "latitude": 50.4927865,
      "longitude": 8.6564424
  },
  {
      "name": "Rewe Center Eins-A",
      "address": "Philipp-Reis-Str. 4, 35510 Butzbach",
      "latitude": 50.4356831,
      "longitude": 8.683729999999999
  },
  {
      "name": "Rewe Hammann",
      "address": "Artur-Herzog-Str. 1, 35580 Wetzlar",
      "latitude": 50.524884,
      "longitude": 8.489188
  },
  {
      "name": "Rewe Center Eins-A",
      "address": "Walbergraben 4, 35614 Aßlar",
      "latitude": 50.5843941,
      "longitude": 8.479222
  },
  {
      "name": "Rewe Travaci",
      "address": "Grasweg 10, 35625 Hüttenberg",
      "latitude": 50.51790159999999,
      "longitude": 8.6199984
  },
  {
      "name": "Edeka Göbel",
      "address": "Hohleichenrain 2, 35708 Haiger",
      "latitude": 50.7414518,
      "longitude": 8.2257888
  },
  {
      "name": "Rewe Ekrem Özdemir oHG",
      "address": "Mühlweg 6, 35789 Weilmünster",
      "latitude": 50.4300637,
      "longitude": 8.3773961
  },
  {
      "name": "Edeka Dörfer",
      "address": "Geßlerstraße 5 - 11, 44141 Dortmund",
      "latitude": 51.51116709999999,
      "longitude": 7.519497500000001
  },
  {
      "name": "Edeka-Team Jana Dörfer",
      "address": "Gesslerstraße 5, 44141 Dortmund",
      "latitude": 51.51116709999999,
      "longitude": 7.519497500000001
  },
  {
      "name": "Rewe Kuhlmey",
      "address": "Rathenaustraße 23, 44263 Dortmund",
      "latitude": 51.49841079999999,
      "longitude": 7.497885399999999
  },
  {
      "name": "Rewe Center Kuhlmey",
      "address": "Rathenaustr. 25 , 44263 Dortmund",
      "latitude": 51.4979344,
      "longitude": 7.4982328
  },
  {
      "name": "Edeka Schmitt",
      "address": "Heideweg 51, 44267 Dortmund",
      "latitude": 51.4455918,
      "longitude": 7.5238444
  },
  {
      "name": "Rewe Kaeseler",
      "address": "Provinzialstraße 387G, 44388 Dortmund",
      "latitude": 51.5194762,
      "longitude": 7.327061499999998
  },
  {
      "name": "Rewe Kaeseler ",
      "address": "Provinzialstr. 387G , 44388 Dortmund",
      "latitude": 51.5194762,
      "longitude": 7.327061499999998
  },
  {
      "name": "Edeka Peine",
      "address": "Rüttenscheider Straße 255, 45131 Essen",
      "latitude": 51.4263857,
      "longitude": 7.0026907
  },
  {
      "name": "Edeka Isselmarkt",
      "address": "Von-Bruchhausen-Straße 2 - 4, 45657 Recklinghausen",
      "latitude": 51.6115045,
      "longitude": 7.1896605
  },
  {
      "name": "Marktkauf Knödgen",
      "address": "Castroper Straße 124, 45665 Recklinghausen",
      "latitude": 51.6053287,
      "longitude": 7.2126411
  },
  {
      "name": "E-Center Zierles",
      "address": "Industriestraße 22, 45739 Oer",
      "latitude": 51.63899379999999,
      "longitude": 7.2776333
  },
  {
      "name": "Rewe Hennig",
      "address": "Hansaring 59 - 65, 48155 Münster",
      "latitude": 51.9543334,
      "longitude": 7.6437355
  },
  {
      "name": "Scheck In Center",
      "address": "Weberstraße 15, 55130 Mainz",
      "latitude": 49.9756918,
      "longitude": 8.288428999999999
  },
  {
      "name": "E-Center Lich",
      "address": "Am Giener 23, 55268 Nieder-Olm",
      "latitude": 49.91328129999999,
      "longitude": 8.1781129
  },
  {
      "name": "E-Center Eugen Lich KG ",
      "address": "Am Giener 23 , 55268 Nieder-Olm",
      "latitude": 49.91328129999999,
      "longitude": 8.1781129
  },
  {
      "name": "Edeka Westerhoff",
      "address": "Dortmunder Straße 1 - 3, 58099 Hagen",
      "latitude": 51.396591,
      "longitude": 7.468945700000001
  },
  {
      "name": "Edeka Elbers",
      "address": "Plettenberger Straße 10A, 59387 Ascheberg",
      "latitude": 51.8164679,
      "longitude": 7.5929309
  },
  {
      "name": "Rewe Engel",
      "address": "Massener Heilweg 4, 59427 Unna",
      "latitude": 51.53852990000001,
      "longitude": 7.653850299999998
  },
  {
      "name": "Rewe Silvia Engel ",
      "address": "Massener Hellweg 4 , 59427 Unna",
      "latitude": 51.53852990000001,
      "longitude": 7.653850299999998
  },
  {
      "name": "Edeka Weber",
      "address": "Neheimer Markt 2, 59755 Arnsberg",
      "latitude": 51.4535105,
      "longitude": 7.959592499999999
  },
  {
      "name": "Weber Lebensmittelmärkte Arnsberg  ",
      "address": "Neheimer Markt 2 , 59755 Arnsberg",
      "latitude": 51.4535105,
      "longitude": 7.959592499999999
  },
  {
      "name": "Edeka Boxberger",
      "address": "Mühlenweg 5, 59929 Brilon",
      "latitude": 51.3952007,
      "longitude": 8.558967899999999
  },
  {
      "name": "Edeka Scheck In",
      "address": "Ferdinand-Happ-Str. 59, 60314 Frankfurt",
      "latitude": 50.1145593,
      "longitude": 8.71533
  },
  {
      "name": "E Center Langanki",
      "address": "Borsigallee 26, 60388 Frankfurt",
      "latitude": 50.140602,
      "longitude": 8.7520773
  },
  {
      "name": "Scheck-in-Center",
      "address": "Hainer Weg 56-80, 60599 Frankfurt am Main",
      "latitude": 50.0970971,
      "longitude": 8.6934443
  },
  {
      "name": "Rewe Kimes",
      "address": "Am Lachengraben 1, 61206 Wöllstadt",
      "latitude": 50.2855056,
      "longitude": 8.7642693
  },
  {
      "name": "E-Center Stenger",
      "address": "Mühlheimer Str. 325, 63075 Offenbach",
      "latitude": 50.1105679,
      "longitude": 8.802386499999999
  },
  {
      "name": "Edeka Lauber GmbH ",
      "address": "Am Bruchweg 3, 63571 Gelnhausen",
      "latitude": 50.18239670000001,
      "longitude": 9.1343719
  },
  {
      "name": "Edeka Stenger",
      "address": "Lange Str. 13, 63741  Aschaffenburg",
      "latitude": 49.9816815,
      "longitude": 9.1444754
  },
  {
      "name": "Edeka Stenger",
      "address": "Aschaffenburger Str. 46, 63762 Großostheim",
      "latitude": 49.9268714,
      "longitude": 9.0811502
  },
  {
      "name": "Stenger Lebensmittel GmbH & Co. KG",
      "address": "Mainzer Straße 40, 63897 Miltenberg",
      "latitude": 49.7042338,
      "longitude": 9.2376969
  },
  {
      "name": "Edeka Haupter Markt",
      "address": "Pfungstädter Straße 3, 64579 Gernsheim",
      "latitude": 49.7586124,
      "longitude": 8.4855359
  },
  {
      "name": "E-Center Jakobi",
      "address": "Fabrikstr. 2, 64625 Bensheim",
      "latitude": 49.67655209999999,
      "longitude": 8.615527
  },
  {
      "name": "Edeka Winkler",
      "address": "In der Pfarrtanne 14, 64665 Alsbach-Hähnlein",
      "latitude": 49.74421599999999,
      "longitude": 8.6070897
  },
  {
      "name": "Edeka Roland Steiner",
      "address": "Erikastr. 5, 64668 Rimbach",
      "latitude": 49.6273573,
      "longitude": 8.7609981
  },
  {
      "name": "E Center Jakobi",
      "address": "Nibelungenstr. 447, 64686 Lautertal",
      "latitude": 49.7176033,
      "longitude": 8.714616999999999
  },
  {
      "name": "Rewe Klaus Scheider oHG ",
      "address": "Aarstraße 32 , 65195 Wiesbaden",
      "latitude": 50.0875875,
      "longitude": 8.2204011
  },
  {
      "name": "Edeka Nolte",
      "address": "Karlsbader Platz 2-28, 65197 Wiesbaden",
      "latitude": 50.0739562,
      "longitude": 8.223416199999999
  },
  {
      "name": "E-Center Haller",
      "address": "Flörsheimer Str. 2 , 65479 Raunheim",
      "latitude": 50.0079866,
      "longitude": 8.434138599999999
  },
  {
      "name": "Rewe Lukas Nonn oHG ",
      "address": "Mainzer Landstr. 11-14 , 65589 Hadamar",
      "latitude": 50.442889,
      "longitude": 8.042012099999999
  },
  {
      "name": "E- Center Jahke",
      "address": "Rathausring 6, 66877 Ramstein-Miesenbach",
      "latitude": 49.4499106,
      "longitude": 7.5545892
  },
  {
      "name": "E-Center Jahke",
      "address": "Rathausring 6 , 66877 Rammstein",
      "latitude": 49.4499106,
      "longitude": 7.5545892
  },
  {
      "name": "Rewe",
      "address": "Wegelnburgstr. 33, 67065 Ludwigshafen am Rhein",
      "latitude": 49.4577209,
      "longitude": 8.4311978
  },
  {
      "name": "Rewe",
      "address": "Weinstr. 95, 67157 Wachenheim",
      "latitude": 49.4441364,
      "longitude": 8.1778438
  },
  {
      "name": "Edeka Stiegler",
      "address": "Flotzring 33, 67227 Frankenthal",
      "latitude": 49.5379404,
      "longitude": 8.3600393
  },
  {
      "name": "Edeka Hauguth",
      "address": "Viehtriftstr. 110, 67354 Römerberg",
      "latitude": 49.2786076,
      "longitude": 8.405533199999999
  },
  {
      "name": "Rewe Bock oHG ",
      "address": "Im breiten Pfuhl 1, 67365 Schwegenheim",
      "latitude": 49.27116789999999,
      "longitude": 8.3375379
  },
  {
      "name": "Rewe",
      "address": "Dr.-Carl-Sonnenschein-Str. 3, 67550 Worms",
      "latitude": 49.6493727,
      "longitude": 8.3387356
  },
  {
      "name": "Rewe Mark Rankel oHG ",
      "address": "An der Brennerei 2 , 67593 Westhofen",
      "latitude": 49.7035385,
      "longitude": 8.255997599999999
  },
  {
      "name": "Scheck In Center",
      "address": "Friedrich-Ebert-Straße 100, 68167 Mannheim",
      "latitude": 49.50252760000001,
      "longitude": 8.499749699999999
  },
  {
      "name": "Marktkauf",
      "address": "Alte Seilerei 3 , 68199 Mannheim",
      "latitude": 49.45103049999999,
      "longitude": 8.4963236
  },
  {
      "name": "E aktiv markt Pietsch",
      "address": "Geraer Ring 6, 68309 Mannheim",
      "latitude": 49.510699,
      "longitude": 8.5387624
  },
  {
      "name": "Edeka Aktiv Markt Keller",
      "address": "Wallstadter Str. 53, 68526 Ladenburg",
      "latitude": 49.4766954,
      "longitude": 8.6055378
  },
  {
      "name": "Rewe Nicole Trautwein oHG ",
      "address": "Hauptstr. 103-107 , 68799 Reilingen",
      "latitude": 49.2929349,
      "longitude": 8.5699376
  },
  {
      "name": "Rewe Tarek Anbari oHG ",
      "address": "Am Sägewerk 1 , 68804 Altlußheim",
      "latitude": 49.2913128,
      "longitude": 8.5286597
  },
  {
      "name": "Scheck-In Center",
      "address": "Kurfürstenanlage 21-23, 69115 Heidelberg",
      "latitude": 49.4058855,
      "longitude": 8.686716299999999
  },
  {
      "name": "Scheck-In Center",
      "address": "Galileistr. 4, 69115 Heidelberg-Bahnstadt",
      "latitude": 49.4043552,
      "longitude": 8.6680958
  },
  {
      "name": "nah und gut Arlt",
      "address": "Wiesenbacher Str. 65-69, 69151 Neckargemünd",
      "latitude": 49.3865973,
      "longitude": 8.803429399999999
  },
  {
      "name": "Rewe",
      "address": "Karl-Landsteiern-Straße 2, 69151 Neckargemünd",
      "latitude": 49.38938539999999,
      "longitude": 8.7965869
  },
  {
      "name": "E aktiv markt Marx",
      "address": "Bahnhofstr. 34, 69190 Walldorf",
      "latitude": 49.2992934,
      "longitude": 8.645116
  },
  {
      "name": "nah und gut Arlt",
      "address": "Hauptstr. 14-16, 69234 Dielheim",
      "latitude": 49.2824113,
      "longitude": 8.737477199999999
  },
  {
      "name": "Edeka Aktiv Markt Arlt",
      "address": "Industriestr. 7, 69239 Neckarsteinach",
      "latitude": 49.3972087,
      "longitude": 8.8512095
  },
  {
      "name": "Rewe Achenbach oHG",
      "address": "Reilsheimer Str. 9, 69245  Bammental",
      "latitude": 49.3517114,
      "longitude": 8.777263
  },
  {
      "name": "Edeka Arlt",
      "address": "Greiner Str. 6, 69250 Schönau",
      "latitude": 49.4366155,
      "longitude": 8.8120684
  },
  {
      "name": "Edeka Brigitte Brand e.Kfr ",
      "address": "Bergstr. 97-99 , 69469 Weinheim",
      "latitude": 49.558162,
      "longitude": 8.6685787
  },
  {
      "name": "Edeka Bylitza",
      "address": "Hauptstr. 160b, 69488 Birkenau",
      "latitude": 49.56814139999999,
      "longitude": 8.7080828
  },
  {
      "name": "Edeka Baisch",
      "address": "Sophienstr. 21, 70178 Stuttgart",
      "latitude": 48.7722961,
      "longitude": 9.1724464
  },
  {
      "name": "Rewe Nuvoli",
      "address": "Sophie-Tschorn-Str. 4, 70374 Stuttgart",
      "latitude": 48.8176952,
      "longitude": 9.239679899999999
  },
  {
      "name": "Edeka Baisch",
      "address": "Hauptstr. 5, 70563 Stuttgart",
      "latitude": 48.7296203,
      "longitude": 9.111847899999999
  },
  {
      "name": "Edeka Fleck",
      "address": "Europaplatz 20, 70565 Stuttgart",
      "latitude": 48.71333720000001,
      "longitude": 9.1598706
  },
  {
      "name": "Rewe",
      "address": "Industriestr. 5, 70565 Stuttgart",
      "latitude": 48.7255281,
      "longitude": 9.115077399999999
  },
  {
      "name": "Rewe",
      "address": "Industriestraße 5, 70565 Stuttgart",
      "latitude": 48.7255281,
      "longitude": 9.115077399999999
  },
  {
      "name": "Edeka Bauer",
      "address": "Schemppstr. 81, 70619 Stuttgart",
      "latitude": 48.7395668,
      "longitude": 9.219242999999999
  },
  {
      "name": "Edeka Bauer",
      "address": "Neuer Markt 3 , 70771 Leinfelden-Echterdingen",
      "latitude": 48.6941867,
      "longitude": 9.1437904
  },
  {
      "name": "Edeka Matkovic",
      "address": "Hauptstr. 6, 70839 Gerlingen",
      "latitude": 48.8009529,
      "longitude": 9.061243900000001
  },
  {
      "name": "Rewe Hasenöhrl",
      "address": "Leonberger Str. 3-5, 71063 Sindelfingen",
      "latitude": 48.7134252,
      "longitude": 9.0002725
  },
  {
      "name": "Edeka Baisch",
      "address": "Tilsiter Str. 15, 71065 Sindelfingen",
      "latitude": 48.70438910000001,
      "longitude": 9.0315957
  },
  {
      "name": "Edeka Hacker",
      "address": "Hauptstr. 48, 71093 Weil im Schönbuch",
      "latitude": 48.6230517,
      "longitude": 9.0604508
  },
  {
      "name": "Edeka Hacker",
      "address": "Dätzinger Str. 51, 71120 Grafenau",
      "latitude": 48.7144831,
      "longitude": 8.9056309
  },
  {
      "name": "Rewe Bühler",
      "address": "Forchenweg 69, 71134 Aidlingen",
      "latitude": 48.6766144,
      "longitude": 8.8811994
  },
  {
      "name": "Edeka Baisch",
      "address": "Leonberger Str. 98, 71229 Leonberg",
      "latitude": 48.79470999999999,
      "longitude": 9.010854
  },
  {
      "name": "E Center Matkovic",
      "address": "Leonberger Str. 46 - 48, 71254 Ditzingen",
      "latitude": 48.8243922,
      "longitude": 9.0625312
  },
  {
      "name": "Edeka Baisch",
      "address": "Weissacher Str. 34, 71287 Weissach",
      "latitude": 48.8367605,
      "longitude": 8.913804299999999
  },
  {
      "name": "nah und gut Kübler",
      "address": "Mittelstraße 6, 71729 Erdmannhausen",
      "latitude": 48.9412589,
      "longitude": 9.2962394
  },
  {
      "name": "Edeka Koch",
      "address": "Im Grund 2, 72355 Schömberg",
      "latitude": 48.2033158,
      "longitude": 8.7594322
  },
  {
      "name": "Rewe Theiler",
      "address": "Seilerweg 2+4, 72574 Bad Urach",
      "latitude": 48.4898329,
      "longitude": 9.3995519
  },
  {
      "name": "Rewe Steinbeck",
      "address": "Föhrstr. 40, 72760 Reutlingen",
      "latitude": 48.5034111,
      "longitude": 9.210326199999999
  },
  {
      "name": "Edeka Staufers Markthalle",
      "address": "Stuttgarter Straße 67, 73033 Göppingen",
      "latitude": 48.7084012,
      "longitude": 9.6362665
  },
  {
      "name": "E Center Eislingen",
      "address": "Steinbeisstraße 10 - 12, 73054 Eislingen",
      "latitude": 48.6944508,
      "longitude": 9.686373
  },
  {
      "name": "Rewe Center",
      "address": "Göppinger Str. 7 , 73119 Zell unter Aichelberg",
      "latitude": 48.6525219,
      "longitude": 9.5728539
  },
  {
      "name": "Rewe Kubicki oHG ",
      "address": "Kirchheimer Str. 84 , 73235 Weilheim an der Teck",
      "latitude": 48.6221396,
      "longitude": 9.5288355
  },
  {
      "name": "E aktiv markt Seitz",
      "address": "Eutighoferstr. 59, 73525 Schwäbisch Gmünd",
      "latitude": 48.786376,
      "longitude": 9.7733817
  },
  {
      "name": "Rewe Mölders",
      "address": "Ledergasse 44, 73525 Schwäbisch Gmünd",
      "latitude": 48.8009439,
      "longitude": 9.7931674
  },
  {
      "name": "Edeka Alfred Seitz ",
      "address": "Eutighofer Straße 59 , 73525 Schwäbisch Gmünd",
      "latitude": 48.786376,
      "longitude": 9.7733817
  },
  {
      "name": "Edeka Donderer",
      "address": "Rudolf-Diesel-Str. 9, 73529 Schwäbisch Gmünd",
      "latitude": 48.7828022,
      "longitude": 9.8536798
  },
  {
      "name": "Rewe Fritz",
      "address": "Maierhofstr. 24, 73547 Lorch ",
      "latitude": 48.7977149,
      "longitude": 9.675711
  },
  {
      "name": "Capurso Remstal Markt KG ",
      "address": "Mittlere Uferstraße 5 , 73614 Schorndorf",
      "latitude": 48.8068801,
      "longitude": 9.517423299999999
  },
  {
      "name": "Edeka Daiber",
      "address": "Schorndorfer Str. 40, 73666 Baltmannsweiler",
      "latitude": 48.7517451,
      "longitude": 9.445057799999999
  },
  {
      "name": "Rewe",
      "address": "Ritterstr. 5, 73728 Esslingen",
      "latitude": 48.741153,
      "longitude": 9.3088672
  },
  {
      "name": "Rewe",
      "address": "Salinenstr. 35, 74523 Schwäbisch Hall",
      "latitude": 49.1214672,
      "longitude": 9.734579799999999
  },
  {
      "name": "Edeka Alexander Sommer e.K.",
      "address": "Elsenzstraße 1, 75031 Eppingen",
      "latitude": 49.1338518,
      "longitude": 8.9053553
  },
  {
      "name": "Scheck-In Center",
      "address": "Rüppurrer Straße 1, 76137 Karlsruhe",
      "latitude": 49.0054946,
      "longitude": 8.4120902
  },
  {
      "name": "Nahkauf Thomas Auerswald e.K.",
      "address": "Gellertstr. 33, 76185 Karlsruhe",
      "latitude": 49.0102894,
      "longitude": 8.3673305
  },
  {
      "name": "Scheck-In Center",
      "address": "Marstallstr. 18, 76227 Karlsruhe",
      "latitude": 48.9975794,
      "longitude": 8.472690199999999
  },
  {
      "name": "Edeka Kuhn",
      "address": "Brüsseler Ring 1, 76344 Eggenstein-Leopoldshafen",
      "latitude": 49.0943527,
      "longitude": 8.4071146
  },
  {
      "name": "Edeka Kuhn",
      "address": "Am Wall 7, 76351 Linkenheim",
      "latitude": 49.1301658,
      "longitude": 8.4176175
  },
  {
      "name": "Edeka Fitterer",
      "address": "Schneidergarten 2, 76467 Bietigheim",
      "latitude": 48.9016181,
      "longitude": 8.2503155
  },
  {
      "name": "Edeka Huck",
      "address": "Bietigheimer Str. 1, 76477  Elchesheim-Illingen",
      "latitude": 48.9249261,
      "longitude": 8.2639778
  },
  {
      "name": "Edeka Huck",
      "address": "Steinäcker 2, 76479 Steinmauern",
      "latitude": 48.893665,
      "longitude": 8.1960147
  },
  {
      "name": "Scheck In",
      "address": "Gewerbepark Cite 7, 76532 Baden-Baden",
      "latitude": 48.7821895,
      "longitude": 8.191105
  },
  {
      "name": "Marktkauf Wörth",
      "address": "Maximilianstraße 1, 76744 Wörth",
      "latitude": 49.0407594,
      "longitude": 8.2950388
  },
  {
      "name": "Edeka Johansen",
      "address": "Buchstr. 42, 76751 Jockgrim",
      "latitude": 49.0851207,
      "longitude": 8.264789
  },
  {
      "name": "Edeka Albrecht",
      "address": "St.-Christophorus Str. 1a, 76863 Herxheim",
      "latitude": 49.1377027,
      "longitude": 8.2172286
  },
  {
      "name": "Edeka Albrecht",
      "address": "Kapeller Str. 11, 76887 Bad Bergzabern",
      "latitude": 49.1023337,
      "longitude": 8.0046149
  },
  {
      "name": "aktiv markt Timm-Zinth ",
      "address": "Bertha-von-Suttner-Str. 4 , 77654 Offenburg",
      "latitude": 48.4810311,
      "longitude": 7.9576212
  },
  {
      "name": "E Center Offenburg",
      "address": "Wilhelm-Röntgen-Straße 1, 77656 Offenburg",
      "latitude": 48.47376089999999,
      "longitude": 7.924788699999999
  },
  {
      "name": "Edeka Kohler",
      "address": "Am Läger, 77694 Kehl",
      "latitude": 48.5753231,
      "longitude": 7.8131184
  },
  {
      "name": "Decker's Frische Center",
      "address": "Appenweierer Straße 42, 77704 Oberkirch",
      "latitude": 48.5338942,
      "longitude": 8.0708553
  },
  {
      "name": "Edeka Bruder",
      "address": "Hauptstraße 4, 77736 Zell am Harmersbach",
      "latitude": 48.3453083,
      "longitude": 8.0590374
  },
  {
      "name": "Edeka Oberle",
      "address": "Hindenburgstr. 3, 77746 Schutterwald",
      "latitude": 48.4548695,
      "longitude": 7.8951416
  },
  {
      "name": "Edeka Kohler",
      "address": "Alte Landstraße 1, 77749 Hohberg",
      "latitude": 48.4104032,
      "longitude": 7.8876681
  },
  {
      "name": "Edeka Falk",
      "address": "Hägenichstr. 4, 77833 Ottersweier",
      "latitude": 48.6724329,
      "longitude": 8.1168313
  },
  {
      "name": "Scheck-in-Center",
      "address": "Fautenbacher Straße 25, 77855 Achern",
      "latitude": 48.62817,
      "longitude": 8.0547032
  },
  {
      "name": "E-aktiv Markt Seifermann",
      "address": "Mozartstr. 1, 77871 Renchen",
      "latitude": 48.5920141,
      "longitude": 8.0187148
  },
  {
      "name": "Edeka Kohler",
      "address": "Alter Stadtbahnhof1, 77933 Lahr/Schwarzwald",
      "latitude": 48.3375116,
      "longitude": 7.8632037
  },
  {
      "name": "Edeka Kohler",
      "address": "Oberweierer Hauptstr. 79, 77948 Friesenheim",
      "latitude": 48.3744552,
      "longitude": 7.892539499999999
  },
  {
      "name": "Edeka Kohler",
      "address": "Otto-Stölcker-Str. 73, 77955 Ettenheim",
      "latitude": 48.2542746,
      "longitude": 7.822091
  },
  {
      "name": "Edeka Kohler",
      "address": "Am Bahndamm 9, 77960 Seelbach",
      "latitude": 48.3195105,
      "longitude": 7.93592
  },
  {
      "name": "Edeka Kohler",
      "address": "Allmannsweierer Hauptstraße 4, 77963 Schwanau",
      "latitude": 48.3661207,
      "longitude": 7.786858800000001
  },
  {
      "name": "Nahkauf Scholl",
      "address": "Villinger Str. 6, 78078 Niedereschach",
      "latitude": 48.1326702,
      "longitude": 8.5282657
  },
  {
      "name": "E aktiv markt Haas",
      "address": "Schulstr. 6, 78112 St. Georgen",
      "latitude": 48.1242355,
      "longitude": 8.3322656
  },
  {
      "name": "E-center",
      "address": "Unter den Tannen 3/B 34, 78224 Singen",
      "latitude": 47.7615574,
      "longitude": 8.8935648
  },
  {
      "name": "Aach Center",
      "address": "Bahnhofstraßé 10, 78333 Stockach",
      "latitude": 47.8508739,
      "longitude": 9.0065347
  },
  {
      "name": "Rewe",
      "address": "Kaiser-Joseph-Straße 165 , 79098 Freiburg im Breisgau",
      "latitude": 47.9967865,
      "longitude": 7.852826599999999
  },
  {
      "name": "E Center Freiburg",
      "address": "Lörracher Str. 8, 79115 Freiburg im Breisgau",
      "latitude": 47.9815243,
      "longitude": 7.824436400000001
  },
  {
      "name": "Rewe",
      "address": "Friedenstr. 27, 79189 Bad Krozingen",
      "latitude": 47.91925519999999,
      "longitude": 7.706857599999999
  },
  {
      "name": "E-Center",
      "address": "Gewerbestraße 23, 79194 Gundelfingen",
      "latitude": 48.0395282,
      "longitude": 7.859702700000001
  },
  {
      "name": "Edeka Kohler",
      "address": "Gansacker 2+4, 79224 Umkirch",
      "latitude": 48.0359309,
      "longitude": 7.7628803
  },
  {
      "name": "Rewe Borowicz oHG",
      "address": "Herrenweg/Schlossmattenweg 5, 79268 Bötzingen",
      "latitude": 48.0752304,
      "longitude": 7.713204900000001
  },
  {
      "name": "Rewe Center",
      "address": "Am Alten Markt 4, 79539 Lörrach",
      "latitude": 47.6106956,
      "longitude": 7.661790700000001
  },
  {
      "name": "Rewe Holy",
      "address": "Römerstr. 120, 89077 Ulm",
      "latitude": 48.3858974,
      "longitude": 9.9649111
  },
  {
      "name": "Marktkauf Nürnberg-Thon",
      "address": "Wilhelmshavener Str. 15, 90425 Nürnberg",
      "latitude": 49.4808686,
      "longitude": 11.063243
  },
  {
      "name": "Edeka Lebensmittelpunkt Schätz",
      "address": "Kurt-Triest-Straße 5 , 90441 Nürnberg",
      "latitude": 49.4317313,
      "longitude": 11.0442806
  },
  {
      "name": "Marktkauf GmbH 20135",
      "address": "Laufamholzstr. 40 - 42, 90482 Nürnberg-Mögeldorf",
      "latitude": 49.4616892,
      "longitude": 11.137263
  },
  {
      "name": "E-Center Nürnberg 685",
      "address": "Sulzbacher Str. 77 - 81, 90489 Nürnberg",
      "latitude": 49.45943459999999,
      "longitude": 11.0987051
  },
  {
      "name": "E-Center Pascal Bächmann e.k.",
      "address": "Neumühle 4, 91056 Erlangen",
      "latitude": 49.5879385,
      "longitude": 10.9771003
  },
  {
      "name": "E-Center Pascal Bächmann ",
      "address": "Neumühle 4 , 91056 Erlangen",
      "latitude": 49.5879385,
      "longitude": 10.9771003
  },
  {
      "name": "E-Center Bächmann ",
      "address": "Erlanger Str. 60 , 91074 Herzogenaurach",
      "latitude": 49.5657068,
      "longitude": 10.8967353
  },
  {
      "name": "Frischecenter Lauf",
      "address": "Hersbrucker Straße 62 , 91207 Lauf an der Pegnitz",
      "latitude": 49.515515,
      "longitude": 11.2899217
  },
  {
      "name": "E-Center Verena Dallheimer",
      "address": "Brauhausstr. 7 b , 91522 Ansbach",
      "latitude": 49.3047717,
      "longitude": 10.5744237
  },
  {
      "name": "E-Center Ammon",
      "address": "Luitpoldstr. 19 , 91550 Dinkelsbühl",
      "latitude": 49.06906920000001,
      "longitude": 10.3276602
  },
  {
      "name": "Edeka Markus Schiml e.K.",
      "address": "Altenstadter Straße 10, 92648 Vohenstrauß",
      "latitude": 49.62905790000001,
      "longitude": 12.338073
  },
  {
      "name": "E-Center Massak",
      "address": "Kirschäckerstr. 11 , 96052 Bamberg",
      "latitude": 49.9117277,
      "longitude": 10.9061962
  },
  {
      "name": "E-Center Lichtenfels ",
      "address": "Mainau 8, 96215 Lichtenfels",
      "latitude": 50.1495408,
      "longitude": 11.065831
  },
  {
      "name": "Marktkauf Schweinfurt-Hafen",
      "address": "Carl-Benz-Str. 7, 97424 Schweinfurt",
      "latitude": 50.0352104,
      "longitude": 10.2390153
  }
];